/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthenticatedTenantRouteImport } from './routes/_authenticated/_tenant'
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated/$'
import { Route as ConnectorTokenIndexRouteImport } from './routes/connector.$token.index'
import { Route as ConnectorTokenSelectRouteImport } from './routes/connector.$token.select'
import { Route as ConnectorTokenDoneRouteImport } from './routes/connector.$token.done'
import { Route as AuthProviderCallbackRouteImport } from './routes/auth/$provider/callback'
import { Route as AuthenticatedTenantTrialRouteImport } from './routes/_authenticated/_tenant/trial'
import { Route as AuthenticatedTenantSettingsRouteImport } from './routes/_authenticated/_tenant/settings'
import { Route as AuthenticatedTenantSchedulesRouteImport } from './routes/_authenticated/_tenant/schedules'
import { Route as AuthenticatedTenantProductNotEnrolledRouteImport } from './routes/_authenticated/_tenant/product-not-enrolled'
import { Route as AuthenticatedTenantOnboardingRouteImport } from './routes/_authenticated/_tenant/onboarding'
import { Route as AuthenticatedTenantNotificationRouteImport } from './routes/_authenticated/_tenant/notification'
import { Route as AuthenticatedTenantLilyAgentRouteImport } from './routes/_authenticated/_tenant/lily-agent'
import { Route as AuthenticatedTenantItemSetupRouteImport } from './routes/_authenticated/_tenant/item-setup'
import { Route as AuthenticatedTenantHomeRouteImport } from './routes/_authenticated/_tenant/home'
import { Route as AuthenticatedTenantHistoryRouteImport } from './routes/_authenticated/_tenant/history'
import { Route as AuthenticatedTenantDashboardRouteImport } from './routes/_authenticated/_tenant/dashboard'
import { Route as AuthenticatedTenantCoverageRouteImport } from './routes/_authenticated/_tenant/coverage'
import { Route as AuthenticatedTenantCostApprovalsRouteImport } from './routes/_authenticated/_tenant/cost-approvals'
import { Route as AuthenticatedTenantCatalogManagerRouteImport } from './routes/_authenticated/_tenant/catalog-manager'
import { Route as AuthenticatedTenantAccessDeniedRouteImport } from './routes/_authenticated/_tenant/access-denied'
import { Route as AuthenticatedTenantWorkflowRunsRouteRouteImport } from './routes/_authenticated/_tenant/workflow-runs/route'
import { Route as AuthenticatedTenantUploadDeliveryRouteRouteImport } from './routes/_authenticated/_tenant/upload-delivery/route'
import { Route as AuthenticatedTenantTaxonomyRouteRouteImport } from './routes/_authenticated/_tenant/taxonomy/route'
import { Route as AuthenticatedTenantSubsidiaryRouteRouteImport } from './routes/_authenticated/_tenant/subsidiary/route'
import { Route as AuthenticatedTenantPlatformRouteRouteImport } from './routes/_authenticated/_tenant/platform/route'
import { Route as AuthenticatedTenantIntegrationsRouteRouteImport } from './routes/_authenticated/_tenant/integrations/route'
import { Route as AuthenticatedTenantFeedAuditRouteRouteImport } from './routes/_authenticated/_tenant/feed-audit/route'
import { Route as AuthenticatedTenantExplorerRouteRouteImport } from './routes/_authenticated/_tenant/explorer/route'
import { Route as AuthenticatedTenantDeliveriesRouteRouteImport } from './routes/_authenticated/_tenant/deliveries/route'
import { Route as AuthenticatedTenantContentRouteRouteImport } from './routes/_authenticated/_tenant/content/route'
import { Route as AuthenticatedTenantConfigurationRouteRouteImport } from './routes/_authenticated/_tenant/configuration/route'
import { Route as AuthenticatedTenantCatalogV2RouteRouteImport } from './routes/_authenticated/_tenant/catalog-v2/route'
import { Route as AuthenticatedTenantCatalogEnrichmentRouteRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/route'
import { Route as AuthenticatedTenantAiPerformanceRouteRouteImport } from './routes/_authenticated/_tenant/ai-performance/route'
import { Route as AuthenticatedTenantWorkflowRunsIndexRouteImport } from './routes/_authenticated/_tenant/workflow-runs/index'
import { Route as AuthenticatedTenantTaxonomyIndexRouteImport } from './routes/_authenticated/_tenant/taxonomy/index'
import { Route as AuthenticatedTenantSubsidiaryIndexRouteImport } from './routes/_authenticated/_tenant/subsidiary/index'
import { Route as AuthenticatedTenantSubsidiaryPreferencesIndexRouteImport } from './routes/_authenticated/_tenant/subsidiary-preferences/index'
import { Route as AuthenticatedTenantProductCatalogIndexRouteImport } from './routes/_authenticated/_tenant/product-catalog/index'
import { Route as AuthenticatedTenantPlatformIndexRouteImport } from './routes/_authenticated/_tenant/platform/index'
import { Route as AuthenticatedTenantOnboardingIndexRouteImport } from './routes/_authenticated/_tenant/onboarding/index'
import { Route as AuthenticatedTenantItemSetupIndexRouteImport } from './routes/_authenticated/_tenant/item-setup/index'
import { Route as AuthenticatedTenantIntegrationsIndexRouteImport } from './routes/_authenticated/_tenant/integrations/index'
import { Route as AuthenticatedTenantFeedAuditIndexRouteImport } from './routes/_authenticated/_tenant/feed-audit/index'
import { Route as AuthenticatedTenantExplorerIndexRouteImport } from './routes/_authenticated/_tenant/explorer/index'
import { Route as AuthenticatedTenantExperimentsIndexRouteImport } from './routes/_authenticated/_tenant/experiments/index'
import { Route as AuthenticatedTenantDeliveriesIndexRouteImport } from './routes/_authenticated/_tenant/deliveries/index'
import { Route as AuthenticatedTenantContentIndexRouteImport } from './routes/_authenticated/_tenant/content/index'
import { Route as AuthenticatedTenantConfigurationIndexRouteImport } from './routes/_authenticated/_tenant/configuration/index'
import { Route as AuthenticatedTenantCatalogV2IndexRouteImport } from './routes/_authenticated/_tenant/catalog-v2/index'
import { Route as AuthenticatedTenantCatalogOperationsIndexRouteImport } from './routes/_authenticated/_tenant/catalog-operations/index'
import { Route as AuthenticatedTenantCatalogEnrichmentIndexRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/index'
import { Route as AuthenticatedTenantAiPerformanceIndexRouteImport } from './routes/_authenticated/_tenant/ai-performance/index'
import { Route as PublicOauthGoogleAdsCallbackRouteImport } from './routes/public.oauth.google-ads.callback'
import { Route as AuthenticatedTenantWorkflowRunsRunIdRouteImport } from './routes/_authenticated/_tenant/workflow-runs/$runId'
import { Route as AuthenticatedTenantUploadDeliverySingleRouteImport } from './routes/_authenticated/_tenant/upload-delivery/single'
import { Route as AuthenticatedTenantTrialPlatformRouteImport } from './routes/_authenticated/_tenant/trial/$platform'
import { Route as AuthenticatedTenantTaxonomyVersionsRouteImport } from './routes/_authenticated/_tenant/taxonomy/versions'
import { Route as AuthenticatedTenantTaxonomyUploadsRouteImport } from './routes/_authenticated/_tenant/taxonomy/uploads'
import { Route as AuthenticatedTenantTaxonomyProductsRouteImport } from './routes/_authenticated/_tenant/taxonomy/products'
import { Route as AuthenticatedTenantTaxonomyAttributesRouteImport } from './routes/_authenticated/_tenant/taxonomy/attributes'
import { Route as AuthenticatedTenantSubsidiaryUsersRouteImport } from './routes/_authenticated/_tenant/subsidiary/users'
import { Route as AuthenticatedTenantSubsidiarySyncScheduleRouteImport } from './routes/_authenticated/_tenant/subsidiary/sync-schedule'
import { Route as AuthenticatedTenantSubsidiarySubsidiariesRouteImport } from './routes/_authenticated/_tenant/subsidiary/subsidiaries'
import { Route as AuthenticatedTenantSubsidiarySsoRouteImport } from './routes/_authenticated/_tenant/subsidiary/sso'
import { Route as AuthenticatedTenantSubsidiaryScreenAccessRouteImport } from './routes/_authenticated/_tenant/subsidiary/screen-access'
import { Route as AuthenticatedTenantSubsidiaryRolesRouteImport } from './routes/_authenticated/_tenant/subsidiary/roles'
import { Route as AuthenticatedTenantSubsidiaryProductsRouteImport } from './routes/_authenticated/_tenant/subsidiary/products'
import { Route as AuthenticatedTenantSubsidiaryDataSharingRouteImport } from './routes/_authenticated/_tenant/subsidiary/data-sharing'
import { Route as AuthenticatedTenantSubsidiaryAssetAccessRouteImport } from './routes/_authenticated/_tenant/subsidiary/asset-access'
import { Route as AuthenticatedTenantSubsidiaryAccessPolicyRouteImport } from './routes/_authenticated/_tenant/subsidiary/access-policy'
import { Route as AuthenticatedTenantSubsidiaryAccessControlRouteImport } from './routes/_authenticated/_tenant/subsidiary/access-control'
import { Route as AuthenticatedTenantSubsidiaryPreferencesConstraintsRouteImport } from './routes/_authenticated/_tenant/subsidiary-preferences/constraints'
import { Route as AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRouteImport } from './routes/_authenticated/_tenant/subsidiary-preferences/brand-preferences'
import { Route as AuthenticatedTenantSettingsNotificationRouteImport } from './routes/_authenticated/_tenant/settings_.notification'
import { Route as AuthenticatedTenantPlatformUsersRouteImport } from './routes/_authenticated/_tenant/platform/users'
import { Route as AuthenticatedTenantPlatformSubsidiariesRouteImport } from './routes/_authenticated/_tenant/platform/subsidiaries'
import { Route as AuthenticatedTenantPlatformScreensRouteImport } from './routes/_authenticated/_tenant/platform/screens'
import { Route as AuthenticatedTenantPlatformSchedulesRouteImport } from './routes/_authenticated/_tenant/platform/schedules'
import { Route as AuthenticatedTenantPlatformResourcesRouteImport } from './routes/_authenticated/_tenant/platform/resources'
import { Route as AuthenticatedTenantPlatformProductsRouteImport } from './routes/_authenticated/_tenant/platform/products'
import { Route as AuthenticatedTenantPlatformPermissionsRouteImport } from './routes/_authenticated/_tenant/platform/permissions'
import { Route as AuthenticatedTenantPlatformFeatureFlagsRouteImport } from './routes/_authenticated/_tenant/platform/feature-flags'
import { Route as AuthenticatedTenantPlatformEnrichmentLimitRouteImport } from './routes/_authenticated/_tenant/platform/enrichment-limit'
import { Route as AuthenticatedTenantPlatformDataManagementRouteImport } from './routes/_authenticated/_tenant/platform/data-management'
import { Route as AuthenticatedTenantPlatformCoverageRouteImport } from './routes/_authenticated/_tenant/platform/coverage'
import { Route as AuthenticatedTenantPlatformCostApprovalRouteImport } from './routes/_authenticated/_tenant/platform/cost-approval'
import { Route as AuthenticatedTenantPlatformConnectorsRouteImport } from './routes/_authenticated/_tenant/platform/connectors'
import { Route as AuthenticatedTenantPlatformBatchReviewRouteImport } from './routes/_authenticated/_tenant/platform/batch-review'
import { Route as AuthenticatedTenantPlatformAuditLogsRouteImport } from './routes/_authenticated/_tenant/platform/audit-logs'
import { Route as AuthenticatedTenantPipelinesPipelineIdRouteImport } from './routes/_authenticated/_tenant/pipelines/$pipelineId'
import { Route as AuthenticatedTenantPipelineRunsRunIdRouteImport } from './routes/_authenticated/_tenant/pipeline-runs/$runId'
import { Route as AuthenticatedTenantOnboardingProductOverviewRouteImport } from './routes/_authenticated/_tenant/onboarding/product-overview'
import { Route as AuthenticatedTenantOnboardingPaidAdsRouteImport } from './routes/_authenticated/_tenant/onboarding/paid-ads'
import { Route as AuthenticatedTenantOnboardingOnsiteRouteImport } from './routes/_authenticated/_tenant/onboarding/onsite'
import { Route as AuthenticatedTenantOnboardingCompleteImportRouteImport } from './routes/_authenticated/_tenant/onboarding/complete-import'
import { Route as AuthenticatedTenantItemSetupVerifyRouteImport } from './routes/_authenticated/_tenant/item-setup/verify'
import { Route as AuthenticatedTenantItemSetupTaxonomyReviewRouteImport } from './routes/_authenticated/_tenant/item-setup/taxonomy-review'
import { Route as AuthenticatedTenantItemSetupTaxonomyRouteImport } from './routes/_authenticated/_tenant/item-setup/taxonomy'
import { Route as AuthenticatedTenantItemSetupSourcePriorityRouteImport } from './routes/_authenticated/_tenant/item-setup/source-priority'
import { Route as AuthenticatedTenantItemSetupShopifyConfirmRouteImport } from './routes/_authenticated/_tenant/item-setup/shopify-confirm'
import { Route as AuthenticatedTenantItemSetupShopifyRouteImport } from './routes/_authenticated/_tenant/item-setup/shopify'
import { Route as AuthenticatedTenantItemSetupSftpRouteImport } from './routes/_authenticated/_tenant/item-setup/sftp'
import { Route as AuthenticatedTenantItemSetupQualityReportRouteImport } from './routes/_authenticated/_tenant/item-setup/quality-report'
import { Route as AuthenticatedTenantItemSetupPatternInspectorRouteImport } from './routes/_authenticated/_tenant/item-setup/pattern-inspector'
import { Route as AuthenticatedTenantItemSetupOutputFormatRouteImport } from './routes/_authenticated/_tenant/item-setup/output-format'
import { Route as AuthenticatedTenantItemSetupFullCatalogGenerationRouteImport } from './routes/_authenticated/_tenant/item-setup/full-catalog-generation'
import { Route as AuthenticatedTenantItemSetupFilePreviewRouteImport } from './routes/_authenticated/_tenant/item-setup/file-preview'
import { Route as AuthenticatedTenantItemSetupEnrichmentOverviewRouteImport } from './routes/_authenticated/_tenant/item-setup/enrichment-overview'
import { Route as AuthenticatedTenantItemSetupContentGenerationRouteImport } from './routes/_authenticated/_tenant/item-setup/content-generation'
import { Route as AuthenticatedTenantItemSetupClientVerificationRouteImport } from './routes/_authenticated/_tenant/item-setup/client-verification'
import { Route as AuthenticatedTenantItemSetupCatalogReviewRouteImport } from './routes/_authenticated/_tenant/item-setup/catalog-review'
import { Route as AuthenticatedTenantItemSetupCalibrationScopeRouteImport } from './routes/_authenticated/_tenant/item-setup/calibration-scope'
import { Route as AuthenticatedTenantIntegrationsSharingRouteImport } from './routes/_authenticated/_tenant/integrations_.sharing'
import { Route as AuthenticatedTenantIntegrationsSchedulesRouteImport } from './routes/_authenticated/_tenant/integrations/schedules'
import { Route as AuthenticatedTenantIntegrationsProductsRouteImport } from './routes/_authenticated/_tenant/integrations/products'
import { Route as AuthenticatedTenantIntegrationsKeywordPlannerRouteImport } from './routes/_authenticated/_tenant/integrations/keyword-planner'
import { Route as AuthenticatedTenantIntegrationsHealthRouteImport } from './routes/_authenticated/_tenant/integrations/health'
import { Route as AuthenticatedTenantIntegrationsDatalakeRouteImport } from './routes/_authenticated/_tenant/integrations/datalake'
import { Route as AuthenticatedTenantIntegrationsCoverageRouteImport } from './routes/_authenticated/_tenant/integrations/coverage'
import { Route as AuthenticatedTenantIntegrationsConnectorsRouteImport } from './routes/_authenticated/_tenant/integrations/connectors'
import { Route as AuthenticatedTenantIntegrationsClickhouseRouteImport } from './routes/_authenticated/_tenant/integrations/clickhouse'
import { Route as AuthenticatedTenantIntegrationsCatalogImagesRouteImport } from './routes/_authenticated/_tenant/integrations/catalog-images'
import { Route as AuthenticatedTenantFeedAuditUploadRouteImport } from './routes/_authenticated/_tenant/feed-audit/upload'
import { Route as AuthenticatedTenantFeedAuditCreateRouteImport } from './routes/_authenticated/_tenant/feed-audit/create'
import { Route as AuthenticatedTenantFeedAuditIdRouteImport } from './routes/_authenticated/_tenant/feed-audit/$id'
import { Route as AuthenticatedTenantExportsSourceWorkflowIdRouteImport } from './routes/_authenticated/_tenant/exports/$sourceWorkflowId'
import { Route as AuthenticatedTenantExplorerProductsRouteImport } from './routes/_authenticated/_tenant/explorer/products'
import { Route as AuthenticatedTenantExplorerKeywordPlannerRouteImport } from './routes/_authenticated/_tenant/explorer/keyword-planner'
import { Route as AuthenticatedTenantExplorerDatalakeRouteImport } from './routes/_authenticated/_tenant/explorer/datalake'
import { Route as AuthenticatedTenantExplorerCoverageRouteImport } from './routes/_authenticated/_tenant/explorer/coverage'
import { Route as AuthenticatedTenantExplorerClickhouseRouteImport } from './routes/_authenticated/_tenant/explorer/clickhouse'
import { Route as AuthenticatedTenantExplorerCatalogImagesRouteImport } from './routes/_authenticated/_tenant/explorer/catalog-images'
import { Route as AuthenticatedTenantExperimentsCreateRouteImport } from './routes/_authenticated/_tenant/experiments_.create'
import { Route as AuthenticatedTenantExperimentsIdRouteImport } from './routes/_authenticated/_tenant/experiments/$id'
import { Route as AuthenticatedTenantEnrichmentsMetaRouteImport } from './routes/_authenticated/_tenant/enrichments/meta'
import { Route as AuthenticatedTenantEnrichmentsGoogleRouteImport } from './routes/_authenticated/_tenant/enrichments/google'
import { Route as AuthenticatedTenantDeliveriesNewRouteImport } from './routes/_authenticated/_tenant/deliveries/new'
import { Route as AuthenticatedTenantDeliveriesRunIdRouteImport } from './routes/_authenticated/_tenant/deliveries/$runId'
import { Route as AuthenticatedTenantCostApprovalsWorkflowIdRouteImport } from './routes/_authenticated/_tenant/cost-approvals_.$workflowId'
import { Route as AuthenticatedTenantContentReviewRouteImport } from './routes/_authenticated/_tenant/content/review'
import { Route as AuthenticatedTenantContentPromptsRouteImport } from './routes/_authenticated/_tenant/content/prompts'
import { Route as AuthenticatedTenantContentOverviewRouteImport } from './routes/_authenticated/_tenant/content/overview'
import { Route as AuthenticatedTenantContentModelConfigurationRouteImport } from './routes/_authenticated/_tenant/content/model-configuration'
import { Route as AuthenticatedTenantContentJobsRouteImport } from './routes/_authenticated/_tenant/content/jobs'
import { Route as AuthenticatedTenantContentAttributionRouteImport } from './routes/_authenticated/_tenant/content/attribution'
import { Route as AuthenticatedTenantConfigurationTreatmentRouteImport } from './routes/_authenticated/_tenant/configuration/treatment'
import { Route as AuthenticatedTenantConfigurationPromptsRouteImport } from './routes/_authenticated/_tenant/configuration/prompts'
import { Route as AuthenticatedTenantConfigurationManagerRouteImport } from './routes/_authenticated/_tenant/configuration/manager'
import { Route as AuthenticatedTenantConfigurationLilyTaxonomyRouteImport } from './routes/_authenticated/_tenant/configuration/lily-taxonomy'
import { Route as AuthenticatedTenantConfigurationGpcCategoriesRouteImport } from './routes/_authenticated/_tenant/configuration/gpc-categories'
import { Route as AuthenticatedTenantConfigurationFpcCategoriesRouteImport } from './routes/_authenticated/_tenant/configuration/fpc-categories'
import { Route as AuthenticatedTenantConfigurationDashboardRouteImport } from './routes/_authenticated/_tenant/configuration/dashboard'
import { Route as AuthenticatedTenantCatalogV2SchedulesRouteImport } from './routes/_authenticated/_tenant/catalog-v2/schedules'
import { Route as AuthenticatedTenantCatalogV2NeedsAttentionRouteImport } from './routes/_authenticated/_tenant/catalog-v2/needs-attention'
import { Route as AuthenticatedTenantCatalogV2CostApprovalsRouteImport } from './routes/_authenticated/_tenant/catalog-v2/cost-approvals'
import { Route as AuthenticatedTenantCatalogOperationsProductsNeedAttentionRouteImport } from './routes/_authenticated/_tenant/catalog-operations/products-need-attention'
import { Route as AuthenticatedTenantCatalogOperationsBatchIdRouteImport } from './routes/_authenticated/_tenant/catalog-operations/$batchId'
import { Route as AuthenticatedTenantCatalogEnrichmentNeedsAttentionRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/needs-attention'
import { Route as AuthenticatedTenantCatalogEnrichmentCostApprovalsRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/cost-approvals'
import { Route as AuthenticatedTenantAiPerformanceWorkflowIdRouteImport } from './routes/_authenticated/_tenant/ai-performance/$workflowId'
import { Route as AuthenticatedTenantPlatformServiceAuthRouteRouteImport } from './routes/_authenticated/_tenant/platform/service-auth/route'
import { Route as AuthenticatedTenantPlatformTransformersIndexRouteImport } from './routes/_authenticated/_tenant/platform/transformers/index'
import { Route as AuthenticatedTenantPlatformSubsidiariesIndexRouteImport } from './routes/_authenticated/_tenant/platform/subsidiaries/index'
import { Route as AuthenticatedTenantPlatformServiceAuthIndexRouteImport } from './routes/_authenticated/_tenant/platform/service-auth/index'
import { Route as AuthenticatedTenantIntegrationsUploadDeliveryIndexRouteImport } from './routes/_authenticated/_tenant/integrations/upload-delivery/index'
import { Route as AuthenticatedTenantIntegrationsPipelinesIndexRouteImport } from './routes/_authenticated/_tenant/integrations/pipelines/index'
import { Route as AuthenticatedTenantIntegrationsDataQualityIndexRouteImport } from './routes/_authenticated/_tenant/integrations/data-quality/index'
import { Route as AuthenticatedTenantIntegrationsConnectionsIndexRouteImport } from './routes/_authenticated/_tenant/integrations/connections.index'
import { Route as AuthenticatedTenantExportsCatalogIndexRouteImport } from './routes/_authenticated/_tenant/exports/catalog/index'
import { Route as AuthenticatedTenantExplorerDataQualityIndexRouteImport } from './routes/_authenticated/_tenant/explorer/data-quality/index'
import { Route as AuthenticatedTenantExperimentsCreateIndexRouteImport } from './routes/_authenticated/_tenant/experiments_.create/index'
import { Route as AuthenticatedTenantContentRunsIndexRouteImport } from './routes/_authenticated/_tenant/content/runs/index'
import { Route as AuthenticatedTenantContentQcIndexRouteImport } from './routes/_authenticated/_tenant/content/qc/index'
import { Route as AuthenticatedTenantConfigurationManagerIndexRouteImport } from './routes/_authenticated/_tenant/configuration/manager/index'
import { Route as AuthenticatedTenantCatalogV2RunsIndexRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/index'
import { Route as AuthenticatedTenantCatalogV2ProductsIndexRouteImport } from './routes/_authenticated/_tenant/catalog-v2/products/index'
import { Route as AuthenticatedTenantCatalogV2FeedAuditIndexRouteImport } from './routes/_authenticated/_tenant/catalog-v2/feed-audit/index'
import { Route as AuthenticatedTenantCatalogV2ExperimentsIndexRouteImport } from './routes/_authenticated/_tenant/catalog-v2/experiments/index'
import { Route as AuthenticatedTenantCatalogEnrichmentSchedulesIndexRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/schedules/index'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsIndexRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/index'
import { Route as AuthenticatedTenantCatalogEnrichmentProductsIndexRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/products/index'
import { Route as AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/feed-audit/index'
import { Route as AuthenticatedTenantCatalogEnrichmentExperimentsIndexRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/experiments/index'
import { Route as AuthenticatedTenantTrialPlatformEnrichmentRouteImport } from './routes/_authenticated/_tenant/trial/$platform/enrichment'
import { Route as AuthenticatedTenantTrialPlatformCreateRouteImport } from './routes/_authenticated/_tenant/trial/$platform/create'
import { Route as AuthenticatedTenantPlatformTransformersTransformerIdRouteImport } from './routes/_authenticated/_tenant/platform/transformers/$transformerId'
import { Route as AuthenticatedTenantPlatformSubsidiariesOnboardingRouteImport } from './routes/_authenticated/_tenant/platform/subsidiaries/onboarding'
import { Route as AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteImport } from './routes/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId'
import { Route as AuthenticatedTenantPlatformServiceAuthDiscoveryRouteImport } from './routes/_authenticated/_tenant/platform/service-auth/discovery'
import { Route as AuthenticatedTenantPlatformServiceAuthAuditRouteImport } from './routes/_authenticated/_tenant/platform/service-auth/audit'
import { Route as AuthenticatedTenantOnboardingIntegrationMetaRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/meta'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google'
import { Route as AuthenticatedTenantOauthGoogleAdsCallbackRouteImport } from './routes/_authenticated/_tenant/oauth.google-ads.callback'
import { Route as AuthenticatedTenantIntegrationsDatalakeUploadRouteImport } from './routes/_authenticated/_tenant/integrations/datalake_.upload'
import { Route as AuthenticatedTenantIntegrationsDataQualityCompareRouteImport } from './routes/_authenticated/_tenant/integrations/data-quality/compare'
import { Route as AuthenticatedTenantIntegrationsConnectionsNewRouteImport } from './routes/_authenticated/_tenant/integrations/connections.new'
import { Route as AuthenticatedTenantExportsCatalogNewRouteImport } from './routes/_authenticated/_tenant/exports/catalog/new'
import { Route as AuthenticatedTenantExplorerDatalakeUploadRouteImport } from './routes/_authenticated/_tenant/explorer/datalake_.upload'
import { Route as AuthenticatedTenantExplorerDataQualityCompareRouteImport } from './routes/_authenticated/_tenant/explorer/data-quality/compare'
import { Route as AuthenticatedTenantExperimentsCreateInfoRouteImport } from './routes/_authenticated/_tenant/experiments_.create/info'
import { Route as AuthenticatedTenantExperimentsCreateConfigureRouteImport } from './routes/_authenticated/_tenant/experiments_.create/configure'
import { Route as AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteImport } from './routes/_authenticated/_tenant/experiments_.$expId.content-enrichment'
import { Route as AuthenticatedTenantEnrichmentsMetaProductSelectionRouteImport } from './routes/_authenticated/_tenant/enrichments/meta/product-selection'
import { Route as AuthenticatedTenantEnrichmentsGoogleProductSelectionRouteImport } from './routes/_authenticated/_tenant/enrichments/google/product-selection'
import { Route as AuthenticatedTenantDeliveriesConnectionsConnectionIdRouteImport } from './routes/_authenticated/_tenant/deliveries/connections.$connectionId'
import { Route as AuthenticatedTenantContentQcNewRouteImport } from './routes/_authenticated/_tenant/content_.qc.new'
import { Route as AuthenticatedTenantContentQcRunIdRouteImport } from './routes/_authenticated/_tenant/content_.qc.$runId'
import { Route as AuthenticatedTenantContentCatalogNewRouteImport } from './routes/_authenticated/_tenant/content_.catalog.new'
import { Route as AuthenticatedTenantContentCatalogJobIdRouteImport } from './routes/_authenticated/_tenant/content_.catalog.$jobId'
import { Route as AuthenticatedTenantContentSettingsVocabularyRouteImport } from './routes/_authenticated/_tenant/content/settings/vocabulary'
import { Route as AuthenticatedTenantContentSettingsModelsRouteImport } from './routes/_authenticated/_tenant/content/settings/models'
import { Route as AuthenticatedTenantContentSettingsInstructionsRouteImport } from './routes/_authenticated/_tenant/content/settings/instructions'
import { Route as AuthenticatedTenantContentRunsHowItWorksRouteImport } from './routes/_authenticated/_tenant/content/runs/how-it-works'
import { Route as AuthenticatedTenantContentRunsRunIdRouteImport } from './routes/_authenticated/_tenant/content/runs/$runId'
import { Route as AuthenticatedTenantContentJobsHowItWorksRouteImport } from './routes/_authenticated/_tenant/content/jobs_.how-it-works'
import { Route as AuthenticatedTenantConfigurationManagerParametersRouteImport } from './routes/_authenticated/_tenant/configuration/manager/parameters'
import { Route as AuthenticatedTenantConfigurationManagerAuditTrailRouteImport } from './routes/_authenticated/_tenant/configuration/manager/audit-trail'
import { Route as AuthenticatedTenantCatalogV2RunsNewRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/new'
import { Route as AuthenticatedTenantCatalogV2ProductsProductIdRouteImport } from './routes/_authenticated/_tenant/catalog-v2/products/$productId'
import { Route as AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRouteImport } from './routes/_authenticated/_tenant/catalog-v2/feed-products/$feedProductId'
import { Route as AuthenticatedTenantCatalogV2FeedAuditNewRouteImport } from './routes/_authenticated/_tenant/catalog-v2/feed-audit/new'
import { Route as AuthenticatedTenantCatalogV2ExperimentsNewRouteImport } from './routes/_authenticated/_tenant/catalog-v2/experiments/new'
import { Route as AuthenticatedTenantCatalogV2ExperimentsExperimentIdRouteImport } from './routes/_authenticated/_tenant/catalog-v2/experiments/$experimentId'
import { Route as AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRouteImport } from './routes/_authenticated/_tenant/catalog-operations/products-need-attention_/$productId'
import { Route as AuthenticatedTenantCatalogOperationsBatchIdProductsRouteImport } from './routes/_authenticated/_tenant/catalog-operations/$batchId_/products'
import { Route as AuthenticatedTenantCatalogOperationsBatchIdDeliverRouteImport } from './routes/_authenticated/_tenant/catalog-operations/$batchId_/deliver'
import { Route as AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRouteImport } from './routes/_authenticated/_tenant/catalog-operations/$batchId_/compare-delivery'
import { Route as AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/schedules/$scheduleId'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsNewRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/new'
import { Route as AuthenticatedTenantCatalogEnrichmentProductsProductIdRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/products/$productId'
import { Route as AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/feed-products/$feedProductId'
import { Route as AuthenticatedTenantCatalogEnrichmentFeedAuditNewRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/feed-audit/new'
import { Route as AuthenticatedTenantCatalogEnrichmentExperimentsNewRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/experiments/new'
import { Route as AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/experiments/$experimentId'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdRouteRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/route'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/route'
import { Route as AuthenticatedTenantTrialPlatformEnrichmentIndexRouteImport } from './routes/_authenticated/_tenant/trial/$platform/enrichment/index'
import { Route as AuthenticatedTenantPlatformServiceAuthUsersIndexRouteImport } from './routes/_authenticated/_tenant/platform/service-auth/users/index'
import { Route as AuthenticatedTenantOnboardingIntegrationMetaIndexRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/meta/index'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleIndexRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/index'
import { Route as AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRouteImport } from './routes/_authenticated/_tenant/experiments_.$expId.content-enrichment/index'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdIndexRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/index'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/index'
import { Route as AuthenticatedTenantTrialPlatformEnrichmentIdRouteImport } from './routes/_authenticated/_tenant/trial/$platform/enrichment/$id'
import { Route as AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRouteImport } from './routes/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId/products'
import { Route as AuthenticatedTenantPlatformServiceAuthUsersIdRouteImport } from './routes/_authenticated/_tenant/platform/service-auth/users/$id'
import { Route as AuthenticatedTenantOnboardingIntegrationMetaSftpRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/meta/sftp'
import { Route as AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/meta/product-overview'
import { Route as AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/meta/meta-commerce-manager'
import { Route as AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/meta/import-catalog'
import { Route as AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/meta/complete-import'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleShopifyRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/shopify'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleSftpRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/sftp'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/import-catalog'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/google-merchant-center'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/google-analytics'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/google-ads'
import { Route as AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRouteImport } from './routes/_authenticated/_tenant/integrations/connections.connect.$connectorCode'
import { Route as AuthenticatedTenantExportsCatalogRunsRunIdRouteImport } from './routes/_authenticated/_tenant/exports/catalog/runs/$runId'
import { Route as AuthenticatedTenantExportsCatalogProfilesProfileIdRouteImport } from './routes/_authenticated/_tenant/exports/catalog/profiles/$profileId'
import { Route as AuthenticatedTenantExportsCatalogExportsExportIdRouteImport } from './routes/_authenticated/_tenant/exports/catalog/exports/$exportId'
import { Route as AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRouteImport } from './routes/_authenticated/_tenant/experiments_.$expId.content-enrichment/review'
import { Route as AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRouteImport } from './routes/_authenticated/_tenant/experiments_.$expId.content-enrichment/overview'
import { Route as AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRouteImport } from './routes/_authenticated/_tenant/experiments_.$expId.content-enrichment/groups'
import { Route as AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRouteImport } from './routes/_authenticated/_tenant/experiments_.$expId.content-enrichment/full'
import { Route as AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRouteImport } from './routes/_authenticated/_tenant/experiments_.$expId.content-enrichment/delivery'
import { Route as AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteImport } from './routes/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId'
import { Route as AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteImport } from './routes/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId'
import { Route as AuthenticatedTenantContentRunsRunIdReviewRouteImport } from './routes/_authenticated/_tenant/content/runs/$runId_/review'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdRecoveryRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/recovery'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/quality-checks'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdLineageRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/lineage'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdIssuesRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/issues'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdInsightsRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/insights'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdImagesRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/images'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdGateRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/gate'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdContentResultsRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/content-results'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdCompareRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/compare'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdApprovalRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/approval'
import { Route as AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRouteImport } from './routes/_authenticated/_tenant/catalog-operations/$batchId_/products_/$productId'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/recovery'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/quality-checks'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/lineage'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/issues'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/images'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/gate'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/delivery'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/cost'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/content-results'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/compare'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/approval'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/activity'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/google-analytics/index'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/google-ads/index'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/index'
import { Route as AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRouteImport } from './routes/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/index'
import { Route as AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRouteImport } from './routes/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/index'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/products/index'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/index'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/google-analytics/pick-property'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/google-analytics/data-preview'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/google-ads/select-account'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/google-ads/confirmation'
import { Route as AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRouteImport } from './routes/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/extraction'
import { Route as AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRouteImport } from './routes/_authenticated/_tenant/integrations/data-quality/product.$connectionId.$externalId'
import { Route as AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRouteImport } from './routes/_authenticated/_tenant/explorer/data-quality/product.$connectionId.$externalId'
import { Route as AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRouteImport } from './routes/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId_/deliver'
import { Route as AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRouteImport } from './routes/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/review'
import { Route as AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRouteImport } from './routes/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/overview'
import { Route as AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRouteImport } from './routes/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/full'
import { Route as AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRouteImport } from './routes/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/delivery'
import { Route as AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRouteImport } from './routes/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId_/deliver'
import { Route as AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRouteImport } from './routes/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/review'
import { Route as AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRouteImport } from './routes/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/overview'
import { Route as AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRouteImport } from './routes/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/full'
import { Route as AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRouteImport } from './routes/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/delivery'
import { Route as AuthenticatedTenantContentRunsRunIdProductsProductIdRouteImport } from './routes/_authenticated/_tenant/content_.runs.$runId.products.$productId'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/products/$productId'
import { Route as AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRouteImport } from './routes/_authenticated/_tenant/catalog-v2/runs/$runId/insights_.products'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/$productId'
import { Route as AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRouteImport } from './routes/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights_.products'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTenantRoute = AuthenticatedTenantRouteImport.update({
  id: '/_tenant',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ConnectorTokenIndexRoute = ConnectorTokenIndexRouteImport.update({
  id: '/connector/$token/',
  path: '/connector/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectorTokenSelectRoute = ConnectorTokenSelectRouteImport.update({
  id: '/connector/$token/select',
  path: '/connector/$token/select',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectorTokenDoneRoute = ConnectorTokenDoneRouteImport.update({
  id: '/connector/$token/done',
  path: '/connector/$token/done',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthProviderCallbackRoute = AuthProviderCallbackRouteImport.update({
  id: '/auth/$provider/callback',
  path: '/auth/$provider/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTenantTrialRoute =
  AuthenticatedTenantTrialRouteImport.update({
    id: '/trial',
    path: '/trial',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantSettingsRoute =
  AuthenticatedTenantSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantSchedulesRoute =
  AuthenticatedTenantSchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantProductNotEnrolledRoute =
  AuthenticatedTenantProductNotEnrolledRouteImport.update({
    id: '/product-not-enrolled',
    path: '/product-not-enrolled',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantOnboardingRoute =
  AuthenticatedTenantOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantNotificationRoute =
  AuthenticatedTenantNotificationRouteImport.update({
    id: '/notification',
    path: '/notification',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantLilyAgentRoute =
  AuthenticatedTenantLilyAgentRouteImport.update({
    id: '/lily-agent',
    path: '/lily-agent',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantItemSetupRoute =
  AuthenticatedTenantItemSetupRouteImport.update({
    id: '/item-setup',
    path: '/item-setup',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantHomeRoute = AuthenticatedTenantHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedTenantRoute,
} as any)
const AuthenticatedTenantHistoryRoute =
  AuthenticatedTenantHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantDashboardRoute =
  AuthenticatedTenantDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCoverageRoute =
  AuthenticatedTenantCoverageRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCostApprovalsRoute =
  AuthenticatedTenantCostApprovalsRouteImport.update({
    id: '/cost-approvals',
    path: '/cost-approvals',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogManagerRoute =
  AuthenticatedTenantCatalogManagerRouteImport.update({
    id: '/catalog-manager',
    path: '/catalog-manager',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantAccessDeniedRoute =
  AuthenticatedTenantAccessDeniedRouteImport.update({
    id: '/access-denied',
    path: '/access-denied',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantWorkflowRunsRouteRoute =
  AuthenticatedTenantWorkflowRunsRouteRouteImport.update({
    id: '/workflow-runs',
    path: '/workflow-runs',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantUploadDeliveryRouteRoute =
  AuthenticatedTenantUploadDeliveryRouteRouteImport.update({
    id: '/upload-delivery',
    path: '/upload-delivery',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantTaxonomyRouteRoute =
  AuthenticatedTenantTaxonomyRouteRouteImport.update({
    id: '/taxonomy',
    path: '/taxonomy',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantSubsidiaryRouteRoute =
  AuthenticatedTenantSubsidiaryRouteRouteImport.update({
    id: '/subsidiary',
    path: '/subsidiary',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantPlatformRouteRoute =
  AuthenticatedTenantPlatformRouteRouteImport.update({
    id: '/platform',
    path: '/platform',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantIntegrationsRouteRoute =
  AuthenticatedTenantIntegrationsRouteRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantFeedAuditRouteRoute =
  AuthenticatedTenantFeedAuditRouteRouteImport.update({
    id: '/feed-audit',
    path: '/feed-audit',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantExplorerRouteRoute =
  AuthenticatedTenantExplorerRouteRouteImport.update({
    id: '/explorer',
    path: '/explorer',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantDeliveriesRouteRoute =
  AuthenticatedTenantDeliveriesRouteRouteImport.update({
    id: '/deliveries',
    path: '/deliveries',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantContentRouteRoute =
  AuthenticatedTenantContentRouteRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantConfigurationRouteRoute =
  AuthenticatedTenantConfigurationRouteRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogV2RouteRoute =
  AuthenticatedTenantCatalogV2RouteRouteImport.update({
    id: '/catalog-v2',
    path: '/catalog-v2',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRouteRoute =
  AuthenticatedTenantCatalogEnrichmentRouteRouteImport.update({
    id: '/catalog-enrichment',
    path: '/catalog-enrichment',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantAiPerformanceRouteRoute =
  AuthenticatedTenantAiPerformanceRouteRouteImport.update({
    id: '/ai-performance',
    path: '/ai-performance',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantWorkflowRunsIndexRoute =
  AuthenticatedTenantWorkflowRunsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantWorkflowRunsRouteRoute,
  } as any)
const AuthenticatedTenantTaxonomyIndexRoute =
  AuthenticatedTenantTaxonomyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantTaxonomyRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryIndexRoute =
  AuthenticatedTenantSubsidiaryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryPreferencesIndexRoute =
  AuthenticatedTenantSubsidiaryPreferencesIndexRouteImport.update({
    id: '/subsidiary-preferences/',
    path: '/subsidiary-preferences/',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantProductCatalogIndexRoute =
  AuthenticatedTenantProductCatalogIndexRouteImport.update({
    id: '/product-catalog/',
    path: '/product-catalog/',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantPlatformIndexRoute =
  AuthenticatedTenantPlatformIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantOnboardingIndexRoute =
  AuthenticatedTenantOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantOnboardingRoute,
  } as any)
const AuthenticatedTenantItemSetupIndexRoute =
  AuthenticatedTenantItemSetupIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantIntegrationsIndexRoute =
  AuthenticatedTenantIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantFeedAuditIndexRoute =
  AuthenticatedTenantFeedAuditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantFeedAuditRouteRoute,
  } as any)
const AuthenticatedTenantExplorerIndexRoute =
  AuthenticatedTenantExplorerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExperimentsIndexRoute =
  AuthenticatedTenantExperimentsIndexRouteImport.update({
    id: '/experiments/',
    path: '/experiments/',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantDeliveriesIndexRoute =
  AuthenticatedTenantDeliveriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantDeliveriesRouteRoute,
  } as any)
const AuthenticatedTenantContentIndexRoute =
  AuthenticatedTenantContentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationIndexRoute =
  AuthenticatedTenantConfigurationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantConfigurationRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2IndexRoute =
  AuthenticatedTenantCatalogV2IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogOperationsIndexRoute =
  AuthenticatedTenantCatalogOperationsIndexRouteImport.update({
    id: '/catalog-operations/',
    path: '/catalog-operations/',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentIndexRoute =
  AuthenticatedTenantCatalogEnrichmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantAiPerformanceIndexRoute =
  AuthenticatedTenantAiPerformanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantAiPerformanceRouteRoute,
  } as any)
const PublicOauthGoogleAdsCallbackRoute =
  PublicOauthGoogleAdsCallbackRouteImport.update({
    id: '/public/oauth/google-ads/callback',
    path: '/public/oauth/google-ads/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedTenantWorkflowRunsRunIdRoute =
  AuthenticatedTenantWorkflowRunsRunIdRouteImport.update({
    id: '/$runId',
    path: '/$runId',
    getParentRoute: () => AuthenticatedTenantWorkflowRunsRouteRoute,
  } as any)
const AuthenticatedTenantUploadDeliverySingleRoute =
  AuthenticatedTenantUploadDeliverySingleRouteImport.update({
    id: '/single',
    path: '/single',
    getParentRoute: () => AuthenticatedTenantUploadDeliveryRouteRoute,
  } as any)
const AuthenticatedTenantTrialPlatformRoute =
  AuthenticatedTenantTrialPlatformRouteImport.update({
    id: '/$platform',
    path: '/$platform',
    getParentRoute: () => AuthenticatedTenantTrialRoute,
  } as any)
const AuthenticatedTenantTaxonomyVersionsRoute =
  AuthenticatedTenantTaxonomyVersionsRouteImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: () => AuthenticatedTenantTaxonomyRouteRoute,
  } as any)
const AuthenticatedTenantTaxonomyUploadsRoute =
  AuthenticatedTenantTaxonomyUploadsRouteImport.update({
    id: '/uploads',
    path: '/uploads',
    getParentRoute: () => AuthenticatedTenantTaxonomyRouteRoute,
  } as any)
const AuthenticatedTenantTaxonomyProductsRoute =
  AuthenticatedTenantTaxonomyProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedTenantTaxonomyRouteRoute,
  } as any)
const AuthenticatedTenantTaxonomyAttributesRoute =
  AuthenticatedTenantTaxonomyAttributesRouteImport.update({
    id: '/attributes',
    path: '/attributes',
    getParentRoute: () => AuthenticatedTenantTaxonomyRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryUsersRoute =
  AuthenticatedTenantSubsidiaryUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiarySyncScheduleRoute =
  AuthenticatedTenantSubsidiarySyncScheduleRouteImport.update({
    id: '/sync-schedule',
    path: '/sync-schedule',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiarySubsidiariesRoute =
  AuthenticatedTenantSubsidiarySubsidiariesRouteImport.update({
    id: '/subsidiaries',
    path: '/subsidiaries',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiarySsoRoute =
  AuthenticatedTenantSubsidiarySsoRouteImport.update({
    id: '/sso',
    path: '/sso',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryScreenAccessRoute =
  AuthenticatedTenantSubsidiaryScreenAccessRouteImport.update({
    id: '/screen-access',
    path: '/screen-access',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryRolesRoute =
  AuthenticatedTenantSubsidiaryRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryProductsRoute =
  AuthenticatedTenantSubsidiaryProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryDataSharingRoute =
  AuthenticatedTenantSubsidiaryDataSharingRouteImport.update({
    id: '/data-sharing',
    path: '/data-sharing',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryAssetAccessRoute =
  AuthenticatedTenantSubsidiaryAssetAccessRouteImport.update({
    id: '/asset-access',
    path: '/asset-access',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryAccessPolicyRoute =
  AuthenticatedTenantSubsidiaryAccessPolicyRouteImport.update({
    id: '/access-policy',
    path: '/access-policy',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryAccessControlRoute =
  AuthenticatedTenantSubsidiaryAccessControlRouteImport.update({
    id: '/access-control',
    path: '/access-control',
    getParentRoute: () => AuthenticatedTenantSubsidiaryRouteRoute,
  } as any)
const AuthenticatedTenantSubsidiaryPreferencesConstraintsRoute =
  AuthenticatedTenantSubsidiaryPreferencesConstraintsRouteImport.update({
    id: '/subsidiary-preferences/constraints',
    path: '/subsidiary-preferences/constraints',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRoute =
  AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRouteImport.update({
    id: '/subsidiary-preferences/brand-preferences',
    path: '/subsidiary-preferences/brand-preferences',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantSettingsNotificationRoute =
  AuthenticatedTenantSettingsNotificationRouteImport.update({
    id: '/settings_/notification',
    path: '/settings/notification',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantPlatformUsersRoute =
  AuthenticatedTenantPlatformUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformSubsidiariesRoute =
  AuthenticatedTenantPlatformSubsidiariesRouteImport.update({
    id: '/subsidiaries',
    path: '/subsidiaries',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformScreensRoute =
  AuthenticatedTenantPlatformScreensRouteImport.update({
    id: '/screens',
    path: '/screens',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformSchedulesRoute =
  AuthenticatedTenantPlatformSchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformResourcesRoute =
  AuthenticatedTenantPlatformResourcesRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformProductsRoute =
  AuthenticatedTenantPlatformProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformPermissionsRoute =
  AuthenticatedTenantPlatformPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformFeatureFlagsRoute =
  AuthenticatedTenantPlatformFeatureFlagsRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformEnrichmentLimitRoute =
  AuthenticatedTenantPlatformEnrichmentLimitRouteImport.update({
    id: '/enrichment-limit',
    path: '/enrichment-limit',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformDataManagementRoute =
  AuthenticatedTenantPlatformDataManagementRouteImport.update({
    id: '/data-management',
    path: '/data-management',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformCoverageRoute =
  AuthenticatedTenantPlatformCoverageRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformCostApprovalRoute =
  AuthenticatedTenantPlatformCostApprovalRouteImport.update({
    id: '/cost-approval',
    path: '/cost-approval',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformConnectorsRoute =
  AuthenticatedTenantPlatformConnectorsRouteImport.update({
    id: '/connectors',
    path: '/connectors',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformBatchReviewRoute =
  AuthenticatedTenantPlatformBatchReviewRouteImport.update({
    id: '/batch-review',
    path: '/batch-review',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformAuditLogsRoute =
  AuthenticatedTenantPlatformAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPipelinesPipelineIdRoute =
  AuthenticatedTenantPipelinesPipelineIdRouteImport.update({
    id: '/pipelines/$pipelineId',
    path: '/pipelines/$pipelineId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantPipelineRunsRunIdRoute =
  AuthenticatedTenantPipelineRunsRunIdRouteImport.update({
    id: '/pipeline-runs/$runId',
    path: '/pipeline-runs/$runId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantOnboardingProductOverviewRoute =
  AuthenticatedTenantOnboardingProductOverviewRouteImport.update({
    id: '/product-overview',
    path: '/product-overview',
    getParentRoute: () => AuthenticatedTenantOnboardingRoute,
  } as any)
const AuthenticatedTenantOnboardingPaidAdsRoute =
  AuthenticatedTenantOnboardingPaidAdsRouteImport.update({
    id: '/paid-ads',
    path: '/paid-ads',
    getParentRoute: () => AuthenticatedTenantOnboardingRoute,
  } as any)
const AuthenticatedTenantOnboardingOnsiteRoute =
  AuthenticatedTenantOnboardingOnsiteRouteImport.update({
    id: '/onsite',
    path: '/onsite',
    getParentRoute: () => AuthenticatedTenantOnboardingRoute,
  } as any)
const AuthenticatedTenantOnboardingCompleteImportRoute =
  AuthenticatedTenantOnboardingCompleteImportRouteImport.update({
    id: '/complete-import',
    path: '/complete-import',
    getParentRoute: () => AuthenticatedTenantOnboardingRoute,
  } as any)
const AuthenticatedTenantItemSetupVerifyRoute =
  AuthenticatedTenantItemSetupVerifyRouteImport.update({
    id: '/verify',
    path: '/verify',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupTaxonomyReviewRoute =
  AuthenticatedTenantItemSetupTaxonomyReviewRouteImport.update({
    id: '/taxonomy-review',
    path: '/taxonomy-review',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupTaxonomyRoute =
  AuthenticatedTenantItemSetupTaxonomyRouteImport.update({
    id: '/taxonomy',
    path: '/taxonomy',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupSourcePriorityRoute =
  AuthenticatedTenantItemSetupSourcePriorityRouteImport.update({
    id: '/source-priority',
    path: '/source-priority',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupShopifyConfirmRoute =
  AuthenticatedTenantItemSetupShopifyConfirmRouteImport.update({
    id: '/shopify-confirm',
    path: '/shopify-confirm',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupShopifyRoute =
  AuthenticatedTenantItemSetupShopifyRouteImport.update({
    id: '/shopify',
    path: '/shopify',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupSftpRoute =
  AuthenticatedTenantItemSetupSftpRouteImport.update({
    id: '/sftp',
    path: '/sftp',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupQualityReportRoute =
  AuthenticatedTenantItemSetupQualityReportRouteImport.update({
    id: '/quality-report',
    path: '/quality-report',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupPatternInspectorRoute =
  AuthenticatedTenantItemSetupPatternInspectorRouteImport.update({
    id: '/pattern-inspector',
    path: '/pattern-inspector',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupOutputFormatRoute =
  AuthenticatedTenantItemSetupOutputFormatRouteImport.update({
    id: '/output-format',
    path: '/output-format',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupFullCatalogGenerationRoute =
  AuthenticatedTenantItemSetupFullCatalogGenerationRouteImport.update({
    id: '/full-catalog-generation',
    path: '/full-catalog-generation',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupFilePreviewRoute =
  AuthenticatedTenantItemSetupFilePreviewRouteImport.update({
    id: '/file-preview',
    path: '/file-preview',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupEnrichmentOverviewRoute =
  AuthenticatedTenantItemSetupEnrichmentOverviewRouteImport.update({
    id: '/enrichment-overview',
    path: '/enrichment-overview',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupContentGenerationRoute =
  AuthenticatedTenantItemSetupContentGenerationRouteImport.update({
    id: '/content-generation',
    path: '/content-generation',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupClientVerificationRoute =
  AuthenticatedTenantItemSetupClientVerificationRouteImport.update({
    id: '/client-verification',
    path: '/client-verification',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupCatalogReviewRoute =
  AuthenticatedTenantItemSetupCatalogReviewRouteImport.update({
    id: '/catalog-review',
    path: '/catalog-review',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantItemSetupCalibrationScopeRoute =
  AuthenticatedTenantItemSetupCalibrationScopeRouteImport.update({
    id: '/calibration-scope',
    path: '/calibration-scope',
    getParentRoute: () => AuthenticatedTenantItemSetupRoute,
  } as any)
const AuthenticatedTenantIntegrationsSharingRoute =
  AuthenticatedTenantIntegrationsSharingRouteImport.update({
    id: '/integrations_/sharing',
    path: '/integrations/sharing',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantIntegrationsSchedulesRoute =
  AuthenticatedTenantIntegrationsSchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsProductsRoute =
  AuthenticatedTenantIntegrationsProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsKeywordPlannerRoute =
  AuthenticatedTenantIntegrationsKeywordPlannerRouteImport.update({
    id: '/keyword-planner',
    path: '/keyword-planner',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsHealthRoute =
  AuthenticatedTenantIntegrationsHealthRouteImport.update({
    id: '/health',
    path: '/health',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsDatalakeRoute =
  AuthenticatedTenantIntegrationsDatalakeRouteImport.update({
    id: '/datalake',
    path: '/datalake',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsCoverageRoute =
  AuthenticatedTenantIntegrationsCoverageRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsConnectorsRoute =
  AuthenticatedTenantIntegrationsConnectorsRouteImport.update({
    id: '/connectors',
    path: '/connectors',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsClickhouseRoute =
  AuthenticatedTenantIntegrationsClickhouseRouteImport.update({
    id: '/clickhouse',
    path: '/clickhouse',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsCatalogImagesRoute =
  AuthenticatedTenantIntegrationsCatalogImagesRouteImport.update({
    id: '/catalog-images',
    path: '/catalog-images',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantFeedAuditUploadRoute =
  AuthenticatedTenantFeedAuditUploadRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => AuthenticatedTenantFeedAuditRouteRoute,
  } as any)
const AuthenticatedTenantFeedAuditCreateRoute =
  AuthenticatedTenantFeedAuditCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedTenantFeedAuditRouteRoute,
  } as any)
const AuthenticatedTenantFeedAuditIdRoute =
  AuthenticatedTenantFeedAuditIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedTenantFeedAuditRouteRoute,
  } as any)
const AuthenticatedTenantExportsSourceWorkflowIdRoute =
  AuthenticatedTenantExportsSourceWorkflowIdRouteImport.update({
    id: '/exports/$sourceWorkflowId',
    path: '/exports/$sourceWorkflowId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantExplorerProductsRoute =
  AuthenticatedTenantExplorerProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExplorerKeywordPlannerRoute =
  AuthenticatedTenantExplorerKeywordPlannerRouteImport.update({
    id: '/keyword-planner',
    path: '/keyword-planner',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExplorerDatalakeRoute =
  AuthenticatedTenantExplorerDatalakeRouteImport.update({
    id: '/datalake',
    path: '/datalake',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExplorerCoverageRoute =
  AuthenticatedTenantExplorerCoverageRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExplorerClickhouseRoute =
  AuthenticatedTenantExplorerClickhouseRouteImport.update({
    id: '/clickhouse',
    path: '/clickhouse',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExplorerCatalogImagesRoute =
  AuthenticatedTenantExplorerCatalogImagesRouteImport.update({
    id: '/catalog-images',
    path: '/catalog-images',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExperimentsCreateRoute =
  AuthenticatedTenantExperimentsCreateRouteImport.update({
    id: '/experiments_/create',
    path: '/experiments/create',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantExperimentsIdRoute =
  AuthenticatedTenantExperimentsIdRouteImport.update({
    id: '/experiments/$id',
    path: '/experiments/$id',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantEnrichmentsMetaRoute =
  AuthenticatedTenantEnrichmentsMetaRouteImport.update({
    id: '/enrichments/meta',
    path: '/enrichments/meta',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantEnrichmentsGoogleRoute =
  AuthenticatedTenantEnrichmentsGoogleRouteImport.update({
    id: '/enrichments/google',
    path: '/enrichments/google',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantDeliveriesNewRoute =
  AuthenticatedTenantDeliveriesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedTenantDeliveriesRouteRoute,
  } as any)
const AuthenticatedTenantDeliveriesRunIdRoute =
  AuthenticatedTenantDeliveriesRunIdRouteImport.update({
    id: '/$runId',
    path: '/$runId',
    getParentRoute: () => AuthenticatedTenantDeliveriesRouteRoute,
  } as any)
const AuthenticatedTenantCostApprovalsWorkflowIdRoute =
  AuthenticatedTenantCostApprovalsWorkflowIdRouteImport.update({
    id: '/cost-approvals_/$workflowId',
    path: '/cost-approvals/$workflowId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantContentReviewRoute =
  AuthenticatedTenantContentReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentPromptsRoute =
  AuthenticatedTenantContentPromptsRouteImport.update({
    id: '/prompts',
    path: '/prompts',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentOverviewRoute =
  AuthenticatedTenantContentOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentModelConfigurationRoute =
  AuthenticatedTenantContentModelConfigurationRouteImport.update({
    id: '/model-configuration',
    path: '/model-configuration',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentJobsRoute =
  AuthenticatedTenantContentJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentAttributionRoute =
  AuthenticatedTenantContentAttributionRouteImport.update({
    id: '/attribution',
    path: '/attribution',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationTreatmentRoute =
  AuthenticatedTenantConfigurationTreatmentRouteImport.update({
    id: '/treatment',
    path: '/treatment',
    getParentRoute: () => AuthenticatedTenantConfigurationRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationPromptsRoute =
  AuthenticatedTenantConfigurationPromptsRouteImport.update({
    id: '/prompts',
    path: '/prompts',
    getParentRoute: () => AuthenticatedTenantConfigurationRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationManagerRoute =
  AuthenticatedTenantConfigurationManagerRouteImport.update({
    id: '/manager',
    path: '/manager',
    getParentRoute: () => AuthenticatedTenantConfigurationRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationLilyTaxonomyRoute =
  AuthenticatedTenantConfigurationLilyTaxonomyRouteImport.update({
    id: '/lily-taxonomy',
    path: '/lily-taxonomy',
    getParentRoute: () => AuthenticatedTenantConfigurationRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationGpcCategoriesRoute =
  AuthenticatedTenantConfigurationGpcCategoriesRouteImport.update({
    id: '/gpc-categories',
    path: '/gpc-categories',
    getParentRoute: () => AuthenticatedTenantConfigurationRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationFpcCategoriesRoute =
  AuthenticatedTenantConfigurationFpcCategoriesRouteImport.update({
    id: '/fpc-categories',
    path: '/fpc-categories',
    getParentRoute: () => AuthenticatedTenantConfigurationRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationDashboardRoute =
  AuthenticatedTenantConfigurationDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedTenantConfigurationRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2SchedulesRoute =
  AuthenticatedTenantCatalogV2SchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2NeedsAttentionRoute =
  AuthenticatedTenantCatalogV2NeedsAttentionRouteImport.update({
    id: '/needs-attention',
    path: '/needs-attention',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2CostApprovalsRoute =
  AuthenticatedTenantCatalogV2CostApprovalsRouteImport.update({
    id: '/cost-approvals',
    path: '/cost-approvals',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogOperationsProductsNeedAttentionRoute =
  AuthenticatedTenantCatalogOperationsProductsNeedAttentionRouteImport.update({
    id: '/catalog-operations/products-need-attention',
    path: '/catalog-operations/products-need-attention',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogOperationsBatchIdRoute =
  AuthenticatedTenantCatalogOperationsBatchIdRouteImport.update({
    id: '/catalog-operations/$batchId',
    path: '/catalog-operations/$batchId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentNeedsAttentionRoute =
  AuthenticatedTenantCatalogEnrichmentNeedsAttentionRouteImport.update({
    id: '/needs-attention',
    path: '/needs-attention',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentCostApprovalsRoute =
  AuthenticatedTenantCatalogEnrichmentCostApprovalsRouteImport.update({
    id: '/cost-approvals',
    path: '/cost-approvals',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantAiPerformanceWorkflowIdRoute =
  AuthenticatedTenantAiPerformanceWorkflowIdRouteImport.update({
    id: '/$workflowId',
    path: '/$workflowId',
    getParentRoute: () => AuthenticatedTenantAiPerformanceRouteRoute,
  } as any)
const AuthenticatedTenantPlatformServiceAuthRouteRoute =
  AuthenticatedTenantPlatformServiceAuthRouteRouteImport.update({
    id: '/service-auth',
    path: '/service-auth',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformTransformersIndexRoute =
  AuthenticatedTenantPlatformTransformersIndexRouteImport.update({
    id: '/transformers/',
    path: '/transformers/',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformSubsidiariesIndexRoute =
  AuthenticatedTenantPlatformSubsidiariesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantPlatformSubsidiariesRoute,
  } as any)
const AuthenticatedTenantPlatformServiceAuthIndexRoute =
  AuthenticatedTenantPlatformServiceAuthIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantPlatformServiceAuthRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsUploadDeliveryIndexRoute =
  AuthenticatedTenantIntegrationsUploadDeliveryIndexRouteImport.update({
    id: '/upload-delivery/',
    path: '/upload-delivery/',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsPipelinesIndexRoute =
  AuthenticatedTenantIntegrationsPipelinesIndexRouteImport.update({
    id: '/pipelines/',
    path: '/pipelines/',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsDataQualityIndexRoute =
  AuthenticatedTenantIntegrationsDataQualityIndexRouteImport.update({
    id: '/data-quality/',
    path: '/data-quality/',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsConnectionsIndexRoute =
  AuthenticatedTenantIntegrationsConnectionsIndexRouteImport.update({
    id: '/connections/',
    path: '/connections/',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantExportsCatalogIndexRoute =
  AuthenticatedTenantExportsCatalogIndexRouteImport.update({
    id: '/exports/catalog/',
    path: '/exports/catalog/',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantExplorerDataQualityIndexRoute =
  AuthenticatedTenantExplorerDataQualityIndexRouteImport.update({
    id: '/data-quality/',
    path: '/data-quality/',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExperimentsCreateIndexRoute =
  AuthenticatedTenantExperimentsCreateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantExperimentsCreateRoute,
  } as any)
const AuthenticatedTenantContentRunsIndexRoute =
  AuthenticatedTenantContentRunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentQcIndexRoute =
  AuthenticatedTenantContentQcIndexRouteImport.update({
    id: '/qc/',
    path: '/qc/',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationManagerIndexRoute =
  AuthenticatedTenantConfigurationManagerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantConfigurationManagerRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsIndexRoute =
  AuthenticatedTenantCatalogV2RunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2ProductsIndexRoute =
  AuthenticatedTenantCatalogV2ProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2FeedAuditIndexRoute =
  AuthenticatedTenantCatalogV2FeedAuditIndexRouteImport.update({
    id: '/feed-audit/',
    path: '/feed-audit/',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2ExperimentsIndexRoute =
  AuthenticatedTenantCatalogV2ExperimentsIndexRouteImport.update({
    id: '/experiments/',
    path: '/experiments/',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentSchedulesIndexRoute =
  AuthenticatedTenantCatalogEnrichmentSchedulesIndexRouteImport.update({
    id: '/schedules/',
    path: '/schedules/',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsIndexRoute =
  AuthenticatedTenantCatalogEnrichmentRunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentProductsIndexRoute =
  AuthenticatedTenantCatalogEnrichmentProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRoute =
  AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRouteImport.update({
    id: '/feed-audit/',
    path: '/feed-audit/',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentExperimentsIndexRoute =
  AuthenticatedTenantCatalogEnrichmentExperimentsIndexRouteImport.update({
    id: '/experiments/',
    path: '/experiments/',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantTrialPlatformEnrichmentRoute =
  AuthenticatedTenantTrialPlatformEnrichmentRouteImport.update({
    id: '/enrichment',
    path: '/enrichment',
    getParentRoute: () => AuthenticatedTenantTrialPlatformRoute,
  } as any)
const AuthenticatedTenantTrialPlatformCreateRoute =
  AuthenticatedTenantTrialPlatformCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedTenantTrialPlatformRoute,
  } as any)
const AuthenticatedTenantPlatformTransformersTransformerIdRoute =
  AuthenticatedTenantPlatformTransformersTransformerIdRouteImport.update({
    id: '/transformers/$transformerId',
    path: '/transformers/$transformerId',
    getParentRoute: () => AuthenticatedTenantPlatformRouteRoute,
  } as any)
const AuthenticatedTenantPlatformSubsidiariesOnboardingRoute =
  AuthenticatedTenantPlatformSubsidiariesOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedTenantPlatformSubsidiariesRoute,
  } as any)
const AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRoute =
  AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteImport.update({
    id: '/$subsidiaryId',
    path: '/$subsidiaryId',
    getParentRoute: () => AuthenticatedTenantPlatformSubsidiariesRoute,
  } as any)
const AuthenticatedTenantPlatformServiceAuthDiscoveryRoute =
  AuthenticatedTenantPlatformServiceAuthDiscoveryRouteImport.update({
    id: '/discovery',
    path: '/discovery',
    getParentRoute: () => AuthenticatedTenantPlatformServiceAuthRouteRoute,
  } as any)
const AuthenticatedTenantPlatformServiceAuthAuditRoute =
  AuthenticatedTenantPlatformServiceAuthAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedTenantPlatformServiceAuthRouteRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationMetaRoute =
  AuthenticatedTenantOnboardingIntegrationMetaRouteImport.update({
    id: '/integration/meta',
    path: '/integration/meta',
    getParentRoute: () => AuthenticatedTenantOnboardingRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationGoogleRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleRouteImport.update({
    id: '/integration/google',
    path: '/integration/google',
    getParentRoute: () => AuthenticatedTenantOnboardingRoute,
  } as any)
const AuthenticatedTenantOauthGoogleAdsCallbackRoute =
  AuthenticatedTenantOauthGoogleAdsCallbackRouteImport.update({
    id: '/oauth/google-ads/callback',
    path: '/oauth/google-ads/callback',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantIntegrationsDatalakeUploadRoute =
  AuthenticatedTenantIntegrationsDatalakeUploadRouteImport.update({
    id: '/datalake_/upload',
    path: '/datalake/upload',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsDataQualityCompareRoute =
  AuthenticatedTenantIntegrationsDataQualityCompareRouteImport.update({
    id: '/data-quality/compare',
    path: '/data-quality/compare',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantIntegrationsConnectionsNewRoute =
  AuthenticatedTenantIntegrationsConnectionsNewRouteImport.update({
    id: '/connections/new',
    path: '/connections/new',
    getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
  } as any)
const AuthenticatedTenantExportsCatalogNewRoute =
  AuthenticatedTenantExportsCatalogNewRouteImport.update({
    id: '/exports/catalog/new',
    path: '/exports/catalog/new',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantExplorerDatalakeUploadRoute =
  AuthenticatedTenantExplorerDatalakeUploadRouteImport.update({
    id: '/datalake_/upload',
    path: '/datalake/upload',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExplorerDataQualityCompareRoute =
  AuthenticatedTenantExplorerDataQualityCompareRouteImport.update({
    id: '/data-quality/compare',
    path: '/data-quality/compare',
    getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
  } as any)
const AuthenticatedTenantExperimentsCreateInfoRoute =
  AuthenticatedTenantExperimentsCreateInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => AuthenticatedTenantExperimentsCreateRoute,
  } as any)
const AuthenticatedTenantExperimentsCreateConfigureRoute =
  AuthenticatedTenantExperimentsCreateConfigureRouteImport.update({
    id: '/configure',
    path: '/configure',
    getParentRoute: () => AuthenticatedTenantExperimentsCreateRoute,
  } as any)
const AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute =
  AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteImport.update({
    id: '/experiments_/$expId/content-enrichment',
    path: '/experiments/$expId/content-enrichment',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantEnrichmentsMetaProductSelectionRoute =
  AuthenticatedTenantEnrichmentsMetaProductSelectionRouteImport.update({
    id: '/product-selection',
    path: '/product-selection',
    getParentRoute: () => AuthenticatedTenantEnrichmentsMetaRoute,
  } as any)
const AuthenticatedTenantEnrichmentsGoogleProductSelectionRoute =
  AuthenticatedTenantEnrichmentsGoogleProductSelectionRouteImport.update({
    id: '/product-selection',
    path: '/product-selection',
    getParentRoute: () => AuthenticatedTenantEnrichmentsGoogleRoute,
  } as any)
const AuthenticatedTenantDeliveriesConnectionsConnectionIdRoute =
  AuthenticatedTenantDeliveriesConnectionsConnectionIdRouteImport.update({
    id: '/connections/$connectionId',
    path: '/connections/$connectionId',
    getParentRoute: () => AuthenticatedTenantDeliveriesRouteRoute,
  } as any)
const AuthenticatedTenantContentQcNewRoute =
  AuthenticatedTenantContentQcNewRouteImport.update({
    id: '/content_/qc/new',
    path: '/content/qc/new',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantContentQcRunIdRoute =
  AuthenticatedTenantContentQcRunIdRouteImport.update({
    id: '/content_/qc/$runId',
    path: '/content/qc/$runId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantContentCatalogNewRoute =
  AuthenticatedTenantContentCatalogNewRouteImport.update({
    id: '/content_/catalog/new',
    path: '/content/catalog/new',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantContentCatalogJobIdRoute =
  AuthenticatedTenantContentCatalogJobIdRouteImport.update({
    id: '/content_/catalog/$jobId',
    path: '/content/catalog/$jobId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantContentSettingsVocabularyRoute =
  AuthenticatedTenantContentSettingsVocabularyRouteImport.update({
    id: '/settings/vocabulary',
    path: '/settings/vocabulary',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentSettingsModelsRoute =
  AuthenticatedTenantContentSettingsModelsRouteImport.update({
    id: '/settings/models',
    path: '/settings/models',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentSettingsInstructionsRoute =
  AuthenticatedTenantContentSettingsInstructionsRouteImport.update({
    id: '/settings/instructions',
    path: '/settings/instructions',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentRunsHowItWorksRoute =
  AuthenticatedTenantContentRunsHowItWorksRouteImport.update({
    id: '/runs/how-it-works',
    path: '/runs/how-it-works',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentRunsRunIdRoute =
  AuthenticatedTenantContentRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantContentJobsHowItWorksRoute =
  AuthenticatedTenantContentJobsHowItWorksRouteImport.update({
    id: '/jobs_/how-it-works',
    path: '/jobs/how-it-works',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantConfigurationManagerParametersRoute =
  AuthenticatedTenantConfigurationManagerParametersRouteImport.update({
    id: '/parameters',
    path: '/parameters',
    getParentRoute: () => AuthenticatedTenantConfigurationManagerRoute,
  } as any)
const AuthenticatedTenantConfigurationManagerAuditTrailRoute =
  AuthenticatedTenantConfigurationManagerAuditTrailRouteImport.update({
    id: '/audit-trail',
    path: '/audit-trail',
    getParentRoute: () => AuthenticatedTenantConfigurationManagerRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsNewRoute =
  AuthenticatedTenantCatalogV2RunsNewRouteImport.update({
    id: '/runs/new',
    path: '/runs/new',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2ProductsProductIdRoute =
  AuthenticatedTenantCatalogV2ProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRoute =
  AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRouteImport.update({
    id: '/feed-products/$feedProductId',
    path: '/feed-products/$feedProductId',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2FeedAuditNewRoute =
  AuthenticatedTenantCatalogV2FeedAuditNewRouteImport.update({
    id: '/feed-audit/new',
    path: '/feed-audit/new',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2ExperimentsNewRoute =
  AuthenticatedTenantCatalogV2ExperimentsNewRouteImport.update({
    id: '/experiments/new',
    path: '/experiments/new',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2ExperimentsExperimentIdRoute =
  AuthenticatedTenantCatalogV2ExperimentsExperimentIdRouteImport.update({
    id: '/experiments/$experimentId',
    path: '/experiments/$experimentId',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRoute =
  AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRouteImport.update(
    {
      id: '/catalog-operations/products-need-attention_/$productId',
      path: '/catalog-operations/products-need-attention/$productId',
      getParentRoute: () => AuthenticatedTenantRoute,
    } as any,
  )
const AuthenticatedTenantCatalogOperationsBatchIdProductsRoute =
  AuthenticatedTenantCatalogOperationsBatchIdProductsRouteImport.update({
    id: '/catalog-operations/$batchId_/products',
    path: '/catalog-operations/$batchId/products',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogOperationsBatchIdDeliverRoute =
  AuthenticatedTenantCatalogOperationsBatchIdDeliverRouteImport.update({
    id: '/catalog-operations/$batchId_/deliver',
    path: '/catalog-operations/$batchId/deliver',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRoute =
  AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRouteImport.update({
    id: '/catalog-operations/$batchId_/compare-delivery',
    path: '/catalog-operations/$batchId/compare-delivery',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRoute =
  AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRouteImport.update({
    id: '/schedules/$scheduleId',
    path: '/schedules/$scheduleId',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsNewRoute =
  AuthenticatedTenantCatalogEnrichmentRunsNewRouteImport.update({
    id: '/runs/new',
    path: '/runs/new',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentProductsProductIdRoute =
  AuthenticatedTenantCatalogEnrichmentProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRoute =
  AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRouteImport.update(
    {
      id: '/feed-products/$feedProductId',
      path: '/feed-products/$feedProductId',
      getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
    } as any,
  )
const AuthenticatedTenantCatalogEnrichmentFeedAuditNewRoute =
  AuthenticatedTenantCatalogEnrichmentFeedAuditNewRouteImport.update({
    id: '/feed-audit/new',
    path: '/feed-audit/new',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentExperimentsNewRoute =
  AuthenticatedTenantCatalogEnrichmentExperimentsNewRouteImport.update({
    id: '/experiments/new',
    path: '/experiments/new',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRoute =
  AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRouteImport.update(
    {
      id: '/experiments/$experimentId',
      path: '/experiments/$experimentId',
      getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
    } as any,
  )
const AuthenticatedTenantCatalogV2RunsRunIdRouteRoute =
  AuthenticatedTenantCatalogV2RunsRunIdRouteRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AuthenticatedTenantCatalogV2RouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AuthenticatedTenantCatalogEnrichmentRouteRoute,
  } as any)
const AuthenticatedTenantTrialPlatformEnrichmentIndexRoute =
  AuthenticatedTenantTrialPlatformEnrichmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantTrialPlatformEnrichmentRoute,
  } as any)
const AuthenticatedTenantPlatformServiceAuthUsersIndexRoute =
  AuthenticatedTenantPlatformServiceAuthUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedTenantPlatformServiceAuthRouteRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationMetaIndexRoute =
  AuthenticatedTenantOnboardingIntegrationMetaIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantOnboardingIntegrationMetaRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationGoogleIndexRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantOnboardingIntegrationGoogleRoute,
  } as any)
const AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRoute =
  AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdIndexRoute =
  AuthenticatedTenantCatalogV2RunsRunIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantTrialPlatformEnrichmentIdRoute =
  AuthenticatedTenantTrialPlatformEnrichmentIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedTenantTrialPlatformEnrichmentRoute,
  } as any)
const AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRoute =
  AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRouteImport.update(
    {
      id: '/products',
      path: '/products',
      getParentRoute: () =>
        AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRoute,
    } as any,
  )
const AuthenticatedTenantPlatformServiceAuthUsersIdRoute =
  AuthenticatedTenantPlatformServiceAuthUsersIdRouteImport.update({
    id: '/users/$id',
    path: '/users/$id',
    getParentRoute: () => AuthenticatedTenantPlatformServiceAuthRouteRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationMetaSftpRoute =
  AuthenticatedTenantOnboardingIntegrationMetaSftpRouteImport.update({
    id: '/sftp',
    path: '/sftp',
    getParentRoute: () => AuthenticatedTenantOnboardingIntegrationMetaRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRoute =
  AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRouteImport.update(
    {
      id: '/product-overview',
      path: '/product-overview',
      getParentRoute: () => AuthenticatedTenantOnboardingIntegrationMetaRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRoute =
  AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRouteImport.update(
    {
      id: '/meta-commerce-manager',
      path: '/meta-commerce-manager',
      getParentRoute: () => AuthenticatedTenantOnboardingIntegrationMetaRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRoute =
  AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRouteImport.update({
    id: '/import-catalog',
    path: '/import-catalog',
    getParentRoute: () => AuthenticatedTenantOnboardingIntegrationMetaRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRoute =
  AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRouteImport.update({
    id: '/complete-import',
    path: '/complete-import',
    getParentRoute: () => AuthenticatedTenantOnboardingIntegrationMetaRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationGoogleShopifyRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleShopifyRouteImport.update({
    id: '/shopify',
    path: '/shopify',
    getParentRoute: () => AuthenticatedTenantOnboardingIntegrationGoogleRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationGoogleSftpRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleSftpRouteImport.update({
    id: '/sftp',
    path: '/sftp',
    getParentRoute: () => AuthenticatedTenantOnboardingIntegrationGoogleRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRouteImport.update(
    {
      id: '/import-catalog',
      path: '/import-catalog',
      getParentRoute: () => AuthenticatedTenantOnboardingIntegrationGoogleRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRouteImport.update(
    {
      id: '/google-merchant-center',
      path: '/google-merchant-center',
      getParentRoute: () => AuthenticatedTenantOnboardingIntegrationGoogleRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteImport.update(
    {
      id: '/google-analytics',
      path: '/google-analytics',
      getParentRoute: () => AuthenticatedTenantOnboardingIntegrationGoogleRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteImport.update({
    id: '/google-ads',
    path: '/google-ads',
    getParentRoute: () => AuthenticatedTenantOnboardingIntegrationGoogleRoute,
  } as any)
const AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRoute =
  AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRouteImport.update(
    {
      id: '/connections/connect/$connectorCode',
      path: '/connections/connect/$connectorCode',
      getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
    } as any,
  )
const AuthenticatedTenantExportsCatalogRunsRunIdRoute =
  AuthenticatedTenantExportsCatalogRunsRunIdRouteImport.update({
    id: '/exports/catalog/runs/$runId',
    path: '/exports/catalog/runs/$runId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantExportsCatalogProfilesProfileIdRoute =
  AuthenticatedTenantExportsCatalogProfilesProfileIdRouteImport.update({
    id: '/exports/catalog/profiles/$profileId',
    path: '/exports/catalog/profiles/$profileId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantExportsCatalogExportsExportIdRoute =
  AuthenticatedTenantExportsCatalogExportsExportIdRouteImport.update({
    id: '/exports/catalog/exports/$exportId',
    path: '/exports/catalog/exports/$exportId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRoute =
  AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () =>
      AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute,
  } as any)
const AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRoute =
  AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute,
    } as any,
  )
const AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRoute =
  AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () =>
      AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute,
  } as any)
const AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRoute =
  AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRouteImport.update({
    id: '/full',
    path: '/full',
    getParentRoute: () =>
      AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute,
  } as any)
const AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRoute =
  AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRouteImport.update(
    {
      id: '/delivery',
      path: '/delivery',
      getParentRoute: () =>
        AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute =
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteImport.update({
    id: '/content-enrichment/$batchId',
    path: '/content-enrichment/$batchId',
    getParentRoute: () => AuthenticatedTenantEnrichmentsMetaRoute,
  } as any)
const AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute =
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteImport.update(
    {
      id: '/content-enrichment/$batchId',
      path: '/content-enrichment/$batchId',
      getParentRoute: () => AuthenticatedTenantEnrichmentsGoogleRoute,
    } as any,
  )
const AuthenticatedTenantContentRunsRunIdReviewRoute =
  AuthenticatedTenantContentRunsRunIdReviewRouteImport.update({
    id: '/runs/$runId_/review',
    path: '/runs/$runId/review',
    getParentRoute: () => AuthenticatedTenantContentRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdRecoveryRoute =
  AuthenticatedTenantCatalogV2RunsRunIdRecoveryRouteImport.update({
    id: '/recovery',
    path: '/recovery',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRoute =
  AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRouteImport.update({
    id: '/quality-checks',
    path: '/quality-checks',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdLineageRoute =
  AuthenticatedTenantCatalogV2RunsRunIdLineageRouteImport.update({
    id: '/lineage',
    path: '/lineage',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdIssuesRoute =
  AuthenticatedTenantCatalogV2RunsRunIdIssuesRouteImport.update({
    id: '/issues',
    path: '/issues',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdInsightsRoute =
  AuthenticatedTenantCatalogV2RunsRunIdInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdImagesRoute =
  AuthenticatedTenantCatalogV2RunsRunIdImagesRouteImport.update({
    id: '/images',
    path: '/images',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdGateRoute =
  AuthenticatedTenantCatalogV2RunsRunIdGateRouteImport.update({
    id: '/gate',
    path: '/gate',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdContentResultsRoute =
  AuthenticatedTenantCatalogV2RunsRunIdContentResultsRouteImport.update({
    id: '/content-results',
    path: '/content-results',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdCompareRoute =
  AuthenticatedTenantCatalogV2RunsRunIdCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdApprovalRoute =
  AuthenticatedTenantCatalogV2RunsRunIdApprovalRouteImport.update({
    id: '/approval',
    path: '/approval',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRoute =
  AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRouteImport.update(
    {
      id: '/catalog-operations/$batchId_/products_/$productId',
      path: '/catalog-operations/$batchId/products/$productId',
      getParentRoute: () => AuthenticatedTenantRoute,
    } as any,
  )
const AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRouteImport.update({
    id: '/recovery',
    path: '/recovery',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRouteImport.update({
    id: '/quality-checks',
    path: '/quality-checks',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRouteImport.update({
    id: '/lineage',
    path: '/lineage',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRouteImport.update({
    id: '/issues',
    path: '/issues',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRouteImport.update({
    id: '/images',
    path: '/images',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRouteImport.update({
    id: '/gate',
    path: '/gate',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRouteImport.update({
    id: '/delivery',
    path: '/delivery',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRouteImport.update({
    id: '/cost',
    path: '/cost',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRouteImport.update(
    {
      id: '/content-results',
      path: '/content-results',
      getParentRoute: () =>
        AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
    } as any,
  )
const AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRouteImport.update({
    id: '/approval',
    path: '/approval',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRouteImport.update(
    {
      id: '/adobe-analytics/',
      path: '/adobe-analytics/',
      getParentRoute: () => AuthenticatedTenantOnboardingIntegrationGoogleRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRoute =
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRoute =
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRoute =
  AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () =>
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRouteImport.update(
    {
      id: '/pick-property',
      path: '/pick-property',
      getParentRoute: () =>
        AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRouteImport.update(
    {
      id: '/data-preview',
      path: '/data-preview',
      getParentRoute: () =>
        AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRouteImport.update(
    {
      id: '/select-account',
      path: '/select-account',
      getParentRoute: () =>
        AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRouteImport.update(
    {
      id: '/confirmation',
      path: '/confirmation',
      getParentRoute: () =>
        AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute,
    } as any,
  )
const AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRoute =
  AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRouteImport.update(
    {
      id: '/adobe-analytics/extraction',
      path: '/adobe-analytics/extraction',
      getParentRoute: () => AuthenticatedTenantOnboardingIntegrationGoogleRoute,
    } as any,
  )
const AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRoute =
  AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRouteImport.update(
    {
      id: '/data-quality/product/$connectionId/$externalId',
      path: '/data-quality/product/$connectionId/$externalId',
      getParentRoute: () => AuthenticatedTenantIntegrationsRouteRoute,
    } as any,
  )
const AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRoute =
  AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRouteImport.update(
    {
      id: '/data-quality/product/$connectionId/$externalId',
      path: '/data-quality/product/$connectionId/$externalId',
      getParentRoute: () => AuthenticatedTenantExplorerRouteRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRoute =
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRouteImport.update(
    {
      id: '/content-enrichment/$batchId_/deliver',
      path: '/content-enrichment/$batchId/deliver',
      getParentRoute: () => AuthenticatedTenantEnrichmentsMetaRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRoute =
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRoute =
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRoute =
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRouteImport.update(
    {
      id: '/full',
      path: '/full',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRoute =
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRouteImport.update(
    {
      id: '/delivery',
      path: '/delivery',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRoute =
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRouteImport.update(
    {
      id: '/content-enrichment/$batchId_/deliver',
      path: '/content-enrichment/$batchId/deliver',
      getParentRoute: () => AuthenticatedTenantEnrichmentsGoogleRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRoute =
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRoute =
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRoute =
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRouteImport.update(
    {
      id: '/full',
      path: '/full',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRoute =
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRouteImport.update(
    {
      id: '/delivery',
      path: '/delivery',
      getParentRoute: () =>
        AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute,
    } as any,
  )
const AuthenticatedTenantContentRunsRunIdProductsProductIdRoute =
  AuthenticatedTenantContentRunsRunIdProductsProductIdRouteImport.update({
    id: '/content_/runs/$runId/products/$productId',
    path: '/content/runs/$runId/products/$productId',
    getParentRoute: () => AuthenticatedTenantRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRoute =
  AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRoute =
  AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRouteImport.update({
    id: '/insights_/products',
    path: '/insights/products',
    getParentRoute: () => AuthenticatedTenantCatalogV2RunsRunIdRouteRoute,
  } as any)
const AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRouteImport.update(
    {
      id: '/products/$productId',
      path: '/products/$productId',
      getParentRoute: () =>
        AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
    } as any,
  )
const AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRoute =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRouteImport.update(
    {
      id: '/insights_/products',
      path: '/insights/products',
      getParentRoute: () =>
        AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/$': typeof AuthenticatedSplatRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/ai-performance': typeof AuthenticatedTenantAiPerformanceRouteRouteWithChildren
  '/catalog-enrichment': typeof AuthenticatedTenantCatalogEnrichmentRouteRouteWithChildren
  '/catalog-v2': typeof AuthenticatedTenantCatalogV2RouteRouteWithChildren
  '/configuration': typeof AuthenticatedTenantConfigurationRouteRouteWithChildren
  '/content': typeof AuthenticatedTenantContentRouteRouteWithChildren
  '/deliveries': typeof AuthenticatedTenantDeliveriesRouteRouteWithChildren
  '/explorer': typeof AuthenticatedTenantExplorerRouteRouteWithChildren
  '/feed-audit': typeof AuthenticatedTenantFeedAuditRouteRouteWithChildren
  '/integrations': typeof AuthenticatedTenantIntegrationsRouteRouteWithChildren
  '/platform': typeof AuthenticatedTenantPlatformRouteRouteWithChildren
  '/subsidiary': typeof AuthenticatedTenantSubsidiaryRouteRouteWithChildren
  '/taxonomy': typeof AuthenticatedTenantTaxonomyRouteRouteWithChildren
  '/upload-delivery': typeof AuthenticatedTenantUploadDeliveryRouteRouteWithChildren
  '/workflow-runs': typeof AuthenticatedTenantWorkflowRunsRouteRouteWithChildren
  '/access-denied': typeof AuthenticatedTenantAccessDeniedRoute
  '/catalog-manager': typeof AuthenticatedTenantCatalogManagerRoute
  '/cost-approvals': typeof AuthenticatedTenantCostApprovalsRoute
  '/coverage': typeof AuthenticatedTenantCoverageRoute
  '/dashboard': typeof AuthenticatedTenantDashboardRoute
  '/history': typeof AuthenticatedTenantHistoryRoute
  '/home': typeof AuthenticatedTenantHomeRoute
  '/item-setup': typeof AuthenticatedTenantItemSetupRouteWithChildren
  '/lily-agent': typeof AuthenticatedTenantLilyAgentRoute
  '/notification': typeof AuthenticatedTenantNotificationRoute
  '/onboarding': typeof AuthenticatedTenantOnboardingRouteWithChildren
  '/product-not-enrolled': typeof AuthenticatedTenantProductNotEnrolledRoute
  '/schedules': typeof AuthenticatedTenantSchedulesRoute
  '/settings': typeof AuthenticatedTenantSettingsRoute
  '/trial': typeof AuthenticatedTenantTrialRouteWithChildren
  '/auth/$provider/callback': typeof AuthProviderCallbackRoute
  '/connector/$token/done': typeof ConnectorTokenDoneRoute
  '/connector/$token/select': typeof ConnectorTokenSelectRoute
  '/connector/$token/': typeof ConnectorTokenIndexRoute
  '/platform/service-auth': typeof AuthenticatedTenantPlatformServiceAuthRouteRouteWithChildren
  '/ai-performance/$workflowId': typeof AuthenticatedTenantAiPerformanceWorkflowIdRoute
  '/catalog-enrichment/cost-approvals': typeof AuthenticatedTenantCatalogEnrichmentCostApprovalsRoute
  '/catalog-enrichment/needs-attention': typeof AuthenticatedTenantCatalogEnrichmentNeedsAttentionRoute
  '/catalog-operations/$batchId': typeof AuthenticatedTenantCatalogOperationsBatchIdRoute
  '/catalog-operations/products-need-attention': typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionRoute
  '/catalog-v2/cost-approvals': typeof AuthenticatedTenantCatalogV2CostApprovalsRoute
  '/catalog-v2/needs-attention': typeof AuthenticatedTenantCatalogV2NeedsAttentionRoute
  '/catalog-v2/schedules': typeof AuthenticatedTenantCatalogV2SchedulesRoute
  '/configuration/dashboard': typeof AuthenticatedTenantConfigurationDashboardRoute
  '/configuration/fpc-categories': typeof AuthenticatedTenantConfigurationFpcCategoriesRoute
  '/configuration/gpc-categories': typeof AuthenticatedTenantConfigurationGpcCategoriesRoute
  '/configuration/lily-taxonomy': typeof AuthenticatedTenantConfigurationLilyTaxonomyRoute
  '/configuration/manager': typeof AuthenticatedTenantConfigurationManagerRouteWithChildren
  '/configuration/prompts': typeof AuthenticatedTenantConfigurationPromptsRoute
  '/configuration/treatment': typeof AuthenticatedTenantConfigurationTreatmentRoute
  '/content/attribution': typeof AuthenticatedTenantContentAttributionRoute
  '/content/jobs': typeof AuthenticatedTenantContentJobsRoute
  '/content/model-configuration': typeof AuthenticatedTenantContentModelConfigurationRoute
  '/content/overview': typeof AuthenticatedTenantContentOverviewRoute
  '/content/prompts': typeof AuthenticatedTenantContentPromptsRoute
  '/content/review': typeof AuthenticatedTenantContentReviewRoute
  '/cost-approvals/$workflowId': typeof AuthenticatedTenantCostApprovalsWorkflowIdRoute
  '/deliveries/$runId': typeof AuthenticatedTenantDeliveriesRunIdRoute
  '/deliveries/new': typeof AuthenticatedTenantDeliveriesNewRoute
  '/enrichments/google': typeof AuthenticatedTenantEnrichmentsGoogleRouteWithChildren
  '/enrichments/meta': typeof AuthenticatedTenantEnrichmentsMetaRouteWithChildren
  '/experiments/$id': typeof AuthenticatedTenantExperimentsIdRoute
  '/experiments/create': typeof AuthenticatedTenantExperimentsCreateRouteWithChildren
  '/explorer/catalog-images': typeof AuthenticatedTenantExplorerCatalogImagesRoute
  '/explorer/clickhouse': typeof AuthenticatedTenantExplorerClickhouseRoute
  '/explorer/coverage': typeof AuthenticatedTenantExplorerCoverageRoute
  '/explorer/datalake': typeof AuthenticatedTenantExplorerDatalakeRoute
  '/explorer/keyword-planner': typeof AuthenticatedTenantExplorerKeywordPlannerRoute
  '/explorer/products': typeof AuthenticatedTenantExplorerProductsRoute
  '/exports/$sourceWorkflowId': typeof AuthenticatedTenantExportsSourceWorkflowIdRoute
  '/feed-audit/$id': typeof AuthenticatedTenantFeedAuditIdRoute
  '/feed-audit/create': typeof AuthenticatedTenantFeedAuditCreateRoute
  '/feed-audit/upload': typeof AuthenticatedTenantFeedAuditUploadRoute
  '/integrations/catalog-images': typeof AuthenticatedTenantIntegrationsCatalogImagesRoute
  '/integrations/clickhouse': typeof AuthenticatedTenantIntegrationsClickhouseRoute
  '/integrations/connectors': typeof AuthenticatedTenantIntegrationsConnectorsRoute
  '/integrations/coverage': typeof AuthenticatedTenantIntegrationsCoverageRoute
  '/integrations/datalake': typeof AuthenticatedTenantIntegrationsDatalakeRoute
  '/integrations/health': typeof AuthenticatedTenantIntegrationsHealthRoute
  '/integrations/keyword-planner': typeof AuthenticatedTenantIntegrationsKeywordPlannerRoute
  '/integrations/products': typeof AuthenticatedTenantIntegrationsProductsRoute
  '/integrations/schedules': typeof AuthenticatedTenantIntegrationsSchedulesRoute
  '/integrations/sharing': typeof AuthenticatedTenantIntegrationsSharingRoute
  '/item-setup/calibration-scope': typeof AuthenticatedTenantItemSetupCalibrationScopeRoute
  '/item-setup/catalog-review': typeof AuthenticatedTenantItemSetupCatalogReviewRoute
  '/item-setup/client-verification': typeof AuthenticatedTenantItemSetupClientVerificationRoute
  '/item-setup/content-generation': typeof AuthenticatedTenantItemSetupContentGenerationRoute
  '/item-setup/enrichment-overview': typeof AuthenticatedTenantItemSetupEnrichmentOverviewRoute
  '/item-setup/file-preview': typeof AuthenticatedTenantItemSetupFilePreviewRoute
  '/item-setup/full-catalog-generation': typeof AuthenticatedTenantItemSetupFullCatalogGenerationRoute
  '/item-setup/output-format': typeof AuthenticatedTenantItemSetupOutputFormatRoute
  '/item-setup/pattern-inspector': typeof AuthenticatedTenantItemSetupPatternInspectorRoute
  '/item-setup/quality-report': typeof AuthenticatedTenantItemSetupQualityReportRoute
  '/item-setup/sftp': typeof AuthenticatedTenantItemSetupSftpRoute
  '/item-setup/shopify': typeof AuthenticatedTenantItemSetupShopifyRoute
  '/item-setup/shopify-confirm': typeof AuthenticatedTenantItemSetupShopifyConfirmRoute
  '/item-setup/source-priority': typeof AuthenticatedTenantItemSetupSourcePriorityRoute
  '/item-setup/taxonomy': typeof AuthenticatedTenantItemSetupTaxonomyRoute
  '/item-setup/taxonomy-review': typeof AuthenticatedTenantItemSetupTaxonomyReviewRoute
  '/item-setup/verify': typeof AuthenticatedTenantItemSetupVerifyRoute
  '/onboarding/complete-import': typeof AuthenticatedTenantOnboardingCompleteImportRoute
  '/onboarding/onsite': typeof AuthenticatedTenantOnboardingOnsiteRoute
  '/onboarding/paid-ads': typeof AuthenticatedTenantOnboardingPaidAdsRoute
  '/onboarding/product-overview': typeof AuthenticatedTenantOnboardingProductOverviewRoute
  '/pipeline-runs/$runId': typeof AuthenticatedTenantPipelineRunsRunIdRoute
  '/pipelines/$pipelineId': typeof AuthenticatedTenantPipelinesPipelineIdRoute
  '/platform/audit-logs': typeof AuthenticatedTenantPlatformAuditLogsRoute
  '/platform/batch-review': typeof AuthenticatedTenantPlatformBatchReviewRoute
  '/platform/connectors': typeof AuthenticatedTenantPlatformConnectorsRoute
  '/platform/cost-approval': typeof AuthenticatedTenantPlatformCostApprovalRoute
  '/platform/coverage': typeof AuthenticatedTenantPlatformCoverageRoute
  '/platform/data-management': typeof AuthenticatedTenantPlatformDataManagementRoute
  '/platform/enrichment-limit': typeof AuthenticatedTenantPlatformEnrichmentLimitRoute
  '/platform/feature-flags': typeof AuthenticatedTenantPlatformFeatureFlagsRoute
  '/platform/permissions': typeof AuthenticatedTenantPlatformPermissionsRoute
  '/platform/products': typeof AuthenticatedTenantPlatformProductsRoute
  '/platform/resources': typeof AuthenticatedTenantPlatformResourcesRoute
  '/platform/schedules': typeof AuthenticatedTenantPlatformSchedulesRoute
  '/platform/screens': typeof AuthenticatedTenantPlatformScreensRoute
  '/platform/subsidiaries': typeof AuthenticatedTenantPlatformSubsidiariesRouteWithChildren
  '/platform/users': typeof AuthenticatedTenantPlatformUsersRoute
  '/settings/notification': typeof AuthenticatedTenantSettingsNotificationRoute
  '/subsidiary-preferences/brand-preferences': typeof AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRoute
  '/subsidiary-preferences/constraints': typeof AuthenticatedTenantSubsidiaryPreferencesConstraintsRoute
  '/subsidiary/access-control': typeof AuthenticatedTenantSubsidiaryAccessControlRoute
  '/subsidiary/access-policy': typeof AuthenticatedTenantSubsidiaryAccessPolicyRoute
  '/subsidiary/asset-access': typeof AuthenticatedTenantSubsidiaryAssetAccessRoute
  '/subsidiary/data-sharing': typeof AuthenticatedTenantSubsidiaryDataSharingRoute
  '/subsidiary/products': typeof AuthenticatedTenantSubsidiaryProductsRoute
  '/subsidiary/roles': typeof AuthenticatedTenantSubsidiaryRolesRoute
  '/subsidiary/screen-access': typeof AuthenticatedTenantSubsidiaryScreenAccessRoute
  '/subsidiary/sso': typeof AuthenticatedTenantSubsidiarySsoRoute
  '/subsidiary/subsidiaries': typeof AuthenticatedTenantSubsidiarySubsidiariesRoute
  '/subsidiary/sync-schedule': typeof AuthenticatedTenantSubsidiarySyncScheduleRoute
  '/subsidiary/users': typeof AuthenticatedTenantSubsidiaryUsersRoute
  '/taxonomy/attributes': typeof AuthenticatedTenantTaxonomyAttributesRoute
  '/taxonomy/products': typeof AuthenticatedTenantTaxonomyProductsRoute
  '/taxonomy/uploads': typeof AuthenticatedTenantTaxonomyUploadsRoute
  '/taxonomy/versions': typeof AuthenticatedTenantTaxonomyVersionsRoute
  '/trial/$platform': typeof AuthenticatedTenantTrialPlatformRouteWithChildren
  '/upload-delivery/single': typeof AuthenticatedTenantUploadDeliverySingleRoute
  '/workflow-runs/$runId': typeof AuthenticatedTenantWorkflowRunsRunIdRoute
  '/public/oauth/google-ads/callback': typeof PublicOauthGoogleAdsCallbackRoute
  '/ai-performance/': typeof AuthenticatedTenantAiPerformanceIndexRoute
  '/catalog-enrichment/': typeof AuthenticatedTenantCatalogEnrichmentIndexRoute
  '/catalog-operations/': typeof AuthenticatedTenantCatalogOperationsIndexRoute
  '/catalog-v2/': typeof AuthenticatedTenantCatalogV2IndexRoute
  '/configuration/': typeof AuthenticatedTenantConfigurationIndexRoute
  '/content/': typeof AuthenticatedTenantContentIndexRoute
  '/deliveries/': typeof AuthenticatedTenantDeliveriesIndexRoute
  '/experiments/': typeof AuthenticatedTenantExperimentsIndexRoute
  '/explorer/': typeof AuthenticatedTenantExplorerIndexRoute
  '/feed-audit/': typeof AuthenticatedTenantFeedAuditIndexRoute
  '/integrations/': typeof AuthenticatedTenantIntegrationsIndexRoute
  '/item-setup/': typeof AuthenticatedTenantItemSetupIndexRoute
  '/onboarding/': typeof AuthenticatedTenantOnboardingIndexRoute
  '/platform/': typeof AuthenticatedTenantPlatformIndexRoute
  '/product-catalog/': typeof AuthenticatedTenantProductCatalogIndexRoute
  '/subsidiary-preferences/': typeof AuthenticatedTenantSubsidiaryPreferencesIndexRoute
  '/subsidiary/': typeof AuthenticatedTenantSubsidiaryIndexRoute
  '/taxonomy/': typeof AuthenticatedTenantTaxonomyIndexRoute
  '/workflow-runs/': typeof AuthenticatedTenantWorkflowRunsIndexRoute
  '/catalog-enrichment/runs/$runId': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteWithChildren
  '/catalog-v2/runs/$runId': typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRouteWithChildren
  '/catalog-enrichment/experiments/$experimentId': typeof AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRoute
  '/catalog-enrichment/experiments/new': typeof AuthenticatedTenantCatalogEnrichmentExperimentsNewRoute
  '/catalog-enrichment/feed-audit/new': typeof AuthenticatedTenantCatalogEnrichmentFeedAuditNewRoute
  '/catalog-enrichment/feed-products/$feedProductId': typeof AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRoute
  '/catalog-enrichment/products/$productId': typeof AuthenticatedTenantCatalogEnrichmentProductsProductIdRoute
  '/catalog-enrichment/runs/new': typeof AuthenticatedTenantCatalogEnrichmentRunsNewRoute
  '/catalog-enrichment/schedules/$scheduleId': typeof AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRoute
  '/catalog-operations/$batchId/compare-delivery': typeof AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRoute
  '/catalog-operations/$batchId/deliver': typeof AuthenticatedTenantCatalogOperationsBatchIdDeliverRoute
  '/catalog-operations/$batchId/products': typeof AuthenticatedTenantCatalogOperationsBatchIdProductsRoute
  '/catalog-operations/products-need-attention/$productId': typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRoute
  '/catalog-v2/experiments/$experimentId': typeof AuthenticatedTenantCatalogV2ExperimentsExperimentIdRoute
  '/catalog-v2/experiments/new': typeof AuthenticatedTenantCatalogV2ExperimentsNewRoute
  '/catalog-v2/feed-audit/new': typeof AuthenticatedTenantCatalogV2FeedAuditNewRoute
  '/catalog-v2/feed-products/$feedProductId': typeof AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRoute
  '/catalog-v2/products/$productId': typeof AuthenticatedTenantCatalogV2ProductsProductIdRoute
  '/catalog-v2/runs/new': typeof AuthenticatedTenantCatalogV2RunsNewRoute
  '/configuration/manager/audit-trail': typeof AuthenticatedTenantConfigurationManagerAuditTrailRoute
  '/configuration/manager/parameters': typeof AuthenticatedTenantConfigurationManagerParametersRoute
  '/content/jobs/how-it-works': typeof AuthenticatedTenantContentJobsHowItWorksRoute
  '/content/runs/$runId': typeof AuthenticatedTenantContentRunsRunIdRoute
  '/content/runs/how-it-works': typeof AuthenticatedTenantContentRunsHowItWorksRoute
  '/content/settings/instructions': typeof AuthenticatedTenantContentSettingsInstructionsRoute
  '/content/settings/models': typeof AuthenticatedTenantContentSettingsModelsRoute
  '/content/settings/vocabulary': typeof AuthenticatedTenantContentSettingsVocabularyRoute
  '/content/catalog/$jobId': typeof AuthenticatedTenantContentCatalogJobIdRoute
  '/content/catalog/new': typeof AuthenticatedTenantContentCatalogNewRoute
  '/content/qc/$runId': typeof AuthenticatedTenantContentQcRunIdRoute
  '/content/qc/new': typeof AuthenticatedTenantContentQcNewRoute
  '/deliveries/connections/$connectionId': typeof AuthenticatedTenantDeliveriesConnectionsConnectionIdRoute
  '/enrichments/google/product-selection': typeof AuthenticatedTenantEnrichmentsGoogleProductSelectionRoute
  '/enrichments/meta/product-selection': typeof AuthenticatedTenantEnrichmentsMetaProductSelectionRoute
  '/experiments/$expId/content-enrichment': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteWithChildren
  '/experiments/create/configure': typeof AuthenticatedTenantExperimentsCreateConfigureRoute
  '/experiments/create/info': typeof AuthenticatedTenantExperimentsCreateInfoRoute
  '/explorer/data-quality/compare': typeof AuthenticatedTenantExplorerDataQualityCompareRoute
  '/explorer/datalake/upload': typeof AuthenticatedTenantExplorerDatalakeUploadRoute
  '/exports/catalog/new': typeof AuthenticatedTenantExportsCatalogNewRoute
  '/integrations/connections/new': typeof AuthenticatedTenantIntegrationsConnectionsNewRoute
  '/integrations/data-quality/compare': typeof AuthenticatedTenantIntegrationsDataQualityCompareRoute
  '/integrations/datalake/upload': typeof AuthenticatedTenantIntegrationsDatalakeUploadRoute
  '/oauth/google-ads/callback': typeof AuthenticatedTenantOauthGoogleAdsCallbackRoute
  '/onboarding/integration/google': typeof AuthenticatedTenantOnboardingIntegrationGoogleRouteWithChildren
  '/onboarding/integration/meta': typeof AuthenticatedTenantOnboardingIntegrationMetaRouteWithChildren
  '/platform/service-auth/audit': typeof AuthenticatedTenantPlatformServiceAuthAuditRoute
  '/platform/service-auth/discovery': typeof AuthenticatedTenantPlatformServiceAuthDiscoveryRoute
  '/platform/subsidiaries/$subsidiaryId': typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteWithChildren
  '/platform/subsidiaries/onboarding': typeof AuthenticatedTenantPlatformSubsidiariesOnboardingRoute
  '/platform/transformers/$transformerId': typeof AuthenticatedTenantPlatformTransformersTransformerIdRoute
  '/trial/$platform/create': typeof AuthenticatedTenantTrialPlatformCreateRoute
  '/trial/$platform/enrichment': typeof AuthenticatedTenantTrialPlatformEnrichmentRouteWithChildren
  '/catalog-enrichment/experiments/': typeof AuthenticatedTenantCatalogEnrichmentExperimentsIndexRoute
  '/catalog-enrichment/feed-audit/': typeof AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRoute
  '/catalog-enrichment/products/': typeof AuthenticatedTenantCatalogEnrichmentProductsIndexRoute
  '/catalog-enrichment/runs/': typeof AuthenticatedTenantCatalogEnrichmentRunsIndexRoute
  '/catalog-enrichment/schedules/': typeof AuthenticatedTenantCatalogEnrichmentSchedulesIndexRoute
  '/catalog-v2/experiments/': typeof AuthenticatedTenantCatalogV2ExperimentsIndexRoute
  '/catalog-v2/feed-audit/': typeof AuthenticatedTenantCatalogV2FeedAuditIndexRoute
  '/catalog-v2/products/': typeof AuthenticatedTenantCatalogV2ProductsIndexRoute
  '/catalog-v2/runs/': typeof AuthenticatedTenantCatalogV2RunsIndexRoute
  '/configuration/manager/': typeof AuthenticatedTenantConfigurationManagerIndexRoute
  '/content/qc/': typeof AuthenticatedTenantContentQcIndexRoute
  '/content/runs/': typeof AuthenticatedTenantContentRunsIndexRoute
  '/experiments/create/': typeof AuthenticatedTenantExperimentsCreateIndexRoute
  '/explorer/data-quality/': typeof AuthenticatedTenantExplorerDataQualityIndexRoute
  '/exports/catalog/': typeof AuthenticatedTenantExportsCatalogIndexRoute
  '/integrations/connections/': typeof AuthenticatedTenantIntegrationsConnectionsIndexRoute
  '/integrations/data-quality/': typeof AuthenticatedTenantIntegrationsDataQualityIndexRoute
  '/integrations/pipelines/': typeof AuthenticatedTenantIntegrationsPipelinesIndexRoute
  '/integrations/upload-delivery/': typeof AuthenticatedTenantIntegrationsUploadDeliveryIndexRoute
  '/platform/service-auth/': typeof AuthenticatedTenantPlatformServiceAuthIndexRoute
  '/platform/subsidiaries/': typeof AuthenticatedTenantPlatformSubsidiariesIndexRoute
  '/platform/transformers/': typeof AuthenticatedTenantPlatformTransformersIndexRoute
  '/catalog-enrichment/runs/$runId/activity': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRoute
  '/catalog-enrichment/runs/$runId/approval': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRoute
  '/catalog-enrichment/runs/$runId/compare': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRoute
  '/catalog-enrichment/runs/$runId/content-results': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRoute
  '/catalog-enrichment/runs/$runId/cost': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRoute
  '/catalog-enrichment/runs/$runId/delivery': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRoute
  '/catalog-enrichment/runs/$runId/gate': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRoute
  '/catalog-enrichment/runs/$runId/images': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRoute
  '/catalog-enrichment/runs/$runId/insights': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRoute
  '/catalog-enrichment/runs/$runId/issues': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRoute
  '/catalog-enrichment/runs/$runId/lineage': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRoute
  '/catalog-enrichment/runs/$runId/quality-checks': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRoute
  '/catalog-enrichment/runs/$runId/recovery': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRoute
  '/catalog-operations/$batchId/products/$productId': typeof AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRoute
  '/catalog-v2/runs/$runId/approval': typeof AuthenticatedTenantCatalogV2RunsRunIdApprovalRoute
  '/catalog-v2/runs/$runId/compare': typeof AuthenticatedTenantCatalogV2RunsRunIdCompareRoute
  '/catalog-v2/runs/$runId/content-results': typeof AuthenticatedTenantCatalogV2RunsRunIdContentResultsRoute
  '/catalog-v2/runs/$runId/gate': typeof AuthenticatedTenantCatalogV2RunsRunIdGateRoute
  '/catalog-v2/runs/$runId/images': typeof AuthenticatedTenantCatalogV2RunsRunIdImagesRoute
  '/catalog-v2/runs/$runId/insights': typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsRoute
  '/catalog-v2/runs/$runId/issues': typeof AuthenticatedTenantCatalogV2RunsRunIdIssuesRoute
  '/catalog-v2/runs/$runId/lineage': typeof AuthenticatedTenantCatalogV2RunsRunIdLineageRoute
  '/catalog-v2/runs/$runId/quality-checks': typeof AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRoute
  '/catalog-v2/runs/$runId/recovery': typeof AuthenticatedTenantCatalogV2RunsRunIdRecoveryRoute
  '/content/runs/$runId/review': typeof AuthenticatedTenantContentRunsRunIdReviewRoute
  '/enrichments/google/content-enrichment/$batchId': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteWithChildren
  '/enrichments/meta/content-enrichment/$batchId': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteWithChildren
  '/experiments/$expId/content-enrichment/delivery': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRoute
  '/experiments/$expId/content-enrichment/full': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRoute
  '/experiments/$expId/content-enrichment/groups': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRoute
  '/experiments/$expId/content-enrichment/overview': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRoute
  '/experiments/$expId/content-enrichment/review': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRoute
  '/exports/catalog/exports/$exportId': typeof AuthenticatedTenantExportsCatalogExportsExportIdRoute
  '/exports/catalog/profiles/$profileId': typeof AuthenticatedTenantExportsCatalogProfilesProfileIdRoute
  '/exports/catalog/runs/$runId': typeof AuthenticatedTenantExportsCatalogRunsRunIdRoute
  '/integrations/connections/connect/$connectorCode': typeof AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRoute
  '/onboarding/integration/google/google-ads': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteWithChildren
  '/onboarding/integration/google/google-analytics': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteWithChildren
  '/onboarding/integration/google/google-merchant-center': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRoute
  '/onboarding/integration/google/import-catalog': typeof AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRoute
  '/onboarding/integration/google/sftp': typeof AuthenticatedTenantOnboardingIntegrationGoogleSftpRoute
  '/onboarding/integration/google/shopify': typeof AuthenticatedTenantOnboardingIntegrationGoogleShopifyRoute
  '/onboarding/integration/meta/complete-import': typeof AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRoute
  '/onboarding/integration/meta/import-catalog': typeof AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRoute
  '/onboarding/integration/meta/meta-commerce-manager': typeof AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRoute
  '/onboarding/integration/meta/product-overview': typeof AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRoute
  '/onboarding/integration/meta/sftp': typeof AuthenticatedTenantOnboardingIntegrationMetaSftpRoute
  '/platform/service-auth/users/$id': typeof AuthenticatedTenantPlatformServiceAuthUsersIdRoute
  '/platform/subsidiaries/$subsidiaryId/products': typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRoute
  '/trial/$platform/enrichment/$id': typeof AuthenticatedTenantTrialPlatformEnrichmentIdRoute
  '/catalog-enrichment/runs/$runId/': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRoute
  '/catalog-v2/runs/$runId/': typeof AuthenticatedTenantCatalogV2RunsRunIdIndexRoute
  '/experiments/$expId/content-enrichment/': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRoute
  '/onboarding/integration/google/': typeof AuthenticatedTenantOnboardingIntegrationGoogleIndexRoute
  '/onboarding/integration/meta/': typeof AuthenticatedTenantOnboardingIntegrationMetaIndexRoute
  '/platform/service-auth/users/': typeof AuthenticatedTenantPlatformServiceAuthUsersIndexRoute
  '/trial/$platform/enrichment/': typeof AuthenticatedTenantTrialPlatformEnrichmentIndexRoute
  '/catalog-enrichment/runs/$runId/insights/products': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRoute
  '/catalog-enrichment/runs/$runId/products/$productId': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRoute
  '/catalog-v2/runs/$runId/insights/products': typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRoute
  '/catalog-v2/runs/$runId/products/$productId': typeof AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRoute
  '/content/runs/$runId/products/$productId': typeof AuthenticatedTenantContentRunsRunIdProductsProductIdRoute
  '/enrichments/google/content-enrichment/$batchId/delivery': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRoute
  '/enrichments/google/content-enrichment/$batchId/full': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRoute
  '/enrichments/google/content-enrichment/$batchId/overview': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRoute
  '/enrichments/google/content-enrichment/$batchId/review': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRoute
  '/enrichments/google/content-enrichment/$batchId/deliver': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRoute
  '/enrichments/meta/content-enrichment/$batchId/delivery': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRoute
  '/enrichments/meta/content-enrichment/$batchId/full': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRoute
  '/enrichments/meta/content-enrichment/$batchId/overview': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRoute
  '/enrichments/meta/content-enrichment/$batchId/review': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRoute
  '/enrichments/meta/content-enrichment/$batchId/deliver': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRoute
  '/explorer/data-quality/product/$connectionId/$externalId': typeof AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRoute
  '/integrations/data-quality/product/$connectionId/$externalId': typeof AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRoute
  '/onboarding/integration/google/adobe-analytics/extraction': typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRoute
  '/onboarding/integration/google/google-ads/confirmation': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRoute
  '/onboarding/integration/google/google-ads/select-account': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRoute
  '/onboarding/integration/google/google-analytics/data-preview': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRoute
  '/onboarding/integration/google/google-analytics/pick-property': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRoute
  '/catalog-enrichment/runs/$runId/products/': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRoute
  '/catalog-v2/runs/$runId/products/': typeof AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRoute
  '/enrichments/google/content-enrichment/$batchId/': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRoute
  '/enrichments/meta/content-enrichment/$batchId/': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRoute
  '/onboarding/integration/google/adobe-analytics/': typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRoute
  '/onboarding/integration/google/google-ads/': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRoute
  '/onboarding/integration/google/google-analytics/': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/$': typeof AuthenticatedSplatRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/upload-delivery': typeof AuthenticatedTenantUploadDeliveryRouteRouteWithChildren
  '/access-denied': typeof AuthenticatedTenantAccessDeniedRoute
  '/catalog-manager': typeof AuthenticatedTenantCatalogManagerRoute
  '/cost-approvals': typeof AuthenticatedTenantCostApprovalsRoute
  '/coverage': typeof AuthenticatedTenantCoverageRoute
  '/dashboard': typeof AuthenticatedTenantDashboardRoute
  '/history': typeof AuthenticatedTenantHistoryRoute
  '/home': typeof AuthenticatedTenantHomeRoute
  '/lily-agent': typeof AuthenticatedTenantLilyAgentRoute
  '/notification': typeof AuthenticatedTenantNotificationRoute
  '/product-not-enrolled': typeof AuthenticatedTenantProductNotEnrolledRoute
  '/schedules': typeof AuthenticatedTenantSchedulesRoute
  '/settings': typeof AuthenticatedTenantSettingsRoute
  '/trial': typeof AuthenticatedTenantTrialRouteWithChildren
  '/auth/$provider/callback': typeof AuthProviderCallbackRoute
  '/connector/$token/done': typeof ConnectorTokenDoneRoute
  '/connector/$token/select': typeof ConnectorTokenSelectRoute
  '/connector/$token': typeof ConnectorTokenIndexRoute
  '/ai-performance/$workflowId': typeof AuthenticatedTenantAiPerformanceWorkflowIdRoute
  '/catalog-enrichment/cost-approvals': typeof AuthenticatedTenantCatalogEnrichmentCostApprovalsRoute
  '/catalog-enrichment/needs-attention': typeof AuthenticatedTenantCatalogEnrichmentNeedsAttentionRoute
  '/catalog-operations/$batchId': typeof AuthenticatedTenantCatalogOperationsBatchIdRoute
  '/catalog-operations/products-need-attention': typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionRoute
  '/catalog-v2/cost-approvals': typeof AuthenticatedTenantCatalogV2CostApprovalsRoute
  '/catalog-v2/needs-attention': typeof AuthenticatedTenantCatalogV2NeedsAttentionRoute
  '/catalog-v2/schedules': typeof AuthenticatedTenantCatalogV2SchedulesRoute
  '/configuration/dashboard': typeof AuthenticatedTenantConfigurationDashboardRoute
  '/configuration/fpc-categories': typeof AuthenticatedTenantConfigurationFpcCategoriesRoute
  '/configuration/gpc-categories': typeof AuthenticatedTenantConfigurationGpcCategoriesRoute
  '/configuration/lily-taxonomy': typeof AuthenticatedTenantConfigurationLilyTaxonomyRoute
  '/configuration/prompts': typeof AuthenticatedTenantConfigurationPromptsRoute
  '/configuration/treatment': typeof AuthenticatedTenantConfigurationTreatmentRoute
  '/content/attribution': typeof AuthenticatedTenantContentAttributionRoute
  '/content/jobs': typeof AuthenticatedTenantContentJobsRoute
  '/content/model-configuration': typeof AuthenticatedTenantContentModelConfigurationRoute
  '/content/overview': typeof AuthenticatedTenantContentOverviewRoute
  '/content/prompts': typeof AuthenticatedTenantContentPromptsRoute
  '/content/review': typeof AuthenticatedTenantContentReviewRoute
  '/cost-approvals/$workflowId': typeof AuthenticatedTenantCostApprovalsWorkflowIdRoute
  '/deliveries/$runId': typeof AuthenticatedTenantDeliveriesRunIdRoute
  '/deliveries/new': typeof AuthenticatedTenantDeliveriesNewRoute
  '/enrichments/google': typeof AuthenticatedTenantEnrichmentsGoogleRouteWithChildren
  '/enrichments/meta': typeof AuthenticatedTenantEnrichmentsMetaRouteWithChildren
  '/experiments/$id': typeof AuthenticatedTenantExperimentsIdRoute
  '/explorer/catalog-images': typeof AuthenticatedTenantExplorerCatalogImagesRoute
  '/explorer/clickhouse': typeof AuthenticatedTenantExplorerClickhouseRoute
  '/explorer/coverage': typeof AuthenticatedTenantExplorerCoverageRoute
  '/explorer/datalake': typeof AuthenticatedTenantExplorerDatalakeRoute
  '/explorer/keyword-planner': typeof AuthenticatedTenantExplorerKeywordPlannerRoute
  '/explorer/products': typeof AuthenticatedTenantExplorerProductsRoute
  '/exports/$sourceWorkflowId': typeof AuthenticatedTenantExportsSourceWorkflowIdRoute
  '/feed-audit/$id': typeof AuthenticatedTenantFeedAuditIdRoute
  '/feed-audit/create': typeof AuthenticatedTenantFeedAuditCreateRoute
  '/feed-audit/upload': typeof AuthenticatedTenantFeedAuditUploadRoute
  '/integrations/catalog-images': typeof AuthenticatedTenantIntegrationsCatalogImagesRoute
  '/integrations/clickhouse': typeof AuthenticatedTenantIntegrationsClickhouseRoute
  '/integrations/connectors': typeof AuthenticatedTenantIntegrationsConnectorsRoute
  '/integrations/coverage': typeof AuthenticatedTenantIntegrationsCoverageRoute
  '/integrations/datalake': typeof AuthenticatedTenantIntegrationsDatalakeRoute
  '/integrations/health': typeof AuthenticatedTenantIntegrationsHealthRoute
  '/integrations/keyword-planner': typeof AuthenticatedTenantIntegrationsKeywordPlannerRoute
  '/integrations/products': typeof AuthenticatedTenantIntegrationsProductsRoute
  '/integrations/schedules': typeof AuthenticatedTenantIntegrationsSchedulesRoute
  '/integrations/sharing': typeof AuthenticatedTenantIntegrationsSharingRoute
  '/item-setup/calibration-scope': typeof AuthenticatedTenantItemSetupCalibrationScopeRoute
  '/item-setup/catalog-review': typeof AuthenticatedTenantItemSetupCatalogReviewRoute
  '/item-setup/client-verification': typeof AuthenticatedTenantItemSetupClientVerificationRoute
  '/item-setup/content-generation': typeof AuthenticatedTenantItemSetupContentGenerationRoute
  '/item-setup/enrichment-overview': typeof AuthenticatedTenantItemSetupEnrichmentOverviewRoute
  '/item-setup/file-preview': typeof AuthenticatedTenantItemSetupFilePreviewRoute
  '/item-setup/full-catalog-generation': typeof AuthenticatedTenantItemSetupFullCatalogGenerationRoute
  '/item-setup/output-format': typeof AuthenticatedTenantItemSetupOutputFormatRoute
  '/item-setup/pattern-inspector': typeof AuthenticatedTenantItemSetupPatternInspectorRoute
  '/item-setup/quality-report': typeof AuthenticatedTenantItemSetupQualityReportRoute
  '/item-setup/sftp': typeof AuthenticatedTenantItemSetupSftpRoute
  '/item-setup/shopify': typeof AuthenticatedTenantItemSetupShopifyRoute
  '/item-setup/shopify-confirm': typeof AuthenticatedTenantItemSetupShopifyConfirmRoute
  '/item-setup/source-priority': typeof AuthenticatedTenantItemSetupSourcePriorityRoute
  '/item-setup/taxonomy': typeof AuthenticatedTenantItemSetupTaxonomyRoute
  '/item-setup/taxonomy-review': typeof AuthenticatedTenantItemSetupTaxonomyReviewRoute
  '/item-setup/verify': typeof AuthenticatedTenantItemSetupVerifyRoute
  '/onboarding/complete-import': typeof AuthenticatedTenantOnboardingCompleteImportRoute
  '/onboarding/onsite': typeof AuthenticatedTenantOnboardingOnsiteRoute
  '/onboarding/paid-ads': typeof AuthenticatedTenantOnboardingPaidAdsRoute
  '/onboarding/product-overview': typeof AuthenticatedTenantOnboardingProductOverviewRoute
  '/pipeline-runs/$runId': typeof AuthenticatedTenantPipelineRunsRunIdRoute
  '/pipelines/$pipelineId': typeof AuthenticatedTenantPipelinesPipelineIdRoute
  '/platform/audit-logs': typeof AuthenticatedTenantPlatformAuditLogsRoute
  '/platform/batch-review': typeof AuthenticatedTenantPlatformBatchReviewRoute
  '/platform/connectors': typeof AuthenticatedTenantPlatformConnectorsRoute
  '/platform/cost-approval': typeof AuthenticatedTenantPlatformCostApprovalRoute
  '/platform/coverage': typeof AuthenticatedTenantPlatformCoverageRoute
  '/platform/data-management': typeof AuthenticatedTenantPlatformDataManagementRoute
  '/platform/enrichment-limit': typeof AuthenticatedTenantPlatformEnrichmentLimitRoute
  '/platform/feature-flags': typeof AuthenticatedTenantPlatformFeatureFlagsRoute
  '/platform/permissions': typeof AuthenticatedTenantPlatformPermissionsRoute
  '/platform/products': typeof AuthenticatedTenantPlatformProductsRoute
  '/platform/resources': typeof AuthenticatedTenantPlatformResourcesRoute
  '/platform/schedules': typeof AuthenticatedTenantPlatformSchedulesRoute
  '/platform/screens': typeof AuthenticatedTenantPlatformScreensRoute
  '/platform/users': typeof AuthenticatedTenantPlatformUsersRoute
  '/settings/notification': typeof AuthenticatedTenantSettingsNotificationRoute
  '/subsidiary-preferences/brand-preferences': typeof AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRoute
  '/subsidiary-preferences/constraints': typeof AuthenticatedTenantSubsidiaryPreferencesConstraintsRoute
  '/subsidiary/access-control': typeof AuthenticatedTenantSubsidiaryAccessControlRoute
  '/subsidiary/access-policy': typeof AuthenticatedTenantSubsidiaryAccessPolicyRoute
  '/subsidiary/asset-access': typeof AuthenticatedTenantSubsidiaryAssetAccessRoute
  '/subsidiary/data-sharing': typeof AuthenticatedTenantSubsidiaryDataSharingRoute
  '/subsidiary/products': typeof AuthenticatedTenantSubsidiaryProductsRoute
  '/subsidiary/roles': typeof AuthenticatedTenantSubsidiaryRolesRoute
  '/subsidiary/screen-access': typeof AuthenticatedTenantSubsidiaryScreenAccessRoute
  '/subsidiary/sso': typeof AuthenticatedTenantSubsidiarySsoRoute
  '/subsidiary/subsidiaries': typeof AuthenticatedTenantSubsidiarySubsidiariesRoute
  '/subsidiary/sync-schedule': typeof AuthenticatedTenantSubsidiarySyncScheduleRoute
  '/subsidiary/users': typeof AuthenticatedTenantSubsidiaryUsersRoute
  '/taxonomy/attributes': typeof AuthenticatedTenantTaxonomyAttributesRoute
  '/taxonomy/products': typeof AuthenticatedTenantTaxonomyProductsRoute
  '/taxonomy/uploads': typeof AuthenticatedTenantTaxonomyUploadsRoute
  '/taxonomy/versions': typeof AuthenticatedTenantTaxonomyVersionsRoute
  '/trial/$platform': typeof AuthenticatedTenantTrialPlatformRouteWithChildren
  '/upload-delivery/single': typeof AuthenticatedTenantUploadDeliverySingleRoute
  '/workflow-runs/$runId': typeof AuthenticatedTenantWorkflowRunsRunIdRoute
  '/public/oauth/google-ads/callback': typeof PublicOauthGoogleAdsCallbackRoute
  '/ai-performance': typeof AuthenticatedTenantAiPerformanceIndexRoute
  '/catalog-enrichment': typeof AuthenticatedTenantCatalogEnrichmentIndexRoute
  '/catalog-operations': typeof AuthenticatedTenantCatalogOperationsIndexRoute
  '/catalog-v2': typeof AuthenticatedTenantCatalogV2IndexRoute
  '/configuration': typeof AuthenticatedTenantConfigurationIndexRoute
  '/content': typeof AuthenticatedTenantContentIndexRoute
  '/deliveries': typeof AuthenticatedTenantDeliveriesIndexRoute
  '/experiments': typeof AuthenticatedTenantExperimentsIndexRoute
  '/explorer': typeof AuthenticatedTenantExplorerIndexRoute
  '/feed-audit': typeof AuthenticatedTenantFeedAuditIndexRoute
  '/integrations': typeof AuthenticatedTenantIntegrationsIndexRoute
  '/item-setup': typeof AuthenticatedTenantItemSetupIndexRoute
  '/onboarding': typeof AuthenticatedTenantOnboardingIndexRoute
  '/platform': typeof AuthenticatedTenantPlatformIndexRoute
  '/product-catalog': typeof AuthenticatedTenantProductCatalogIndexRoute
  '/subsidiary-preferences': typeof AuthenticatedTenantSubsidiaryPreferencesIndexRoute
  '/subsidiary': typeof AuthenticatedTenantSubsidiaryIndexRoute
  '/taxonomy': typeof AuthenticatedTenantTaxonomyIndexRoute
  '/workflow-runs': typeof AuthenticatedTenantWorkflowRunsIndexRoute
  '/catalog-enrichment/experiments/$experimentId': typeof AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRoute
  '/catalog-enrichment/experiments/new': typeof AuthenticatedTenantCatalogEnrichmentExperimentsNewRoute
  '/catalog-enrichment/feed-audit/new': typeof AuthenticatedTenantCatalogEnrichmentFeedAuditNewRoute
  '/catalog-enrichment/feed-products/$feedProductId': typeof AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRoute
  '/catalog-enrichment/products/$productId': typeof AuthenticatedTenantCatalogEnrichmentProductsProductIdRoute
  '/catalog-enrichment/runs/new': typeof AuthenticatedTenantCatalogEnrichmentRunsNewRoute
  '/catalog-enrichment/schedules/$scheduleId': typeof AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRoute
  '/catalog-operations/$batchId/compare-delivery': typeof AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRoute
  '/catalog-operations/$batchId/deliver': typeof AuthenticatedTenantCatalogOperationsBatchIdDeliverRoute
  '/catalog-operations/$batchId/products': typeof AuthenticatedTenantCatalogOperationsBatchIdProductsRoute
  '/catalog-operations/products-need-attention/$productId': typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRoute
  '/catalog-v2/experiments/$experimentId': typeof AuthenticatedTenantCatalogV2ExperimentsExperimentIdRoute
  '/catalog-v2/experiments/new': typeof AuthenticatedTenantCatalogV2ExperimentsNewRoute
  '/catalog-v2/feed-audit/new': typeof AuthenticatedTenantCatalogV2FeedAuditNewRoute
  '/catalog-v2/feed-products/$feedProductId': typeof AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRoute
  '/catalog-v2/products/$productId': typeof AuthenticatedTenantCatalogV2ProductsProductIdRoute
  '/catalog-v2/runs/new': typeof AuthenticatedTenantCatalogV2RunsNewRoute
  '/configuration/manager/audit-trail': typeof AuthenticatedTenantConfigurationManagerAuditTrailRoute
  '/configuration/manager/parameters': typeof AuthenticatedTenantConfigurationManagerParametersRoute
  '/content/jobs/how-it-works': typeof AuthenticatedTenantContentJobsHowItWorksRoute
  '/content/runs/$runId': typeof AuthenticatedTenantContentRunsRunIdRoute
  '/content/runs/how-it-works': typeof AuthenticatedTenantContentRunsHowItWorksRoute
  '/content/settings/instructions': typeof AuthenticatedTenantContentSettingsInstructionsRoute
  '/content/settings/models': typeof AuthenticatedTenantContentSettingsModelsRoute
  '/content/settings/vocabulary': typeof AuthenticatedTenantContentSettingsVocabularyRoute
  '/content/catalog/$jobId': typeof AuthenticatedTenantContentCatalogJobIdRoute
  '/content/catalog/new': typeof AuthenticatedTenantContentCatalogNewRoute
  '/content/qc/$runId': typeof AuthenticatedTenantContentQcRunIdRoute
  '/content/qc/new': typeof AuthenticatedTenantContentQcNewRoute
  '/deliveries/connections/$connectionId': typeof AuthenticatedTenantDeliveriesConnectionsConnectionIdRoute
  '/enrichments/google/product-selection': typeof AuthenticatedTenantEnrichmentsGoogleProductSelectionRoute
  '/enrichments/meta/product-selection': typeof AuthenticatedTenantEnrichmentsMetaProductSelectionRoute
  '/experiments/create/configure': typeof AuthenticatedTenantExperimentsCreateConfigureRoute
  '/experiments/create/info': typeof AuthenticatedTenantExperimentsCreateInfoRoute
  '/explorer/data-quality/compare': typeof AuthenticatedTenantExplorerDataQualityCompareRoute
  '/explorer/datalake/upload': typeof AuthenticatedTenantExplorerDatalakeUploadRoute
  '/exports/catalog/new': typeof AuthenticatedTenantExportsCatalogNewRoute
  '/integrations/connections/new': typeof AuthenticatedTenantIntegrationsConnectionsNewRoute
  '/integrations/data-quality/compare': typeof AuthenticatedTenantIntegrationsDataQualityCompareRoute
  '/integrations/datalake/upload': typeof AuthenticatedTenantIntegrationsDatalakeUploadRoute
  '/oauth/google-ads/callback': typeof AuthenticatedTenantOauthGoogleAdsCallbackRoute
  '/platform/service-auth/audit': typeof AuthenticatedTenantPlatformServiceAuthAuditRoute
  '/platform/service-auth/discovery': typeof AuthenticatedTenantPlatformServiceAuthDiscoveryRoute
  '/platform/subsidiaries/$subsidiaryId': typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteWithChildren
  '/platform/subsidiaries/onboarding': typeof AuthenticatedTenantPlatformSubsidiariesOnboardingRoute
  '/platform/transformers/$transformerId': typeof AuthenticatedTenantPlatformTransformersTransformerIdRoute
  '/trial/$platform/create': typeof AuthenticatedTenantTrialPlatformCreateRoute
  '/catalog-enrichment/experiments': typeof AuthenticatedTenantCatalogEnrichmentExperimentsIndexRoute
  '/catalog-enrichment/feed-audit': typeof AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRoute
  '/catalog-enrichment/products': typeof AuthenticatedTenantCatalogEnrichmentProductsIndexRoute
  '/catalog-enrichment/runs': typeof AuthenticatedTenantCatalogEnrichmentRunsIndexRoute
  '/catalog-enrichment/schedules': typeof AuthenticatedTenantCatalogEnrichmentSchedulesIndexRoute
  '/catalog-v2/experiments': typeof AuthenticatedTenantCatalogV2ExperimentsIndexRoute
  '/catalog-v2/feed-audit': typeof AuthenticatedTenantCatalogV2FeedAuditIndexRoute
  '/catalog-v2/products': typeof AuthenticatedTenantCatalogV2ProductsIndexRoute
  '/catalog-v2/runs': typeof AuthenticatedTenantCatalogV2RunsIndexRoute
  '/configuration/manager': typeof AuthenticatedTenantConfigurationManagerIndexRoute
  '/content/qc': typeof AuthenticatedTenantContentQcIndexRoute
  '/content/runs': typeof AuthenticatedTenantContentRunsIndexRoute
  '/experiments/create': typeof AuthenticatedTenantExperimentsCreateIndexRoute
  '/explorer/data-quality': typeof AuthenticatedTenantExplorerDataQualityIndexRoute
  '/exports/catalog': typeof AuthenticatedTenantExportsCatalogIndexRoute
  '/integrations/connections': typeof AuthenticatedTenantIntegrationsConnectionsIndexRoute
  '/integrations/data-quality': typeof AuthenticatedTenantIntegrationsDataQualityIndexRoute
  '/integrations/pipelines': typeof AuthenticatedTenantIntegrationsPipelinesIndexRoute
  '/integrations/upload-delivery': typeof AuthenticatedTenantIntegrationsUploadDeliveryIndexRoute
  '/platform/service-auth': typeof AuthenticatedTenantPlatformServiceAuthIndexRoute
  '/platform/subsidiaries': typeof AuthenticatedTenantPlatformSubsidiariesIndexRoute
  '/platform/transformers': typeof AuthenticatedTenantPlatformTransformersIndexRoute
  '/catalog-enrichment/runs/$runId/activity': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRoute
  '/catalog-enrichment/runs/$runId/approval': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRoute
  '/catalog-enrichment/runs/$runId/compare': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRoute
  '/catalog-enrichment/runs/$runId/content-results': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRoute
  '/catalog-enrichment/runs/$runId/cost': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRoute
  '/catalog-enrichment/runs/$runId/delivery': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRoute
  '/catalog-enrichment/runs/$runId/gate': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRoute
  '/catalog-enrichment/runs/$runId/images': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRoute
  '/catalog-enrichment/runs/$runId/insights': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRoute
  '/catalog-enrichment/runs/$runId/issues': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRoute
  '/catalog-enrichment/runs/$runId/lineage': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRoute
  '/catalog-enrichment/runs/$runId/quality-checks': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRoute
  '/catalog-enrichment/runs/$runId/recovery': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRoute
  '/catalog-operations/$batchId/products/$productId': typeof AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRoute
  '/catalog-v2/runs/$runId/approval': typeof AuthenticatedTenantCatalogV2RunsRunIdApprovalRoute
  '/catalog-v2/runs/$runId/compare': typeof AuthenticatedTenantCatalogV2RunsRunIdCompareRoute
  '/catalog-v2/runs/$runId/content-results': typeof AuthenticatedTenantCatalogV2RunsRunIdContentResultsRoute
  '/catalog-v2/runs/$runId/gate': typeof AuthenticatedTenantCatalogV2RunsRunIdGateRoute
  '/catalog-v2/runs/$runId/images': typeof AuthenticatedTenantCatalogV2RunsRunIdImagesRoute
  '/catalog-v2/runs/$runId/insights': typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsRoute
  '/catalog-v2/runs/$runId/issues': typeof AuthenticatedTenantCatalogV2RunsRunIdIssuesRoute
  '/catalog-v2/runs/$runId/lineage': typeof AuthenticatedTenantCatalogV2RunsRunIdLineageRoute
  '/catalog-v2/runs/$runId/quality-checks': typeof AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRoute
  '/catalog-v2/runs/$runId/recovery': typeof AuthenticatedTenantCatalogV2RunsRunIdRecoveryRoute
  '/content/runs/$runId/review': typeof AuthenticatedTenantContentRunsRunIdReviewRoute
  '/experiments/$expId/content-enrichment/delivery': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRoute
  '/experiments/$expId/content-enrichment/full': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRoute
  '/experiments/$expId/content-enrichment/groups': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRoute
  '/experiments/$expId/content-enrichment/overview': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRoute
  '/experiments/$expId/content-enrichment/review': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRoute
  '/exports/catalog/exports/$exportId': typeof AuthenticatedTenantExportsCatalogExportsExportIdRoute
  '/exports/catalog/profiles/$profileId': typeof AuthenticatedTenantExportsCatalogProfilesProfileIdRoute
  '/exports/catalog/runs/$runId': typeof AuthenticatedTenantExportsCatalogRunsRunIdRoute
  '/integrations/connections/connect/$connectorCode': typeof AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRoute
  '/onboarding/integration/google/google-merchant-center': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRoute
  '/onboarding/integration/google/import-catalog': typeof AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRoute
  '/onboarding/integration/google/sftp': typeof AuthenticatedTenantOnboardingIntegrationGoogleSftpRoute
  '/onboarding/integration/google/shopify': typeof AuthenticatedTenantOnboardingIntegrationGoogleShopifyRoute
  '/onboarding/integration/meta/complete-import': typeof AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRoute
  '/onboarding/integration/meta/import-catalog': typeof AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRoute
  '/onboarding/integration/meta/meta-commerce-manager': typeof AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRoute
  '/onboarding/integration/meta/product-overview': typeof AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRoute
  '/onboarding/integration/meta/sftp': typeof AuthenticatedTenantOnboardingIntegrationMetaSftpRoute
  '/platform/service-auth/users/$id': typeof AuthenticatedTenantPlatformServiceAuthUsersIdRoute
  '/platform/subsidiaries/$subsidiaryId/products': typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRoute
  '/trial/$platform/enrichment/$id': typeof AuthenticatedTenantTrialPlatformEnrichmentIdRoute
  '/catalog-enrichment/runs/$runId': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRoute
  '/catalog-v2/runs/$runId': typeof AuthenticatedTenantCatalogV2RunsRunIdIndexRoute
  '/experiments/$expId/content-enrichment': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRoute
  '/onboarding/integration/google': typeof AuthenticatedTenantOnboardingIntegrationGoogleIndexRoute
  '/onboarding/integration/meta': typeof AuthenticatedTenantOnboardingIntegrationMetaIndexRoute
  '/platform/service-auth/users': typeof AuthenticatedTenantPlatformServiceAuthUsersIndexRoute
  '/trial/$platform/enrichment': typeof AuthenticatedTenantTrialPlatformEnrichmentIndexRoute
  '/catalog-enrichment/runs/$runId/insights/products': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRoute
  '/catalog-enrichment/runs/$runId/products/$productId': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRoute
  '/catalog-v2/runs/$runId/insights/products': typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRoute
  '/catalog-v2/runs/$runId/products/$productId': typeof AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRoute
  '/content/runs/$runId/products/$productId': typeof AuthenticatedTenantContentRunsRunIdProductsProductIdRoute
  '/enrichments/google/content-enrichment/$batchId/delivery': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRoute
  '/enrichments/google/content-enrichment/$batchId/full': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRoute
  '/enrichments/google/content-enrichment/$batchId/overview': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRoute
  '/enrichments/google/content-enrichment/$batchId/review': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRoute
  '/enrichments/google/content-enrichment/$batchId/deliver': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRoute
  '/enrichments/meta/content-enrichment/$batchId/delivery': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRoute
  '/enrichments/meta/content-enrichment/$batchId/full': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRoute
  '/enrichments/meta/content-enrichment/$batchId/overview': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRoute
  '/enrichments/meta/content-enrichment/$batchId/review': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRoute
  '/enrichments/meta/content-enrichment/$batchId/deliver': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRoute
  '/explorer/data-quality/product/$connectionId/$externalId': typeof AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRoute
  '/integrations/data-quality/product/$connectionId/$externalId': typeof AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRoute
  '/onboarding/integration/google/adobe-analytics/extraction': typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRoute
  '/onboarding/integration/google/google-ads/confirmation': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRoute
  '/onboarding/integration/google/google-ads/select-account': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRoute
  '/onboarding/integration/google/google-analytics/data-preview': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRoute
  '/onboarding/integration/google/google-analytics/pick-property': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRoute
  '/catalog-enrichment/runs/$runId/products': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRoute
  '/catalog-v2/runs/$runId/products': typeof AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRoute
  '/enrichments/google/content-enrichment/$batchId': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRoute
  '/enrichments/meta/content-enrichment/$batchId': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRoute
  '/onboarding/integration/google/adobe-analytics': typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRoute
  '/onboarding/integration/google/google-ads': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRoute
  '/onboarding/integration/google/google-analytics': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/$': typeof AuthenticatedSplatRoute
  '/_authenticated/_tenant': typeof AuthenticatedTenantRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/_authenticated/_tenant/ai-performance': typeof AuthenticatedTenantAiPerformanceRouteRouteWithChildren
  '/_authenticated/_tenant/catalog-enrichment': typeof AuthenticatedTenantCatalogEnrichmentRouteRouteWithChildren
  '/_authenticated/_tenant/catalog-v2': typeof AuthenticatedTenantCatalogV2RouteRouteWithChildren
  '/_authenticated/_tenant/configuration': typeof AuthenticatedTenantConfigurationRouteRouteWithChildren
  '/_authenticated/_tenant/content': typeof AuthenticatedTenantContentRouteRouteWithChildren
  '/_authenticated/_tenant/deliveries': typeof AuthenticatedTenantDeliveriesRouteRouteWithChildren
  '/_authenticated/_tenant/explorer': typeof AuthenticatedTenantExplorerRouteRouteWithChildren
  '/_authenticated/_tenant/feed-audit': typeof AuthenticatedTenantFeedAuditRouteRouteWithChildren
  '/_authenticated/_tenant/integrations': typeof AuthenticatedTenantIntegrationsRouteRouteWithChildren
  '/_authenticated/_tenant/platform': typeof AuthenticatedTenantPlatformRouteRouteWithChildren
  '/_authenticated/_tenant/subsidiary': typeof AuthenticatedTenantSubsidiaryRouteRouteWithChildren
  '/_authenticated/_tenant/taxonomy': typeof AuthenticatedTenantTaxonomyRouteRouteWithChildren
  '/_authenticated/_tenant/upload-delivery': typeof AuthenticatedTenantUploadDeliveryRouteRouteWithChildren
  '/_authenticated/_tenant/workflow-runs': typeof AuthenticatedTenantWorkflowRunsRouteRouteWithChildren
  '/_authenticated/_tenant/access-denied': typeof AuthenticatedTenantAccessDeniedRoute
  '/_authenticated/_tenant/catalog-manager': typeof AuthenticatedTenantCatalogManagerRoute
  '/_authenticated/_tenant/cost-approvals': typeof AuthenticatedTenantCostApprovalsRoute
  '/_authenticated/_tenant/coverage': typeof AuthenticatedTenantCoverageRoute
  '/_authenticated/_tenant/dashboard': typeof AuthenticatedTenantDashboardRoute
  '/_authenticated/_tenant/history': typeof AuthenticatedTenantHistoryRoute
  '/_authenticated/_tenant/home': typeof AuthenticatedTenantHomeRoute
  '/_authenticated/_tenant/item-setup': typeof AuthenticatedTenantItemSetupRouteWithChildren
  '/_authenticated/_tenant/lily-agent': typeof AuthenticatedTenantLilyAgentRoute
  '/_authenticated/_tenant/notification': typeof AuthenticatedTenantNotificationRoute
  '/_authenticated/_tenant/onboarding': typeof AuthenticatedTenantOnboardingRouteWithChildren
  '/_authenticated/_tenant/product-not-enrolled': typeof AuthenticatedTenantProductNotEnrolledRoute
  '/_authenticated/_tenant/schedules': typeof AuthenticatedTenantSchedulesRoute
  '/_authenticated/_tenant/settings': typeof AuthenticatedTenantSettingsRoute
  '/_authenticated/_tenant/trial': typeof AuthenticatedTenantTrialRouteWithChildren
  '/auth/$provider/callback': typeof AuthProviderCallbackRoute
  '/connector/$token/done': typeof ConnectorTokenDoneRoute
  '/connector/$token/select': typeof ConnectorTokenSelectRoute
  '/connector/$token/': typeof ConnectorTokenIndexRoute
  '/_authenticated/_tenant/platform/service-auth': typeof AuthenticatedTenantPlatformServiceAuthRouteRouteWithChildren
  '/_authenticated/_tenant/ai-performance/$workflowId': typeof AuthenticatedTenantAiPerformanceWorkflowIdRoute
  '/_authenticated/_tenant/catalog-enrichment/cost-approvals': typeof AuthenticatedTenantCatalogEnrichmentCostApprovalsRoute
  '/_authenticated/_tenant/catalog-enrichment/needs-attention': typeof AuthenticatedTenantCatalogEnrichmentNeedsAttentionRoute
  '/_authenticated/_tenant/catalog-operations/$batchId': typeof AuthenticatedTenantCatalogOperationsBatchIdRoute
  '/_authenticated/_tenant/catalog-operations/products-need-attention': typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionRoute
  '/_authenticated/_tenant/catalog-v2/cost-approvals': typeof AuthenticatedTenantCatalogV2CostApprovalsRoute
  '/_authenticated/_tenant/catalog-v2/needs-attention': typeof AuthenticatedTenantCatalogV2NeedsAttentionRoute
  '/_authenticated/_tenant/catalog-v2/schedules': typeof AuthenticatedTenantCatalogV2SchedulesRoute
  '/_authenticated/_tenant/configuration/dashboard': typeof AuthenticatedTenantConfigurationDashboardRoute
  '/_authenticated/_tenant/configuration/fpc-categories': typeof AuthenticatedTenantConfigurationFpcCategoriesRoute
  '/_authenticated/_tenant/configuration/gpc-categories': typeof AuthenticatedTenantConfigurationGpcCategoriesRoute
  '/_authenticated/_tenant/configuration/lily-taxonomy': typeof AuthenticatedTenantConfigurationLilyTaxonomyRoute
  '/_authenticated/_tenant/configuration/manager': typeof AuthenticatedTenantConfigurationManagerRouteWithChildren
  '/_authenticated/_tenant/configuration/prompts': typeof AuthenticatedTenantConfigurationPromptsRoute
  '/_authenticated/_tenant/configuration/treatment': typeof AuthenticatedTenantConfigurationTreatmentRoute
  '/_authenticated/_tenant/content/attribution': typeof AuthenticatedTenantContentAttributionRoute
  '/_authenticated/_tenant/content/jobs': typeof AuthenticatedTenantContentJobsRoute
  '/_authenticated/_tenant/content/model-configuration': typeof AuthenticatedTenantContentModelConfigurationRoute
  '/_authenticated/_tenant/content/overview': typeof AuthenticatedTenantContentOverviewRoute
  '/_authenticated/_tenant/content/prompts': typeof AuthenticatedTenantContentPromptsRoute
  '/_authenticated/_tenant/content/review': typeof AuthenticatedTenantContentReviewRoute
  '/_authenticated/_tenant/cost-approvals_/$workflowId': typeof AuthenticatedTenantCostApprovalsWorkflowIdRoute
  '/_authenticated/_tenant/deliveries/$runId': typeof AuthenticatedTenantDeliveriesRunIdRoute
  '/_authenticated/_tenant/deliveries/new': typeof AuthenticatedTenantDeliveriesNewRoute
  '/_authenticated/_tenant/enrichments/google': typeof AuthenticatedTenantEnrichmentsGoogleRouteWithChildren
  '/_authenticated/_tenant/enrichments/meta': typeof AuthenticatedTenantEnrichmentsMetaRouteWithChildren
  '/_authenticated/_tenant/experiments/$id': typeof AuthenticatedTenantExperimentsIdRoute
  '/_authenticated/_tenant/experiments_/create': typeof AuthenticatedTenantExperimentsCreateRouteWithChildren
  '/_authenticated/_tenant/explorer/catalog-images': typeof AuthenticatedTenantExplorerCatalogImagesRoute
  '/_authenticated/_tenant/explorer/clickhouse': typeof AuthenticatedTenantExplorerClickhouseRoute
  '/_authenticated/_tenant/explorer/coverage': typeof AuthenticatedTenantExplorerCoverageRoute
  '/_authenticated/_tenant/explorer/datalake': typeof AuthenticatedTenantExplorerDatalakeRoute
  '/_authenticated/_tenant/explorer/keyword-planner': typeof AuthenticatedTenantExplorerKeywordPlannerRoute
  '/_authenticated/_tenant/explorer/products': typeof AuthenticatedTenantExplorerProductsRoute
  '/_authenticated/_tenant/exports/$sourceWorkflowId': typeof AuthenticatedTenantExportsSourceWorkflowIdRoute
  '/_authenticated/_tenant/feed-audit/$id': typeof AuthenticatedTenantFeedAuditIdRoute
  '/_authenticated/_tenant/feed-audit/create': typeof AuthenticatedTenantFeedAuditCreateRoute
  '/_authenticated/_tenant/feed-audit/upload': typeof AuthenticatedTenantFeedAuditUploadRoute
  '/_authenticated/_tenant/integrations/catalog-images': typeof AuthenticatedTenantIntegrationsCatalogImagesRoute
  '/_authenticated/_tenant/integrations/clickhouse': typeof AuthenticatedTenantIntegrationsClickhouseRoute
  '/_authenticated/_tenant/integrations/connectors': typeof AuthenticatedTenantIntegrationsConnectorsRoute
  '/_authenticated/_tenant/integrations/coverage': typeof AuthenticatedTenantIntegrationsCoverageRoute
  '/_authenticated/_tenant/integrations/datalake': typeof AuthenticatedTenantIntegrationsDatalakeRoute
  '/_authenticated/_tenant/integrations/health': typeof AuthenticatedTenantIntegrationsHealthRoute
  '/_authenticated/_tenant/integrations/keyword-planner': typeof AuthenticatedTenantIntegrationsKeywordPlannerRoute
  '/_authenticated/_tenant/integrations/products': typeof AuthenticatedTenantIntegrationsProductsRoute
  '/_authenticated/_tenant/integrations/schedules': typeof AuthenticatedTenantIntegrationsSchedulesRoute
  '/_authenticated/_tenant/integrations_/sharing': typeof AuthenticatedTenantIntegrationsSharingRoute
  '/_authenticated/_tenant/item-setup/calibration-scope': typeof AuthenticatedTenantItemSetupCalibrationScopeRoute
  '/_authenticated/_tenant/item-setup/catalog-review': typeof AuthenticatedTenantItemSetupCatalogReviewRoute
  '/_authenticated/_tenant/item-setup/client-verification': typeof AuthenticatedTenantItemSetupClientVerificationRoute
  '/_authenticated/_tenant/item-setup/content-generation': typeof AuthenticatedTenantItemSetupContentGenerationRoute
  '/_authenticated/_tenant/item-setup/enrichment-overview': typeof AuthenticatedTenantItemSetupEnrichmentOverviewRoute
  '/_authenticated/_tenant/item-setup/file-preview': typeof AuthenticatedTenantItemSetupFilePreviewRoute
  '/_authenticated/_tenant/item-setup/full-catalog-generation': typeof AuthenticatedTenantItemSetupFullCatalogGenerationRoute
  '/_authenticated/_tenant/item-setup/output-format': typeof AuthenticatedTenantItemSetupOutputFormatRoute
  '/_authenticated/_tenant/item-setup/pattern-inspector': typeof AuthenticatedTenantItemSetupPatternInspectorRoute
  '/_authenticated/_tenant/item-setup/quality-report': typeof AuthenticatedTenantItemSetupQualityReportRoute
  '/_authenticated/_tenant/item-setup/sftp': typeof AuthenticatedTenantItemSetupSftpRoute
  '/_authenticated/_tenant/item-setup/shopify': typeof AuthenticatedTenantItemSetupShopifyRoute
  '/_authenticated/_tenant/item-setup/shopify-confirm': typeof AuthenticatedTenantItemSetupShopifyConfirmRoute
  '/_authenticated/_tenant/item-setup/source-priority': typeof AuthenticatedTenantItemSetupSourcePriorityRoute
  '/_authenticated/_tenant/item-setup/taxonomy': typeof AuthenticatedTenantItemSetupTaxonomyRoute
  '/_authenticated/_tenant/item-setup/taxonomy-review': typeof AuthenticatedTenantItemSetupTaxonomyReviewRoute
  '/_authenticated/_tenant/item-setup/verify': typeof AuthenticatedTenantItemSetupVerifyRoute
  '/_authenticated/_tenant/onboarding/complete-import': typeof AuthenticatedTenantOnboardingCompleteImportRoute
  '/_authenticated/_tenant/onboarding/onsite': typeof AuthenticatedTenantOnboardingOnsiteRoute
  '/_authenticated/_tenant/onboarding/paid-ads': typeof AuthenticatedTenantOnboardingPaidAdsRoute
  '/_authenticated/_tenant/onboarding/product-overview': typeof AuthenticatedTenantOnboardingProductOverviewRoute
  '/_authenticated/_tenant/pipeline-runs/$runId': typeof AuthenticatedTenantPipelineRunsRunIdRoute
  '/_authenticated/_tenant/pipelines/$pipelineId': typeof AuthenticatedTenantPipelinesPipelineIdRoute
  '/_authenticated/_tenant/platform/audit-logs': typeof AuthenticatedTenantPlatformAuditLogsRoute
  '/_authenticated/_tenant/platform/batch-review': typeof AuthenticatedTenantPlatformBatchReviewRoute
  '/_authenticated/_tenant/platform/connectors': typeof AuthenticatedTenantPlatformConnectorsRoute
  '/_authenticated/_tenant/platform/cost-approval': typeof AuthenticatedTenantPlatformCostApprovalRoute
  '/_authenticated/_tenant/platform/coverage': typeof AuthenticatedTenantPlatformCoverageRoute
  '/_authenticated/_tenant/platform/data-management': typeof AuthenticatedTenantPlatformDataManagementRoute
  '/_authenticated/_tenant/platform/enrichment-limit': typeof AuthenticatedTenantPlatformEnrichmentLimitRoute
  '/_authenticated/_tenant/platform/feature-flags': typeof AuthenticatedTenantPlatformFeatureFlagsRoute
  '/_authenticated/_tenant/platform/permissions': typeof AuthenticatedTenantPlatformPermissionsRoute
  '/_authenticated/_tenant/platform/products': typeof AuthenticatedTenantPlatformProductsRoute
  '/_authenticated/_tenant/platform/resources': typeof AuthenticatedTenantPlatformResourcesRoute
  '/_authenticated/_tenant/platform/schedules': typeof AuthenticatedTenantPlatformSchedulesRoute
  '/_authenticated/_tenant/platform/screens': typeof AuthenticatedTenantPlatformScreensRoute
  '/_authenticated/_tenant/platform/subsidiaries': typeof AuthenticatedTenantPlatformSubsidiariesRouteWithChildren
  '/_authenticated/_tenant/platform/users': typeof AuthenticatedTenantPlatformUsersRoute
  '/_authenticated/_tenant/settings_/notification': typeof AuthenticatedTenantSettingsNotificationRoute
  '/_authenticated/_tenant/subsidiary-preferences/brand-preferences': typeof AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRoute
  '/_authenticated/_tenant/subsidiary-preferences/constraints': typeof AuthenticatedTenantSubsidiaryPreferencesConstraintsRoute
  '/_authenticated/_tenant/subsidiary/access-control': typeof AuthenticatedTenantSubsidiaryAccessControlRoute
  '/_authenticated/_tenant/subsidiary/access-policy': typeof AuthenticatedTenantSubsidiaryAccessPolicyRoute
  '/_authenticated/_tenant/subsidiary/asset-access': typeof AuthenticatedTenantSubsidiaryAssetAccessRoute
  '/_authenticated/_tenant/subsidiary/data-sharing': typeof AuthenticatedTenantSubsidiaryDataSharingRoute
  '/_authenticated/_tenant/subsidiary/products': typeof AuthenticatedTenantSubsidiaryProductsRoute
  '/_authenticated/_tenant/subsidiary/roles': typeof AuthenticatedTenantSubsidiaryRolesRoute
  '/_authenticated/_tenant/subsidiary/screen-access': typeof AuthenticatedTenantSubsidiaryScreenAccessRoute
  '/_authenticated/_tenant/subsidiary/sso': typeof AuthenticatedTenantSubsidiarySsoRoute
  '/_authenticated/_tenant/subsidiary/subsidiaries': typeof AuthenticatedTenantSubsidiarySubsidiariesRoute
  '/_authenticated/_tenant/subsidiary/sync-schedule': typeof AuthenticatedTenantSubsidiarySyncScheduleRoute
  '/_authenticated/_tenant/subsidiary/users': typeof AuthenticatedTenantSubsidiaryUsersRoute
  '/_authenticated/_tenant/taxonomy/attributes': typeof AuthenticatedTenantTaxonomyAttributesRoute
  '/_authenticated/_tenant/taxonomy/products': typeof AuthenticatedTenantTaxonomyProductsRoute
  '/_authenticated/_tenant/taxonomy/uploads': typeof AuthenticatedTenantTaxonomyUploadsRoute
  '/_authenticated/_tenant/taxonomy/versions': typeof AuthenticatedTenantTaxonomyVersionsRoute
  '/_authenticated/_tenant/trial/$platform': typeof AuthenticatedTenantTrialPlatformRouteWithChildren
  '/_authenticated/_tenant/upload-delivery/single': typeof AuthenticatedTenantUploadDeliverySingleRoute
  '/_authenticated/_tenant/workflow-runs/$runId': typeof AuthenticatedTenantWorkflowRunsRunIdRoute
  '/public/oauth/google-ads/callback': typeof PublicOauthGoogleAdsCallbackRoute
  '/_authenticated/_tenant/ai-performance/': typeof AuthenticatedTenantAiPerformanceIndexRoute
  '/_authenticated/_tenant/catalog-enrichment/': typeof AuthenticatedTenantCatalogEnrichmentIndexRoute
  '/_authenticated/_tenant/catalog-operations/': typeof AuthenticatedTenantCatalogOperationsIndexRoute
  '/_authenticated/_tenant/catalog-v2/': typeof AuthenticatedTenantCatalogV2IndexRoute
  '/_authenticated/_tenant/configuration/': typeof AuthenticatedTenantConfigurationIndexRoute
  '/_authenticated/_tenant/content/': typeof AuthenticatedTenantContentIndexRoute
  '/_authenticated/_tenant/deliveries/': typeof AuthenticatedTenantDeliveriesIndexRoute
  '/_authenticated/_tenant/experiments/': typeof AuthenticatedTenantExperimentsIndexRoute
  '/_authenticated/_tenant/explorer/': typeof AuthenticatedTenantExplorerIndexRoute
  '/_authenticated/_tenant/feed-audit/': typeof AuthenticatedTenantFeedAuditIndexRoute
  '/_authenticated/_tenant/integrations/': typeof AuthenticatedTenantIntegrationsIndexRoute
  '/_authenticated/_tenant/item-setup/': typeof AuthenticatedTenantItemSetupIndexRoute
  '/_authenticated/_tenant/onboarding/': typeof AuthenticatedTenantOnboardingIndexRoute
  '/_authenticated/_tenant/platform/': typeof AuthenticatedTenantPlatformIndexRoute
  '/_authenticated/_tenant/product-catalog/': typeof AuthenticatedTenantProductCatalogIndexRoute
  '/_authenticated/_tenant/subsidiary-preferences/': typeof AuthenticatedTenantSubsidiaryPreferencesIndexRoute
  '/_authenticated/_tenant/subsidiary/': typeof AuthenticatedTenantSubsidiaryIndexRoute
  '/_authenticated/_tenant/taxonomy/': typeof AuthenticatedTenantTaxonomyIndexRoute
  '/_authenticated/_tenant/workflow-runs/': typeof AuthenticatedTenantWorkflowRunsIndexRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteWithChildren
  '/_authenticated/_tenant/catalog-v2/runs/$runId': typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRouteWithChildren
  '/_authenticated/_tenant/catalog-enrichment/experiments/$experimentId': typeof AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRoute
  '/_authenticated/_tenant/catalog-enrichment/experiments/new': typeof AuthenticatedTenantCatalogEnrichmentExperimentsNewRoute
  '/_authenticated/_tenant/catalog-enrichment/feed-audit/new': typeof AuthenticatedTenantCatalogEnrichmentFeedAuditNewRoute
  '/_authenticated/_tenant/catalog-enrichment/feed-products/$feedProductId': typeof AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRoute
  '/_authenticated/_tenant/catalog-enrichment/products/$productId': typeof AuthenticatedTenantCatalogEnrichmentProductsProductIdRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/new': typeof AuthenticatedTenantCatalogEnrichmentRunsNewRoute
  '/_authenticated/_tenant/catalog-enrichment/schedules/$scheduleId': typeof AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRoute
  '/_authenticated/_tenant/catalog-operations/$batchId_/compare-delivery': typeof AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRoute
  '/_authenticated/_tenant/catalog-operations/$batchId_/deliver': typeof AuthenticatedTenantCatalogOperationsBatchIdDeliverRoute
  '/_authenticated/_tenant/catalog-operations/$batchId_/products': typeof AuthenticatedTenantCatalogOperationsBatchIdProductsRoute
  '/_authenticated/_tenant/catalog-operations/products-need-attention_/$productId': typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRoute
  '/_authenticated/_tenant/catalog-v2/experiments/$experimentId': typeof AuthenticatedTenantCatalogV2ExperimentsExperimentIdRoute
  '/_authenticated/_tenant/catalog-v2/experiments/new': typeof AuthenticatedTenantCatalogV2ExperimentsNewRoute
  '/_authenticated/_tenant/catalog-v2/feed-audit/new': typeof AuthenticatedTenantCatalogV2FeedAuditNewRoute
  '/_authenticated/_tenant/catalog-v2/feed-products/$feedProductId': typeof AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRoute
  '/_authenticated/_tenant/catalog-v2/products/$productId': typeof AuthenticatedTenantCatalogV2ProductsProductIdRoute
  '/_authenticated/_tenant/catalog-v2/runs/new': typeof AuthenticatedTenantCatalogV2RunsNewRoute
  '/_authenticated/_tenant/configuration/manager/audit-trail': typeof AuthenticatedTenantConfigurationManagerAuditTrailRoute
  '/_authenticated/_tenant/configuration/manager/parameters': typeof AuthenticatedTenantConfigurationManagerParametersRoute
  '/_authenticated/_tenant/content/jobs_/how-it-works': typeof AuthenticatedTenantContentJobsHowItWorksRoute
  '/_authenticated/_tenant/content/runs/$runId': typeof AuthenticatedTenantContentRunsRunIdRoute
  '/_authenticated/_tenant/content/runs/how-it-works': typeof AuthenticatedTenantContentRunsHowItWorksRoute
  '/_authenticated/_tenant/content/settings/instructions': typeof AuthenticatedTenantContentSettingsInstructionsRoute
  '/_authenticated/_tenant/content/settings/models': typeof AuthenticatedTenantContentSettingsModelsRoute
  '/_authenticated/_tenant/content/settings/vocabulary': typeof AuthenticatedTenantContentSettingsVocabularyRoute
  '/_authenticated/_tenant/content_/catalog/$jobId': typeof AuthenticatedTenantContentCatalogJobIdRoute
  '/_authenticated/_tenant/content_/catalog/new': typeof AuthenticatedTenantContentCatalogNewRoute
  '/_authenticated/_tenant/content_/qc/$runId': typeof AuthenticatedTenantContentQcRunIdRoute
  '/_authenticated/_tenant/content_/qc/new': typeof AuthenticatedTenantContentQcNewRoute
  '/_authenticated/_tenant/deliveries/connections/$connectionId': typeof AuthenticatedTenantDeliveriesConnectionsConnectionIdRoute
  '/_authenticated/_tenant/enrichments/google/product-selection': typeof AuthenticatedTenantEnrichmentsGoogleProductSelectionRoute
  '/_authenticated/_tenant/enrichments/meta/product-selection': typeof AuthenticatedTenantEnrichmentsMetaProductSelectionRoute
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteWithChildren
  '/_authenticated/_tenant/experiments_/create/configure': typeof AuthenticatedTenantExperimentsCreateConfigureRoute
  '/_authenticated/_tenant/experiments_/create/info': typeof AuthenticatedTenantExperimentsCreateInfoRoute
  '/_authenticated/_tenant/explorer/data-quality/compare': typeof AuthenticatedTenantExplorerDataQualityCompareRoute
  '/_authenticated/_tenant/explorer/datalake_/upload': typeof AuthenticatedTenantExplorerDatalakeUploadRoute
  '/_authenticated/_tenant/exports/catalog/new': typeof AuthenticatedTenantExportsCatalogNewRoute
  '/_authenticated/_tenant/integrations/connections/new': typeof AuthenticatedTenantIntegrationsConnectionsNewRoute
  '/_authenticated/_tenant/integrations/data-quality/compare': typeof AuthenticatedTenantIntegrationsDataQualityCompareRoute
  '/_authenticated/_tenant/integrations/datalake_/upload': typeof AuthenticatedTenantIntegrationsDatalakeUploadRoute
  '/_authenticated/_tenant/oauth/google-ads/callback': typeof AuthenticatedTenantOauthGoogleAdsCallbackRoute
  '/_authenticated/_tenant/onboarding/integration/google': typeof AuthenticatedTenantOnboardingIntegrationGoogleRouteWithChildren
  '/_authenticated/_tenant/onboarding/integration/meta': typeof AuthenticatedTenantOnboardingIntegrationMetaRouteWithChildren
  '/_authenticated/_tenant/platform/service-auth/audit': typeof AuthenticatedTenantPlatformServiceAuthAuditRoute
  '/_authenticated/_tenant/platform/service-auth/discovery': typeof AuthenticatedTenantPlatformServiceAuthDiscoveryRoute
  '/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId': typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteWithChildren
  '/_authenticated/_tenant/platform/subsidiaries/onboarding': typeof AuthenticatedTenantPlatformSubsidiariesOnboardingRoute
  '/_authenticated/_tenant/platform/transformers/$transformerId': typeof AuthenticatedTenantPlatformTransformersTransformerIdRoute
  '/_authenticated/_tenant/trial/$platform/create': typeof AuthenticatedTenantTrialPlatformCreateRoute
  '/_authenticated/_tenant/trial/$platform/enrichment': typeof AuthenticatedTenantTrialPlatformEnrichmentRouteWithChildren
  '/_authenticated/_tenant/catalog-enrichment/experiments/': typeof AuthenticatedTenantCatalogEnrichmentExperimentsIndexRoute
  '/_authenticated/_tenant/catalog-enrichment/feed-audit/': typeof AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRoute
  '/_authenticated/_tenant/catalog-enrichment/products/': typeof AuthenticatedTenantCatalogEnrichmentProductsIndexRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/': typeof AuthenticatedTenantCatalogEnrichmentRunsIndexRoute
  '/_authenticated/_tenant/catalog-enrichment/schedules/': typeof AuthenticatedTenantCatalogEnrichmentSchedulesIndexRoute
  '/_authenticated/_tenant/catalog-v2/experiments/': typeof AuthenticatedTenantCatalogV2ExperimentsIndexRoute
  '/_authenticated/_tenant/catalog-v2/feed-audit/': typeof AuthenticatedTenantCatalogV2FeedAuditIndexRoute
  '/_authenticated/_tenant/catalog-v2/products/': typeof AuthenticatedTenantCatalogV2ProductsIndexRoute
  '/_authenticated/_tenant/catalog-v2/runs/': typeof AuthenticatedTenantCatalogV2RunsIndexRoute
  '/_authenticated/_tenant/configuration/manager/': typeof AuthenticatedTenantConfigurationManagerIndexRoute
  '/_authenticated/_tenant/content/qc/': typeof AuthenticatedTenantContentQcIndexRoute
  '/_authenticated/_tenant/content/runs/': typeof AuthenticatedTenantContentRunsIndexRoute
  '/_authenticated/_tenant/experiments_/create/': typeof AuthenticatedTenantExperimentsCreateIndexRoute
  '/_authenticated/_tenant/explorer/data-quality/': typeof AuthenticatedTenantExplorerDataQualityIndexRoute
  '/_authenticated/_tenant/exports/catalog/': typeof AuthenticatedTenantExportsCatalogIndexRoute
  '/_authenticated/_tenant/integrations/connections/': typeof AuthenticatedTenantIntegrationsConnectionsIndexRoute
  '/_authenticated/_tenant/integrations/data-quality/': typeof AuthenticatedTenantIntegrationsDataQualityIndexRoute
  '/_authenticated/_tenant/integrations/pipelines/': typeof AuthenticatedTenantIntegrationsPipelinesIndexRoute
  '/_authenticated/_tenant/integrations/upload-delivery/': typeof AuthenticatedTenantIntegrationsUploadDeliveryIndexRoute
  '/_authenticated/_tenant/platform/service-auth/': typeof AuthenticatedTenantPlatformServiceAuthIndexRoute
  '/_authenticated/_tenant/platform/subsidiaries/': typeof AuthenticatedTenantPlatformSubsidiariesIndexRoute
  '/_authenticated/_tenant/platform/transformers/': typeof AuthenticatedTenantPlatformTransformersIndexRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/activity': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/approval': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/compare': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/content-results': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/cost': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/delivery': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/gate': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/images': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/issues': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/lineage': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/quality-checks': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/recovery': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRoute
  '/_authenticated/_tenant/catalog-operations/$batchId_/products_/$productId': typeof AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/approval': typeof AuthenticatedTenantCatalogV2RunsRunIdApprovalRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/compare': typeof AuthenticatedTenantCatalogV2RunsRunIdCompareRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/content-results': typeof AuthenticatedTenantCatalogV2RunsRunIdContentResultsRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/gate': typeof AuthenticatedTenantCatalogV2RunsRunIdGateRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/images': typeof AuthenticatedTenantCatalogV2RunsRunIdImagesRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/insights': typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/issues': typeof AuthenticatedTenantCatalogV2RunsRunIdIssuesRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/lineage': typeof AuthenticatedTenantCatalogV2RunsRunIdLineageRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/quality-checks': typeof AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/recovery': typeof AuthenticatedTenantCatalogV2RunsRunIdRecoveryRoute
  '/_authenticated/_tenant/content/runs/$runId_/review': typeof AuthenticatedTenantContentRunsRunIdReviewRoute
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteWithChildren
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteWithChildren
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/delivery': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRoute
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/full': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRoute
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/groups': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRoute
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/overview': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRoute
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/review': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRoute
  '/_authenticated/_tenant/exports/catalog/exports/$exportId': typeof AuthenticatedTenantExportsCatalogExportsExportIdRoute
  '/_authenticated/_tenant/exports/catalog/profiles/$profileId': typeof AuthenticatedTenantExportsCatalogProfilesProfileIdRoute
  '/_authenticated/_tenant/exports/catalog/runs/$runId': typeof AuthenticatedTenantExportsCatalogRunsRunIdRoute
  '/_authenticated/_tenant/integrations/connections/connect/$connectorCode': typeof AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRoute
  '/_authenticated/_tenant/onboarding/integration/google/google-ads': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteWithChildren
  '/_authenticated/_tenant/onboarding/integration/google/google-analytics': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteWithChildren
  '/_authenticated/_tenant/onboarding/integration/google/google-merchant-center': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRoute
  '/_authenticated/_tenant/onboarding/integration/google/import-catalog': typeof AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRoute
  '/_authenticated/_tenant/onboarding/integration/google/sftp': typeof AuthenticatedTenantOnboardingIntegrationGoogleSftpRoute
  '/_authenticated/_tenant/onboarding/integration/google/shopify': typeof AuthenticatedTenantOnboardingIntegrationGoogleShopifyRoute
  '/_authenticated/_tenant/onboarding/integration/meta/complete-import': typeof AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRoute
  '/_authenticated/_tenant/onboarding/integration/meta/import-catalog': typeof AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRoute
  '/_authenticated/_tenant/onboarding/integration/meta/meta-commerce-manager': typeof AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRoute
  '/_authenticated/_tenant/onboarding/integration/meta/product-overview': typeof AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRoute
  '/_authenticated/_tenant/onboarding/integration/meta/sftp': typeof AuthenticatedTenantOnboardingIntegrationMetaSftpRoute
  '/_authenticated/_tenant/platform/service-auth/users/$id': typeof AuthenticatedTenantPlatformServiceAuthUsersIdRoute
  '/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId/products': typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRoute
  '/_authenticated/_tenant/trial/$platform/enrichment/$id': typeof AuthenticatedTenantTrialPlatformEnrichmentIdRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/': typeof AuthenticatedTenantCatalogV2RunsRunIdIndexRoute
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/': typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRoute
  '/_authenticated/_tenant/onboarding/integration/google/': typeof AuthenticatedTenantOnboardingIntegrationGoogleIndexRoute
  '/_authenticated/_tenant/onboarding/integration/meta/': typeof AuthenticatedTenantOnboardingIntegrationMetaIndexRoute
  '/_authenticated/_tenant/platform/service-auth/users/': typeof AuthenticatedTenantPlatformServiceAuthUsersIndexRoute
  '/_authenticated/_tenant/trial/$platform/enrichment/': typeof AuthenticatedTenantTrialPlatformEnrichmentIndexRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights_/products': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/$productId': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/insights_/products': typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/products/$productId': typeof AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRoute
  '/_authenticated/_tenant/content_/runs/$runId/products/$productId': typeof AuthenticatedTenantContentRunsRunIdProductsProductIdRoute
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/delivery': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRoute
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/full': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRoute
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/overview': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRoute
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/review': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRoute
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId_/deliver': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRoute
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/delivery': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRoute
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/full': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRoute
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/overview': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRoute
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/review': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRoute
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId_/deliver': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRoute
  '/_authenticated/_tenant/explorer/data-quality/product/$connectionId/$externalId': typeof AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRoute
  '/_authenticated/_tenant/integrations/data-quality/product/$connectionId/$externalId': typeof AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRoute
  '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/extraction': typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRoute
  '/_authenticated/_tenant/onboarding/integration/google/google-ads/confirmation': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRoute
  '/_authenticated/_tenant/onboarding/integration/google/google-ads/select-account': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRoute
  '/_authenticated/_tenant/onboarding/integration/google/google-analytics/data-preview': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRoute
  '/_authenticated/_tenant/onboarding/integration/google/google-analytics/pick-property': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRoute
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/': typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRoute
  '/_authenticated/_tenant/catalog-v2/runs/$runId/products/': typeof AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRoute
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/': typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRoute
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/': typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRoute
  '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/': typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRoute
  '/_authenticated/_tenant/onboarding/integration/google/google-ads/': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRoute
  '/_authenticated/_tenant/onboarding/integration/google/google-analytics/': typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/verify-email'
    | '/$'
    | '/auth/callback'
    | '/ai-performance'
    | '/catalog-enrichment'
    | '/catalog-v2'
    | '/configuration'
    | '/content'
    | '/deliveries'
    | '/explorer'
    | '/feed-audit'
    | '/integrations'
    | '/platform'
    | '/subsidiary'
    | '/taxonomy'
    | '/upload-delivery'
    | '/workflow-runs'
    | '/access-denied'
    | '/catalog-manager'
    | '/cost-approvals'
    | '/coverage'
    | '/dashboard'
    | '/history'
    | '/home'
    | '/item-setup'
    | '/lily-agent'
    | '/notification'
    | '/onboarding'
    | '/product-not-enrolled'
    | '/schedules'
    | '/settings'
    | '/trial'
    | '/auth/$provider/callback'
    | '/connector/$token/done'
    | '/connector/$token/select'
    | '/connector/$token/'
    | '/platform/service-auth'
    | '/ai-performance/$workflowId'
    | '/catalog-enrichment/cost-approvals'
    | '/catalog-enrichment/needs-attention'
    | '/catalog-operations/$batchId'
    | '/catalog-operations/products-need-attention'
    | '/catalog-v2/cost-approvals'
    | '/catalog-v2/needs-attention'
    | '/catalog-v2/schedules'
    | '/configuration/dashboard'
    | '/configuration/fpc-categories'
    | '/configuration/gpc-categories'
    | '/configuration/lily-taxonomy'
    | '/configuration/manager'
    | '/configuration/prompts'
    | '/configuration/treatment'
    | '/content/attribution'
    | '/content/jobs'
    | '/content/model-configuration'
    | '/content/overview'
    | '/content/prompts'
    | '/content/review'
    | '/cost-approvals/$workflowId'
    | '/deliveries/$runId'
    | '/deliveries/new'
    | '/enrichments/google'
    | '/enrichments/meta'
    | '/experiments/$id'
    | '/experiments/create'
    | '/explorer/catalog-images'
    | '/explorer/clickhouse'
    | '/explorer/coverage'
    | '/explorer/datalake'
    | '/explorer/keyword-planner'
    | '/explorer/products'
    | '/exports/$sourceWorkflowId'
    | '/feed-audit/$id'
    | '/feed-audit/create'
    | '/feed-audit/upload'
    | '/integrations/catalog-images'
    | '/integrations/clickhouse'
    | '/integrations/connectors'
    | '/integrations/coverage'
    | '/integrations/datalake'
    | '/integrations/health'
    | '/integrations/keyword-planner'
    | '/integrations/products'
    | '/integrations/schedules'
    | '/integrations/sharing'
    | '/item-setup/calibration-scope'
    | '/item-setup/catalog-review'
    | '/item-setup/client-verification'
    | '/item-setup/content-generation'
    | '/item-setup/enrichment-overview'
    | '/item-setup/file-preview'
    | '/item-setup/full-catalog-generation'
    | '/item-setup/output-format'
    | '/item-setup/pattern-inspector'
    | '/item-setup/quality-report'
    | '/item-setup/sftp'
    | '/item-setup/shopify'
    | '/item-setup/shopify-confirm'
    | '/item-setup/source-priority'
    | '/item-setup/taxonomy'
    | '/item-setup/taxonomy-review'
    | '/item-setup/verify'
    | '/onboarding/complete-import'
    | '/onboarding/onsite'
    | '/onboarding/paid-ads'
    | '/onboarding/product-overview'
    | '/pipeline-runs/$runId'
    | '/pipelines/$pipelineId'
    | '/platform/audit-logs'
    | '/platform/batch-review'
    | '/platform/connectors'
    | '/platform/cost-approval'
    | '/platform/coverage'
    | '/platform/data-management'
    | '/platform/enrichment-limit'
    | '/platform/feature-flags'
    | '/platform/permissions'
    | '/platform/products'
    | '/platform/resources'
    | '/platform/schedules'
    | '/platform/screens'
    | '/platform/subsidiaries'
    | '/platform/users'
    | '/settings/notification'
    | '/subsidiary-preferences/brand-preferences'
    | '/subsidiary-preferences/constraints'
    | '/subsidiary/access-control'
    | '/subsidiary/access-policy'
    | '/subsidiary/asset-access'
    | '/subsidiary/data-sharing'
    | '/subsidiary/products'
    | '/subsidiary/roles'
    | '/subsidiary/screen-access'
    | '/subsidiary/sso'
    | '/subsidiary/subsidiaries'
    | '/subsidiary/sync-schedule'
    | '/subsidiary/users'
    | '/taxonomy/attributes'
    | '/taxonomy/products'
    | '/taxonomy/uploads'
    | '/taxonomy/versions'
    | '/trial/$platform'
    | '/upload-delivery/single'
    | '/workflow-runs/$runId'
    | '/public/oauth/google-ads/callback'
    | '/ai-performance/'
    | '/catalog-enrichment/'
    | '/catalog-operations/'
    | '/catalog-v2/'
    | '/configuration/'
    | '/content/'
    | '/deliveries/'
    | '/experiments/'
    | '/explorer/'
    | '/feed-audit/'
    | '/integrations/'
    | '/item-setup/'
    | '/onboarding/'
    | '/platform/'
    | '/product-catalog/'
    | '/subsidiary-preferences/'
    | '/subsidiary/'
    | '/taxonomy/'
    | '/workflow-runs/'
    | '/catalog-enrichment/runs/$runId'
    | '/catalog-v2/runs/$runId'
    | '/catalog-enrichment/experiments/$experimentId'
    | '/catalog-enrichment/experiments/new'
    | '/catalog-enrichment/feed-audit/new'
    | '/catalog-enrichment/feed-products/$feedProductId'
    | '/catalog-enrichment/products/$productId'
    | '/catalog-enrichment/runs/new'
    | '/catalog-enrichment/schedules/$scheduleId'
    | '/catalog-operations/$batchId/compare-delivery'
    | '/catalog-operations/$batchId/deliver'
    | '/catalog-operations/$batchId/products'
    | '/catalog-operations/products-need-attention/$productId'
    | '/catalog-v2/experiments/$experimentId'
    | '/catalog-v2/experiments/new'
    | '/catalog-v2/feed-audit/new'
    | '/catalog-v2/feed-products/$feedProductId'
    | '/catalog-v2/products/$productId'
    | '/catalog-v2/runs/new'
    | '/configuration/manager/audit-trail'
    | '/configuration/manager/parameters'
    | '/content/jobs/how-it-works'
    | '/content/runs/$runId'
    | '/content/runs/how-it-works'
    | '/content/settings/instructions'
    | '/content/settings/models'
    | '/content/settings/vocabulary'
    | '/content/catalog/$jobId'
    | '/content/catalog/new'
    | '/content/qc/$runId'
    | '/content/qc/new'
    | '/deliveries/connections/$connectionId'
    | '/enrichments/google/product-selection'
    | '/enrichments/meta/product-selection'
    | '/experiments/$expId/content-enrichment'
    | '/experiments/create/configure'
    | '/experiments/create/info'
    | '/explorer/data-quality/compare'
    | '/explorer/datalake/upload'
    | '/exports/catalog/new'
    | '/integrations/connections/new'
    | '/integrations/data-quality/compare'
    | '/integrations/datalake/upload'
    | '/oauth/google-ads/callback'
    | '/onboarding/integration/google'
    | '/onboarding/integration/meta'
    | '/platform/service-auth/audit'
    | '/platform/service-auth/discovery'
    | '/platform/subsidiaries/$subsidiaryId'
    | '/platform/subsidiaries/onboarding'
    | '/platform/transformers/$transformerId'
    | '/trial/$platform/create'
    | '/trial/$platform/enrichment'
    | '/catalog-enrichment/experiments/'
    | '/catalog-enrichment/feed-audit/'
    | '/catalog-enrichment/products/'
    | '/catalog-enrichment/runs/'
    | '/catalog-enrichment/schedules/'
    | '/catalog-v2/experiments/'
    | '/catalog-v2/feed-audit/'
    | '/catalog-v2/products/'
    | '/catalog-v2/runs/'
    | '/configuration/manager/'
    | '/content/qc/'
    | '/content/runs/'
    | '/experiments/create/'
    | '/explorer/data-quality/'
    | '/exports/catalog/'
    | '/integrations/connections/'
    | '/integrations/data-quality/'
    | '/integrations/pipelines/'
    | '/integrations/upload-delivery/'
    | '/platform/service-auth/'
    | '/platform/subsidiaries/'
    | '/platform/transformers/'
    | '/catalog-enrichment/runs/$runId/activity'
    | '/catalog-enrichment/runs/$runId/approval'
    | '/catalog-enrichment/runs/$runId/compare'
    | '/catalog-enrichment/runs/$runId/content-results'
    | '/catalog-enrichment/runs/$runId/cost'
    | '/catalog-enrichment/runs/$runId/delivery'
    | '/catalog-enrichment/runs/$runId/gate'
    | '/catalog-enrichment/runs/$runId/images'
    | '/catalog-enrichment/runs/$runId/insights'
    | '/catalog-enrichment/runs/$runId/issues'
    | '/catalog-enrichment/runs/$runId/lineage'
    | '/catalog-enrichment/runs/$runId/quality-checks'
    | '/catalog-enrichment/runs/$runId/recovery'
    | '/catalog-operations/$batchId/products/$productId'
    | '/catalog-v2/runs/$runId/approval'
    | '/catalog-v2/runs/$runId/compare'
    | '/catalog-v2/runs/$runId/content-results'
    | '/catalog-v2/runs/$runId/gate'
    | '/catalog-v2/runs/$runId/images'
    | '/catalog-v2/runs/$runId/insights'
    | '/catalog-v2/runs/$runId/issues'
    | '/catalog-v2/runs/$runId/lineage'
    | '/catalog-v2/runs/$runId/quality-checks'
    | '/catalog-v2/runs/$runId/recovery'
    | '/content/runs/$runId/review'
    | '/enrichments/google/content-enrichment/$batchId'
    | '/enrichments/meta/content-enrichment/$batchId'
    | '/experiments/$expId/content-enrichment/delivery'
    | '/experiments/$expId/content-enrichment/full'
    | '/experiments/$expId/content-enrichment/groups'
    | '/experiments/$expId/content-enrichment/overview'
    | '/experiments/$expId/content-enrichment/review'
    | '/exports/catalog/exports/$exportId'
    | '/exports/catalog/profiles/$profileId'
    | '/exports/catalog/runs/$runId'
    | '/integrations/connections/connect/$connectorCode'
    | '/onboarding/integration/google/google-ads'
    | '/onboarding/integration/google/google-analytics'
    | '/onboarding/integration/google/google-merchant-center'
    | '/onboarding/integration/google/import-catalog'
    | '/onboarding/integration/google/sftp'
    | '/onboarding/integration/google/shopify'
    | '/onboarding/integration/meta/complete-import'
    | '/onboarding/integration/meta/import-catalog'
    | '/onboarding/integration/meta/meta-commerce-manager'
    | '/onboarding/integration/meta/product-overview'
    | '/onboarding/integration/meta/sftp'
    | '/platform/service-auth/users/$id'
    | '/platform/subsidiaries/$subsidiaryId/products'
    | '/trial/$platform/enrichment/$id'
    | '/catalog-enrichment/runs/$runId/'
    | '/catalog-v2/runs/$runId/'
    | '/experiments/$expId/content-enrichment/'
    | '/onboarding/integration/google/'
    | '/onboarding/integration/meta/'
    | '/platform/service-auth/users/'
    | '/trial/$platform/enrichment/'
    | '/catalog-enrichment/runs/$runId/insights/products'
    | '/catalog-enrichment/runs/$runId/products/$productId'
    | '/catalog-v2/runs/$runId/insights/products'
    | '/catalog-v2/runs/$runId/products/$productId'
    | '/content/runs/$runId/products/$productId'
    | '/enrichments/google/content-enrichment/$batchId/delivery'
    | '/enrichments/google/content-enrichment/$batchId/full'
    | '/enrichments/google/content-enrichment/$batchId/overview'
    | '/enrichments/google/content-enrichment/$batchId/review'
    | '/enrichments/google/content-enrichment/$batchId/deliver'
    | '/enrichments/meta/content-enrichment/$batchId/delivery'
    | '/enrichments/meta/content-enrichment/$batchId/full'
    | '/enrichments/meta/content-enrichment/$batchId/overview'
    | '/enrichments/meta/content-enrichment/$batchId/review'
    | '/enrichments/meta/content-enrichment/$batchId/deliver'
    | '/explorer/data-quality/product/$connectionId/$externalId'
    | '/integrations/data-quality/product/$connectionId/$externalId'
    | '/onboarding/integration/google/adobe-analytics/extraction'
    | '/onboarding/integration/google/google-ads/confirmation'
    | '/onboarding/integration/google/google-ads/select-account'
    | '/onboarding/integration/google/google-analytics/data-preview'
    | '/onboarding/integration/google/google-analytics/pick-property'
    | '/catalog-enrichment/runs/$runId/products/'
    | '/catalog-v2/runs/$runId/products/'
    | '/enrichments/google/content-enrichment/$batchId/'
    | '/enrichments/meta/content-enrichment/$batchId/'
    | '/onboarding/integration/google/adobe-analytics/'
    | '/onboarding/integration/google/google-ads/'
    | '/onboarding/integration/google/google-analytics/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/reset-password'
    | '/verify-email'
    | '/$'
    | '/auth/callback'
    | '/upload-delivery'
    | '/access-denied'
    | '/catalog-manager'
    | '/cost-approvals'
    | '/coverage'
    | '/dashboard'
    | '/history'
    | '/home'
    | '/lily-agent'
    | '/notification'
    | '/product-not-enrolled'
    | '/schedules'
    | '/settings'
    | '/trial'
    | '/auth/$provider/callback'
    | '/connector/$token/done'
    | '/connector/$token/select'
    | '/connector/$token'
    | '/ai-performance/$workflowId'
    | '/catalog-enrichment/cost-approvals'
    | '/catalog-enrichment/needs-attention'
    | '/catalog-operations/$batchId'
    | '/catalog-operations/products-need-attention'
    | '/catalog-v2/cost-approvals'
    | '/catalog-v2/needs-attention'
    | '/catalog-v2/schedules'
    | '/configuration/dashboard'
    | '/configuration/fpc-categories'
    | '/configuration/gpc-categories'
    | '/configuration/lily-taxonomy'
    | '/configuration/prompts'
    | '/configuration/treatment'
    | '/content/attribution'
    | '/content/jobs'
    | '/content/model-configuration'
    | '/content/overview'
    | '/content/prompts'
    | '/content/review'
    | '/cost-approvals/$workflowId'
    | '/deliveries/$runId'
    | '/deliveries/new'
    | '/enrichments/google'
    | '/enrichments/meta'
    | '/experiments/$id'
    | '/explorer/catalog-images'
    | '/explorer/clickhouse'
    | '/explorer/coverage'
    | '/explorer/datalake'
    | '/explorer/keyword-planner'
    | '/explorer/products'
    | '/exports/$sourceWorkflowId'
    | '/feed-audit/$id'
    | '/feed-audit/create'
    | '/feed-audit/upload'
    | '/integrations/catalog-images'
    | '/integrations/clickhouse'
    | '/integrations/connectors'
    | '/integrations/coverage'
    | '/integrations/datalake'
    | '/integrations/health'
    | '/integrations/keyword-planner'
    | '/integrations/products'
    | '/integrations/schedules'
    | '/integrations/sharing'
    | '/item-setup/calibration-scope'
    | '/item-setup/catalog-review'
    | '/item-setup/client-verification'
    | '/item-setup/content-generation'
    | '/item-setup/enrichment-overview'
    | '/item-setup/file-preview'
    | '/item-setup/full-catalog-generation'
    | '/item-setup/output-format'
    | '/item-setup/pattern-inspector'
    | '/item-setup/quality-report'
    | '/item-setup/sftp'
    | '/item-setup/shopify'
    | '/item-setup/shopify-confirm'
    | '/item-setup/source-priority'
    | '/item-setup/taxonomy'
    | '/item-setup/taxonomy-review'
    | '/item-setup/verify'
    | '/onboarding/complete-import'
    | '/onboarding/onsite'
    | '/onboarding/paid-ads'
    | '/onboarding/product-overview'
    | '/pipeline-runs/$runId'
    | '/pipelines/$pipelineId'
    | '/platform/audit-logs'
    | '/platform/batch-review'
    | '/platform/connectors'
    | '/platform/cost-approval'
    | '/platform/coverage'
    | '/platform/data-management'
    | '/platform/enrichment-limit'
    | '/platform/feature-flags'
    | '/platform/permissions'
    | '/platform/products'
    | '/platform/resources'
    | '/platform/schedules'
    | '/platform/screens'
    | '/platform/users'
    | '/settings/notification'
    | '/subsidiary-preferences/brand-preferences'
    | '/subsidiary-preferences/constraints'
    | '/subsidiary/access-control'
    | '/subsidiary/access-policy'
    | '/subsidiary/asset-access'
    | '/subsidiary/data-sharing'
    | '/subsidiary/products'
    | '/subsidiary/roles'
    | '/subsidiary/screen-access'
    | '/subsidiary/sso'
    | '/subsidiary/subsidiaries'
    | '/subsidiary/sync-schedule'
    | '/subsidiary/users'
    | '/taxonomy/attributes'
    | '/taxonomy/products'
    | '/taxonomy/uploads'
    | '/taxonomy/versions'
    | '/trial/$platform'
    | '/upload-delivery/single'
    | '/workflow-runs/$runId'
    | '/public/oauth/google-ads/callback'
    | '/ai-performance'
    | '/catalog-enrichment'
    | '/catalog-operations'
    | '/catalog-v2'
    | '/configuration'
    | '/content'
    | '/deliveries'
    | '/experiments'
    | '/explorer'
    | '/feed-audit'
    | '/integrations'
    | '/item-setup'
    | '/onboarding'
    | '/platform'
    | '/product-catalog'
    | '/subsidiary-preferences'
    | '/subsidiary'
    | '/taxonomy'
    | '/workflow-runs'
    | '/catalog-enrichment/experiments/$experimentId'
    | '/catalog-enrichment/experiments/new'
    | '/catalog-enrichment/feed-audit/new'
    | '/catalog-enrichment/feed-products/$feedProductId'
    | '/catalog-enrichment/products/$productId'
    | '/catalog-enrichment/runs/new'
    | '/catalog-enrichment/schedules/$scheduleId'
    | '/catalog-operations/$batchId/compare-delivery'
    | '/catalog-operations/$batchId/deliver'
    | '/catalog-operations/$batchId/products'
    | '/catalog-operations/products-need-attention/$productId'
    | '/catalog-v2/experiments/$experimentId'
    | '/catalog-v2/experiments/new'
    | '/catalog-v2/feed-audit/new'
    | '/catalog-v2/feed-products/$feedProductId'
    | '/catalog-v2/products/$productId'
    | '/catalog-v2/runs/new'
    | '/configuration/manager/audit-trail'
    | '/configuration/manager/parameters'
    | '/content/jobs/how-it-works'
    | '/content/runs/$runId'
    | '/content/runs/how-it-works'
    | '/content/settings/instructions'
    | '/content/settings/models'
    | '/content/settings/vocabulary'
    | '/content/catalog/$jobId'
    | '/content/catalog/new'
    | '/content/qc/$runId'
    | '/content/qc/new'
    | '/deliveries/connections/$connectionId'
    | '/enrichments/google/product-selection'
    | '/enrichments/meta/product-selection'
    | '/experiments/create/configure'
    | '/experiments/create/info'
    | '/explorer/data-quality/compare'
    | '/explorer/datalake/upload'
    | '/exports/catalog/new'
    | '/integrations/connections/new'
    | '/integrations/data-quality/compare'
    | '/integrations/datalake/upload'
    | '/oauth/google-ads/callback'
    | '/platform/service-auth/audit'
    | '/platform/service-auth/discovery'
    | '/platform/subsidiaries/$subsidiaryId'
    | '/platform/subsidiaries/onboarding'
    | '/platform/transformers/$transformerId'
    | '/trial/$platform/create'
    | '/catalog-enrichment/experiments'
    | '/catalog-enrichment/feed-audit'
    | '/catalog-enrichment/products'
    | '/catalog-enrichment/runs'
    | '/catalog-enrichment/schedules'
    | '/catalog-v2/experiments'
    | '/catalog-v2/feed-audit'
    | '/catalog-v2/products'
    | '/catalog-v2/runs'
    | '/configuration/manager'
    | '/content/qc'
    | '/content/runs'
    | '/experiments/create'
    | '/explorer/data-quality'
    | '/exports/catalog'
    | '/integrations/connections'
    | '/integrations/data-quality'
    | '/integrations/pipelines'
    | '/integrations/upload-delivery'
    | '/platform/service-auth'
    | '/platform/subsidiaries'
    | '/platform/transformers'
    | '/catalog-enrichment/runs/$runId/activity'
    | '/catalog-enrichment/runs/$runId/approval'
    | '/catalog-enrichment/runs/$runId/compare'
    | '/catalog-enrichment/runs/$runId/content-results'
    | '/catalog-enrichment/runs/$runId/cost'
    | '/catalog-enrichment/runs/$runId/delivery'
    | '/catalog-enrichment/runs/$runId/gate'
    | '/catalog-enrichment/runs/$runId/images'
    | '/catalog-enrichment/runs/$runId/insights'
    | '/catalog-enrichment/runs/$runId/issues'
    | '/catalog-enrichment/runs/$runId/lineage'
    | '/catalog-enrichment/runs/$runId/quality-checks'
    | '/catalog-enrichment/runs/$runId/recovery'
    | '/catalog-operations/$batchId/products/$productId'
    | '/catalog-v2/runs/$runId/approval'
    | '/catalog-v2/runs/$runId/compare'
    | '/catalog-v2/runs/$runId/content-results'
    | '/catalog-v2/runs/$runId/gate'
    | '/catalog-v2/runs/$runId/images'
    | '/catalog-v2/runs/$runId/insights'
    | '/catalog-v2/runs/$runId/issues'
    | '/catalog-v2/runs/$runId/lineage'
    | '/catalog-v2/runs/$runId/quality-checks'
    | '/catalog-v2/runs/$runId/recovery'
    | '/content/runs/$runId/review'
    | '/experiments/$expId/content-enrichment/delivery'
    | '/experiments/$expId/content-enrichment/full'
    | '/experiments/$expId/content-enrichment/groups'
    | '/experiments/$expId/content-enrichment/overview'
    | '/experiments/$expId/content-enrichment/review'
    | '/exports/catalog/exports/$exportId'
    | '/exports/catalog/profiles/$profileId'
    | '/exports/catalog/runs/$runId'
    | '/integrations/connections/connect/$connectorCode'
    | '/onboarding/integration/google/google-merchant-center'
    | '/onboarding/integration/google/import-catalog'
    | '/onboarding/integration/google/sftp'
    | '/onboarding/integration/google/shopify'
    | '/onboarding/integration/meta/complete-import'
    | '/onboarding/integration/meta/import-catalog'
    | '/onboarding/integration/meta/meta-commerce-manager'
    | '/onboarding/integration/meta/product-overview'
    | '/onboarding/integration/meta/sftp'
    | '/platform/service-auth/users/$id'
    | '/platform/subsidiaries/$subsidiaryId/products'
    | '/trial/$platform/enrichment/$id'
    | '/catalog-enrichment/runs/$runId'
    | '/catalog-v2/runs/$runId'
    | '/experiments/$expId/content-enrichment'
    | '/onboarding/integration/google'
    | '/onboarding/integration/meta'
    | '/platform/service-auth/users'
    | '/trial/$platform/enrichment'
    | '/catalog-enrichment/runs/$runId/insights/products'
    | '/catalog-enrichment/runs/$runId/products/$productId'
    | '/catalog-v2/runs/$runId/insights/products'
    | '/catalog-v2/runs/$runId/products/$productId'
    | '/content/runs/$runId/products/$productId'
    | '/enrichments/google/content-enrichment/$batchId/delivery'
    | '/enrichments/google/content-enrichment/$batchId/full'
    | '/enrichments/google/content-enrichment/$batchId/overview'
    | '/enrichments/google/content-enrichment/$batchId/review'
    | '/enrichments/google/content-enrichment/$batchId/deliver'
    | '/enrichments/meta/content-enrichment/$batchId/delivery'
    | '/enrichments/meta/content-enrichment/$batchId/full'
    | '/enrichments/meta/content-enrichment/$batchId/overview'
    | '/enrichments/meta/content-enrichment/$batchId/review'
    | '/enrichments/meta/content-enrichment/$batchId/deliver'
    | '/explorer/data-quality/product/$connectionId/$externalId'
    | '/integrations/data-quality/product/$connectionId/$externalId'
    | '/onboarding/integration/google/adobe-analytics/extraction'
    | '/onboarding/integration/google/google-ads/confirmation'
    | '/onboarding/integration/google/google-ads/select-account'
    | '/onboarding/integration/google/google-analytics/data-preview'
    | '/onboarding/integration/google/google-analytics/pick-property'
    | '/catalog-enrichment/runs/$runId/products'
    | '/catalog-v2/runs/$runId/products'
    | '/enrichments/google/content-enrichment/$batchId'
    | '/enrichments/meta/content-enrichment/$batchId'
    | '/onboarding/integration/google/adobe-analytics'
    | '/onboarding/integration/google/google-ads'
    | '/onboarding/integration/google/google-analytics'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/reset-password'
    | '/verify-email'
    | '/_authenticated/$'
    | '/_authenticated/_tenant'
    | '/auth/callback'
    | '/_authenticated/_tenant/ai-performance'
    | '/_authenticated/_tenant/catalog-enrichment'
    | '/_authenticated/_tenant/catalog-v2'
    | '/_authenticated/_tenant/configuration'
    | '/_authenticated/_tenant/content'
    | '/_authenticated/_tenant/deliveries'
    | '/_authenticated/_tenant/explorer'
    | '/_authenticated/_tenant/feed-audit'
    | '/_authenticated/_tenant/integrations'
    | '/_authenticated/_tenant/platform'
    | '/_authenticated/_tenant/subsidiary'
    | '/_authenticated/_tenant/taxonomy'
    | '/_authenticated/_tenant/upload-delivery'
    | '/_authenticated/_tenant/workflow-runs'
    | '/_authenticated/_tenant/access-denied'
    | '/_authenticated/_tenant/catalog-manager'
    | '/_authenticated/_tenant/cost-approvals'
    | '/_authenticated/_tenant/coverage'
    | '/_authenticated/_tenant/dashboard'
    | '/_authenticated/_tenant/history'
    | '/_authenticated/_tenant/home'
    | '/_authenticated/_tenant/item-setup'
    | '/_authenticated/_tenant/lily-agent'
    | '/_authenticated/_tenant/notification'
    | '/_authenticated/_tenant/onboarding'
    | '/_authenticated/_tenant/product-not-enrolled'
    | '/_authenticated/_tenant/schedules'
    | '/_authenticated/_tenant/settings'
    | '/_authenticated/_tenant/trial'
    | '/auth/$provider/callback'
    | '/connector/$token/done'
    | '/connector/$token/select'
    | '/connector/$token/'
    | '/_authenticated/_tenant/platform/service-auth'
    | '/_authenticated/_tenant/ai-performance/$workflowId'
    | '/_authenticated/_tenant/catalog-enrichment/cost-approvals'
    | '/_authenticated/_tenant/catalog-enrichment/needs-attention'
    | '/_authenticated/_tenant/catalog-operations/$batchId'
    | '/_authenticated/_tenant/catalog-operations/products-need-attention'
    | '/_authenticated/_tenant/catalog-v2/cost-approvals'
    | '/_authenticated/_tenant/catalog-v2/needs-attention'
    | '/_authenticated/_tenant/catalog-v2/schedules'
    | '/_authenticated/_tenant/configuration/dashboard'
    | '/_authenticated/_tenant/configuration/fpc-categories'
    | '/_authenticated/_tenant/configuration/gpc-categories'
    | '/_authenticated/_tenant/configuration/lily-taxonomy'
    | '/_authenticated/_tenant/configuration/manager'
    | '/_authenticated/_tenant/configuration/prompts'
    | '/_authenticated/_tenant/configuration/treatment'
    | '/_authenticated/_tenant/content/attribution'
    | '/_authenticated/_tenant/content/jobs'
    | '/_authenticated/_tenant/content/model-configuration'
    | '/_authenticated/_tenant/content/overview'
    | '/_authenticated/_tenant/content/prompts'
    | '/_authenticated/_tenant/content/review'
    | '/_authenticated/_tenant/cost-approvals_/$workflowId'
    | '/_authenticated/_tenant/deliveries/$runId'
    | '/_authenticated/_tenant/deliveries/new'
    | '/_authenticated/_tenant/enrichments/google'
    | '/_authenticated/_tenant/enrichments/meta'
    | '/_authenticated/_tenant/experiments/$id'
    | '/_authenticated/_tenant/experiments_/create'
    | '/_authenticated/_tenant/explorer/catalog-images'
    | '/_authenticated/_tenant/explorer/clickhouse'
    | '/_authenticated/_tenant/explorer/coverage'
    | '/_authenticated/_tenant/explorer/datalake'
    | '/_authenticated/_tenant/explorer/keyword-planner'
    | '/_authenticated/_tenant/explorer/products'
    | '/_authenticated/_tenant/exports/$sourceWorkflowId'
    | '/_authenticated/_tenant/feed-audit/$id'
    | '/_authenticated/_tenant/feed-audit/create'
    | '/_authenticated/_tenant/feed-audit/upload'
    | '/_authenticated/_tenant/integrations/catalog-images'
    | '/_authenticated/_tenant/integrations/clickhouse'
    | '/_authenticated/_tenant/integrations/connectors'
    | '/_authenticated/_tenant/integrations/coverage'
    | '/_authenticated/_tenant/integrations/datalake'
    | '/_authenticated/_tenant/integrations/health'
    | '/_authenticated/_tenant/integrations/keyword-planner'
    | '/_authenticated/_tenant/integrations/products'
    | '/_authenticated/_tenant/integrations/schedules'
    | '/_authenticated/_tenant/integrations_/sharing'
    | '/_authenticated/_tenant/item-setup/calibration-scope'
    | '/_authenticated/_tenant/item-setup/catalog-review'
    | '/_authenticated/_tenant/item-setup/client-verification'
    | '/_authenticated/_tenant/item-setup/content-generation'
    | '/_authenticated/_tenant/item-setup/enrichment-overview'
    | '/_authenticated/_tenant/item-setup/file-preview'
    | '/_authenticated/_tenant/item-setup/full-catalog-generation'
    | '/_authenticated/_tenant/item-setup/output-format'
    | '/_authenticated/_tenant/item-setup/pattern-inspector'
    | '/_authenticated/_tenant/item-setup/quality-report'
    | '/_authenticated/_tenant/item-setup/sftp'
    | '/_authenticated/_tenant/item-setup/shopify'
    | '/_authenticated/_tenant/item-setup/shopify-confirm'
    | '/_authenticated/_tenant/item-setup/source-priority'
    | '/_authenticated/_tenant/item-setup/taxonomy'
    | '/_authenticated/_tenant/item-setup/taxonomy-review'
    | '/_authenticated/_tenant/item-setup/verify'
    | '/_authenticated/_tenant/onboarding/complete-import'
    | '/_authenticated/_tenant/onboarding/onsite'
    | '/_authenticated/_tenant/onboarding/paid-ads'
    | '/_authenticated/_tenant/onboarding/product-overview'
    | '/_authenticated/_tenant/pipeline-runs/$runId'
    | '/_authenticated/_tenant/pipelines/$pipelineId'
    | '/_authenticated/_tenant/platform/audit-logs'
    | '/_authenticated/_tenant/platform/batch-review'
    | '/_authenticated/_tenant/platform/connectors'
    | '/_authenticated/_tenant/platform/cost-approval'
    | '/_authenticated/_tenant/platform/coverage'
    | '/_authenticated/_tenant/platform/data-management'
    | '/_authenticated/_tenant/platform/enrichment-limit'
    | '/_authenticated/_tenant/platform/feature-flags'
    | '/_authenticated/_tenant/platform/permissions'
    | '/_authenticated/_tenant/platform/products'
    | '/_authenticated/_tenant/platform/resources'
    | '/_authenticated/_tenant/platform/schedules'
    | '/_authenticated/_tenant/platform/screens'
    | '/_authenticated/_tenant/platform/subsidiaries'
    | '/_authenticated/_tenant/platform/users'
    | '/_authenticated/_tenant/settings_/notification'
    | '/_authenticated/_tenant/subsidiary-preferences/brand-preferences'
    | '/_authenticated/_tenant/subsidiary-preferences/constraints'
    | '/_authenticated/_tenant/subsidiary/access-control'
    | '/_authenticated/_tenant/subsidiary/access-policy'
    | '/_authenticated/_tenant/subsidiary/asset-access'
    | '/_authenticated/_tenant/subsidiary/data-sharing'
    | '/_authenticated/_tenant/subsidiary/products'
    | '/_authenticated/_tenant/subsidiary/roles'
    | '/_authenticated/_tenant/subsidiary/screen-access'
    | '/_authenticated/_tenant/subsidiary/sso'
    | '/_authenticated/_tenant/subsidiary/subsidiaries'
    | '/_authenticated/_tenant/subsidiary/sync-schedule'
    | '/_authenticated/_tenant/subsidiary/users'
    | '/_authenticated/_tenant/taxonomy/attributes'
    | '/_authenticated/_tenant/taxonomy/products'
    | '/_authenticated/_tenant/taxonomy/uploads'
    | '/_authenticated/_tenant/taxonomy/versions'
    | '/_authenticated/_tenant/trial/$platform'
    | '/_authenticated/_tenant/upload-delivery/single'
    | '/_authenticated/_tenant/workflow-runs/$runId'
    | '/public/oauth/google-ads/callback'
    | '/_authenticated/_tenant/ai-performance/'
    | '/_authenticated/_tenant/catalog-enrichment/'
    | '/_authenticated/_tenant/catalog-operations/'
    | '/_authenticated/_tenant/catalog-v2/'
    | '/_authenticated/_tenant/configuration/'
    | '/_authenticated/_tenant/content/'
    | '/_authenticated/_tenant/deliveries/'
    | '/_authenticated/_tenant/experiments/'
    | '/_authenticated/_tenant/explorer/'
    | '/_authenticated/_tenant/feed-audit/'
    | '/_authenticated/_tenant/integrations/'
    | '/_authenticated/_tenant/item-setup/'
    | '/_authenticated/_tenant/onboarding/'
    | '/_authenticated/_tenant/platform/'
    | '/_authenticated/_tenant/product-catalog/'
    | '/_authenticated/_tenant/subsidiary-preferences/'
    | '/_authenticated/_tenant/subsidiary/'
    | '/_authenticated/_tenant/taxonomy/'
    | '/_authenticated/_tenant/workflow-runs/'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId'
    | '/_authenticated/_tenant/catalog-enrichment/experiments/$experimentId'
    | '/_authenticated/_tenant/catalog-enrichment/experiments/new'
    | '/_authenticated/_tenant/catalog-enrichment/feed-audit/new'
    | '/_authenticated/_tenant/catalog-enrichment/feed-products/$feedProductId'
    | '/_authenticated/_tenant/catalog-enrichment/products/$productId'
    | '/_authenticated/_tenant/catalog-enrichment/runs/new'
    | '/_authenticated/_tenant/catalog-enrichment/schedules/$scheduleId'
    | '/_authenticated/_tenant/catalog-operations/$batchId_/compare-delivery'
    | '/_authenticated/_tenant/catalog-operations/$batchId_/deliver'
    | '/_authenticated/_tenant/catalog-operations/$batchId_/products'
    | '/_authenticated/_tenant/catalog-operations/products-need-attention_/$productId'
    | '/_authenticated/_tenant/catalog-v2/experiments/$experimentId'
    | '/_authenticated/_tenant/catalog-v2/experiments/new'
    | '/_authenticated/_tenant/catalog-v2/feed-audit/new'
    | '/_authenticated/_tenant/catalog-v2/feed-products/$feedProductId'
    | '/_authenticated/_tenant/catalog-v2/products/$productId'
    | '/_authenticated/_tenant/catalog-v2/runs/new'
    | '/_authenticated/_tenant/configuration/manager/audit-trail'
    | '/_authenticated/_tenant/configuration/manager/parameters'
    | '/_authenticated/_tenant/content/jobs_/how-it-works'
    | '/_authenticated/_tenant/content/runs/$runId'
    | '/_authenticated/_tenant/content/runs/how-it-works'
    | '/_authenticated/_tenant/content/settings/instructions'
    | '/_authenticated/_tenant/content/settings/models'
    | '/_authenticated/_tenant/content/settings/vocabulary'
    | '/_authenticated/_tenant/content_/catalog/$jobId'
    | '/_authenticated/_tenant/content_/catalog/new'
    | '/_authenticated/_tenant/content_/qc/$runId'
    | '/_authenticated/_tenant/content_/qc/new'
    | '/_authenticated/_tenant/deliveries/connections/$connectionId'
    | '/_authenticated/_tenant/enrichments/google/product-selection'
    | '/_authenticated/_tenant/enrichments/meta/product-selection'
    | '/_authenticated/_tenant/experiments_/$expId/content-enrichment'
    | '/_authenticated/_tenant/experiments_/create/configure'
    | '/_authenticated/_tenant/experiments_/create/info'
    | '/_authenticated/_tenant/explorer/data-quality/compare'
    | '/_authenticated/_tenant/explorer/datalake_/upload'
    | '/_authenticated/_tenant/exports/catalog/new'
    | '/_authenticated/_tenant/integrations/connections/new'
    | '/_authenticated/_tenant/integrations/data-quality/compare'
    | '/_authenticated/_tenant/integrations/datalake_/upload'
    | '/_authenticated/_tenant/oauth/google-ads/callback'
    | '/_authenticated/_tenant/onboarding/integration/google'
    | '/_authenticated/_tenant/onboarding/integration/meta'
    | '/_authenticated/_tenant/platform/service-auth/audit'
    | '/_authenticated/_tenant/platform/service-auth/discovery'
    | '/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId'
    | '/_authenticated/_tenant/platform/subsidiaries/onboarding'
    | '/_authenticated/_tenant/platform/transformers/$transformerId'
    | '/_authenticated/_tenant/trial/$platform/create'
    | '/_authenticated/_tenant/trial/$platform/enrichment'
    | '/_authenticated/_tenant/catalog-enrichment/experiments/'
    | '/_authenticated/_tenant/catalog-enrichment/feed-audit/'
    | '/_authenticated/_tenant/catalog-enrichment/products/'
    | '/_authenticated/_tenant/catalog-enrichment/runs/'
    | '/_authenticated/_tenant/catalog-enrichment/schedules/'
    | '/_authenticated/_tenant/catalog-v2/experiments/'
    | '/_authenticated/_tenant/catalog-v2/feed-audit/'
    | '/_authenticated/_tenant/catalog-v2/products/'
    | '/_authenticated/_tenant/catalog-v2/runs/'
    | '/_authenticated/_tenant/configuration/manager/'
    | '/_authenticated/_tenant/content/qc/'
    | '/_authenticated/_tenant/content/runs/'
    | '/_authenticated/_tenant/experiments_/create/'
    | '/_authenticated/_tenant/explorer/data-quality/'
    | '/_authenticated/_tenant/exports/catalog/'
    | '/_authenticated/_tenant/integrations/connections/'
    | '/_authenticated/_tenant/integrations/data-quality/'
    | '/_authenticated/_tenant/integrations/pipelines/'
    | '/_authenticated/_tenant/integrations/upload-delivery/'
    | '/_authenticated/_tenant/platform/service-auth/'
    | '/_authenticated/_tenant/platform/subsidiaries/'
    | '/_authenticated/_tenant/platform/transformers/'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/activity'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/approval'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/compare'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/content-results'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/cost'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/delivery'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/gate'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/images'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/issues'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/lineage'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/quality-checks'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/recovery'
    | '/_authenticated/_tenant/catalog-operations/$batchId_/products_/$productId'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/approval'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/compare'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/content-results'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/gate'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/images'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/insights'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/issues'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/lineage'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/quality-checks'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/recovery'
    | '/_authenticated/_tenant/content/runs/$runId_/review'
    | '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId'
    | '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId'
    | '/_authenticated/_tenant/experiments_/$expId/content-enrichment/delivery'
    | '/_authenticated/_tenant/experiments_/$expId/content-enrichment/full'
    | '/_authenticated/_tenant/experiments_/$expId/content-enrichment/groups'
    | '/_authenticated/_tenant/experiments_/$expId/content-enrichment/overview'
    | '/_authenticated/_tenant/experiments_/$expId/content-enrichment/review'
    | '/_authenticated/_tenant/exports/catalog/exports/$exportId'
    | '/_authenticated/_tenant/exports/catalog/profiles/$profileId'
    | '/_authenticated/_tenant/exports/catalog/runs/$runId'
    | '/_authenticated/_tenant/integrations/connections/connect/$connectorCode'
    | '/_authenticated/_tenant/onboarding/integration/google/google-ads'
    | '/_authenticated/_tenant/onboarding/integration/google/google-analytics'
    | '/_authenticated/_tenant/onboarding/integration/google/google-merchant-center'
    | '/_authenticated/_tenant/onboarding/integration/google/import-catalog'
    | '/_authenticated/_tenant/onboarding/integration/google/sftp'
    | '/_authenticated/_tenant/onboarding/integration/google/shopify'
    | '/_authenticated/_tenant/onboarding/integration/meta/complete-import'
    | '/_authenticated/_tenant/onboarding/integration/meta/import-catalog'
    | '/_authenticated/_tenant/onboarding/integration/meta/meta-commerce-manager'
    | '/_authenticated/_tenant/onboarding/integration/meta/product-overview'
    | '/_authenticated/_tenant/onboarding/integration/meta/sftp'
    | '/_authenticated/_tenant/platform/service-auth/users/$id'
    | '/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId/products'
    | '/_authenticated/_tenant/trial/$platform/enrichment/$id'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/'
    | '/_authenticated/_tenant/experiments_/$expId/content-enrichment/'
    | '/_authenticated/_tenant/onboarding/integration/google/'
    | '/_authenticated/_tenant/onboarding/integration/meta/'
    | '/_authenticated/_tenant/platform/service-auth/users/'
    | '/_authenticated/_tenant/trial/$platform/enrichment/'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights_/products'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/$productId'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/insights_/products'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/products/$productId'
    | '/_authenticated/_tenant/content_/runs/$runId/products/$productId'
    | '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/delivery'
    | '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/full'
    | '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/overview'
    | '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/review'
    | '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId_/deliver'
    | '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/delivery'
    | '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/full'
    | '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/overview'
    | '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/review'
    | '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId_/deliver'
    | '/_authenticated/_tenant/explorer/data-quality/product/$connectionId/$externalId'
    | '/_authenticated/_tenant/integrations/data-quality/product/$connectionId/$externalId'
    | '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/extraction'
    | '/_authenticated/_tenant/onboarding/integration/google/google-ads/confirmation'
    | '/_authenticated/_tenant/onboarding/integration/google/google-ads/select-account'
    | '/_authenticated/_tenant/onboarding/integration/google/google-analytics/data-preview'
    | '/_authenticated/_tenant/onboarding/integration/google/google-analytics/pick-property'
    | '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/'
    | '/_authenticated/_tenant/catalog-v2/runs/$runId/products/'
    | '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/'
    | '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/'
    | '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/'
    | '/_authenticated/_tenant/onboarding/integration/google/google-ads/'
    | '/_authenticated/_tenant/onboarding/integration/google/google-analytics/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthProviderCallbackRoute: typeof AuthProviderCallbackRoute
  ConnectorTokenDoneRoute: typeof ConnectorTokenDoneRoute
  ConnectorTokenSelectRoute: typeof ConnectorTokenSelectRoute
  ConnectorTokenIndexRoute: typeof ConnectorTokenIndexRoute
  PublicOauthGoogleAdsCallbackRoute: typeof PublicOauthGoogleAdsCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_tenant': {
      id: '/_authenticated/_tenant'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedTenantRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$': {
      id: '/_authenticated/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/connector/$token/': {
      id: '/connector/$token/'
      path: '/connector/$token'
      fullPath: '/connector/$token/'
      preLoaderRoute: typeof ConnectorTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connector/$token/select': {
      id: '/connector/$token/select'
      path: '/connector/$token/select'
      fullPath: '/connector/$token/select'
      preLoaderRoute: typeof ConnectorTokenSelectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connector/$token/done': {
      id: '/connector/$token/done'
      path: '/connector/$token/done'
      fullPath: '/connector/$token/done'
      preLoaderRoute: typeof ConnectorTokenDoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/$provider/callback': {
      id: '/auth/$provider/callback'
      path: '/auth/$provider/callback'
      fullPath: '/auth/$provider/callback'
      preLoaderRoute: typeof AuthProviderCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_tenant/trial': {
      id: '/_authenticated/_tenant/trial'
      path: '/trial'
      fullPath: '/trial'
      preLoaderRoute: typeof AuthenticatedTenantTrialRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/settings': {
      id: '/_authenticated/_tenant/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedTenantSettingsRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/schedules': {
      id: '/_authenticated/_tenant/schedules'
      path: '/schedules'
      fullPath: '/schedules'
      preLoaderRoute: typeof AuthenticatedTenantSchedulesRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/product-not-enrolled': {
      id: '/_authenticated/_tenant/product-not-enrolled'
      path: '/product-not-enrolled'
      fullPath: '/product-not-enrolled'
      preLoaderRoute: typeof AuthenticatedTenantProductNotEnrolledRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/onboarding': {
      id: '/_authenticated/_tenant/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/notification': {
      id: '/_authenticated/_tenant/notification'
      path: '/notification'
      fullPath: '/notification'
      preLoaderRoute: typeof AuthenticatedTenantNotificationRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/lily-agent': {
      id: '/_authenticated/_tenant/lily-agent'
      path: '/lily-agent'
      fullPath: '/lily-agent'
      preLoaderRoute: typeof AuthenticatedTenantLilyAgentRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/item-setup': {
      id: '/_authenticated/_tenant/item-setup'
      path: '/item-setup'
      fullPath: '/item-setup'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/home': {
      id: '/_authenticated/_tenant/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedTenantHomeRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/history': {
      id: '/_authenticated/_tenant/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AuthenticatedTenantHistoryRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/dashboard': {
      id: '/_authenticated/_tenant/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedTenantDashboardRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/coverage': {
      id: '/_authenticated/_tenant/coverage'
      path: '/coverage'
      fullPath: '/coverage'
      preLoaderRoute: typeof AuthenticatedTenantCoverageRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/cost-approvals': {
      id: '/_authenticated/_tenant/cost-approvals'
      path: '/cost-approvals'
      fullPath: '/cost-approvals'
      preLoaderRoute: typeof AuthenticatedTenantCostApprovalsRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-manager': {
      id: '/_authenticated/_tenant/catalog-manager'
      path: '/catalog-manager'
      fullPath: '/catalog-manager'
      preLoaderRoute: typeof AuthenticatedTenantCatalogManagerRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/access-denied': {
      id: '/_authenticated/_tenant/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AuthenticatedTenantAccessDeniedRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/workflow-runs': {
      id: '/_authenticated/_tenant/workflow-runs'
      path: '/workflow-runs'
      fullPath: '/workflow-runs'
      preLoaderRoute: typeof AuthenticatedTenantWorkflowRunsRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/upload-delivery': {
      id: '/_authenticated/_tenant/upload-delivery'
      path: '/upload-delivery'
      fullPath: '/upload-delivery'
      preLoaderRoute: typeof AuthenticatedTenantUploadDeliveryRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/taxonomy': {
      id: '/_authenticated/_tenant/taxonomy'
      path: '/taxonomy'
      fullPath: '/taxonomy'
      preLoaderRoute: typeof AuthenticatedTenantTaxonomyRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/subsidiary': {
      id: '/_authenticated/_tenant/subsidiary'
      path: '/subsidiary'
      fullPath: '/subsidiary'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/platform': {
      id: '/_authenticated/_tenant/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof AuthenticatedTenantPlatformRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/integrations': {
      id: '/_authenticated/_tenant/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/feed-audit': {
      id: '/_authenticated/_tenant/feed-audit'
      path: '/feed-audit'
      fullPath: '/feed-audit'
      preLoaderRoute: typeof AuthenticatedTenantFeedAuditRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/explorer': {
      id: '/_authenticated/_tenant/explorer'
      path: '/explorer'
      fullPath: '/explorer'
      preLoaderRoute: typeof AuthenticatedTenantExplorerRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/deliveries': {
      id: '/_authenticated/_tenant/deliveries'
      path: '/deliveries'
      fullPath: '/deliveries'
      preLoaderRoute: typeof AuthenticatedTenantDeliveriesRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/content': {
      id: '/_authenticated/_tenant/content'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof AuthenticatedTenantContentRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/configuration': {
      id: '/_authenticated/_tenant/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-v2': {
      id: '/_authenticated/_tenant/catalog-v2'
      path: '/catalog-v2'
      fullPath: '/catalog-v2'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-enrichment': {
      id: '/_authenticated/_tenant/catalog-enrichment'
      path: '/catalog-enrichment'
      fullPath: '/catalog-enrichment'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/ai-performance': {
      id: '/_authenticated/_tenant/ai-performance'
      path: '/ai-performance'
      fullPath: '/ai-performance'
      preLoaderRoute: typeof AuthenticatedTenantAiPerformanceRouteRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/workflow-runs/': {
      id: '/_authenticated/_tenant/workflow-runs/'
      path: '/'
      fullPath: '/workflow-runs/'
      preLoaderRoute: typeof AuthenticatedTenantWorkflowRunsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantWorkflowRunsRouteRoute
    }
    '/_authenticated/_tenant/taxonomy/': {
      id: '/_authenticated/_tenant/taxonomy/'
      path: '/'
      fullPath: '/taxonomy/'
      preLoaderRoute: typeof AuthenticatedTenantTaxonomyIndexRouteImport
      parentRoute: typeof AuthenticatedTenantTaxonomyRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/': {
      id: '/_authenticated/_tenant/subsidiary/'
      path: '/'
      fullPath: '/subsidiary/'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryIndexRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary-preferences/': {
      id: '/_authenticated/_tenant/subsidiary-preferences/'
      path: '/subsidiary-preferences'
      fullPath: '/subsidiary-preferences/'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryPreferencesIndexRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/product-catalog/': {
      id: '/_authenticated/_tenant/product-catalog/'
      path: '/product-catalog'
      fullPath: '/product-catalog/'
      preLoaderRoute: typeof AuthenticatedTenantProductCatalogIndexRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/platform/': {
      id: '/_authenticated/_tenant/platform/'
      path: '/'
      fullPath: '/platform/'
      preLoaderRoute: typeof AuthenticatedTenantPlatformIndexRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/onboarding/': {
      id: '/_authenticated/_tenant/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingRoute
    }
    '/_authenticated/_tenant/item-setup/': {
      id: '/_authenticated/_tenant/item-setup/'
      path: '/'
      fullPath: '/item-setup/'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupIndexRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/integrations/': {
      id: '/_authenticated/_tenant/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/feed-audit/': {
      id: '/_authenticated/_tenant/feed-audit/'
      path: '/'
      fullPath: '/feed-audit/'
      preLoaderRoute: typeof AuthenticatedTenantFeedAuditIndexRouteImport
      parentRoute: typeof AuthenticatedTenantFeedAuditRouteRoute
    }
    '/_authenticated/_tenant/explorer/': {
      id: '/_authenticated/_tenant/explorer/'
      path: '/'
      fullPath: '/explorer/'
      preLoaderRoute: typeof AuthenticatedTenantExplorerIndexRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/experiments/': {
      id: '/_authenticated/_tenant/experiments/'
      path: '/experiments'
      fullPath: '/experiments/'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/deliveries/': {
      id: '/_authenticated/_tenant/deliveries/'
      path: '/'
      fullPath: '/deliveries/'
      preLoaderRoute: typeof AuthenticatedTenantDeliveriesIndexRouteImport
      parentRoute: typeof AuthenticatedTenantDeliveriesRouteRoute
    }
    '/_authenticated/_tenant/content/': {
      id: '/_authenticated/_tenant/content/'
      path: '/'
      fullPath: '/content/'
      preLoaderRoute: typeof AuthenticatedTenantContentIndexRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/configuration/': {
      id: '/_authenticated/_tenant/configuration/'
      path: '/'
      fullPath: '/configuration/'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationIndexRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/': {
      id: '/_authenticated/_tenant/catalog-v2/'
      path: '/'
      fullPath: '/catalog-v2/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2IndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-operations/': {
      id: '/_authenticated/_tenant/catalog-operations/'
      path: '/catalog-operations'
      fullPath: '/catalog-operations/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogOperationsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/': {
      id: '/_authenticated/_tenant/catalog-enrichment/'
      path: '/'
      fullPath: '/catalog-enrichment/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/ai-performance/': {
      id: '/_authenticated/_tenant/ai-performance/'
      path: '/'
      fullPath: '/ai-performance/'
      preLoaderRoute: typeof AuthenticatedTenantAiPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedTenantAiPerformanceRouteRoute
    }
    '/public/oauth/google-ads/callback': {
      id: '/public/oauth/google-ads/callback'
      path: '/public/oauth/google-ads/callback'
      fullPath: '/public/oauth/google-ads/callback'
      preLoaderRoute: typeof PublicOauthGoogleAdsCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_tenant/workflow-runs/$runId': {
      id: '/_authenticated/_tenant/workflow-runs/$runId'
      path: '/$runId'
      fullPath: '/workflow-runs/$runId'
      preLoaderRoute: typeof AuthenticatedTenantWorkflowRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedTenantWorkflowRunsRouteRoute
    }
    '/_authenticated/_tenant/upload-delivery/single': {
      id: '/_authenticated/_tenant/upload-delivery/single'
      path: '/single'
      fullPath: '/upload-delivery/single'
      preLoaderRoute: typeof AuthenticatedTenantUploadDeliverySingleRouteImport
      parentRoute: typeof AuthenticatedTenantUploadDeliveryRouteRoute
    }
    '/_authenticated/_tenant/trial/$platform': {
      id: '/_authenticated/_tenant/trial/$platform'
      path: '/$platform'
      fullPath: '/trial/$platform'
      preLoaderRoute: typeof AuthenticatedTenantTrialPlatformRouteImport
      parentRoute: typeof AuthenticatedTenantTrialRoute
    }
    '/_authenticated/_tenant/taxonomy/versions': {
      id: '/_authenticated/_tenant/taxonomy/versions'
      path: '/versions'
      fullPath: '/taxonomy/versions'
      preLoaderRoute: typeof AuthenticatedTenantTaxonomyVersionsRouteImport
      parentRoute: typeof AuthenticatedTenantTaxonomyRouteRoute
    }
    '/_authenticated/_tenant/taxonomy/uploads': {
      id: '/_authenticated/_tenant/taxonomy/uploads'
      path: '/uploads'
      fullPath: '/taxonomy/uploads'
      preLoaderRoute: typeof AuthenticatedTenantTaxonomyUploadsRouteImport
      parentRoute: typeof AuthenticatedTenantTaxonomyRouteRoute
    }
    '/_authenticated/_tenant/taxonomy/products': {
      id: '/_authenticated/_tenant/taxonomy/products'
      path: '/products'
      fullPath: '/taxonomy/products'
      preLoaderRoute: typeof AuthenticatedTenantTaxonomyProductsRouteImport
      parentRoute: typeof AuthenticatedTenantTaxonomyRouteRoute
    }
    '/_authenticated/_tenant/taxonomy/attributes': {
      id: '/_authenticated/_tenant/taxonomy/attributes'
      path: '/attributes'
      fullPath: '/taxonomy/attributes'
      preLoaderRoute: typeof AuthenticatedTenantTaxonomyAttributesRouteImport
      parentRoute: typeof AuthenticatedTenantTaxonomyRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/users': {
      id: '/_authenticated/_tenant/subsidiary/users'
      path: '/users'
      fullPath: '/subsidiary/users'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryUsersRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/sync-schedule': {
      id: '/_authenticated/_tenant/subsidiary/sync-schedule'
      path: '/sync-schedule'
      fullPath: '/subsidiary/sync-schedule'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiarySyncScheduleRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/subsidiaries': {
      id: '/_authenticated/_tenant/subsidiary/subsidiaries'
      path: '/subsidiaries'
      fullPath: '/subsidiary/subsidiaries'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiarySubsidiariesRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/sso': {
      id: '/_authenticated/_tenant/subsidiary/sso'
      path: '/sso'
      fullPath: '/subsidiary/sso'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiarySsoRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/screen-access': {
      id: '/_authenticated/_tenant/subsidiary/screen-access'
      path: '/screen-access'
      fullPath: '/subsidiary/screen-access'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryScreenAccessRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/roles': {
      id: '/_authenticated/_tenant/subsidiary/roles'
      path: '/roles'
      fullPath: '/subsidiary/roles'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryRolesRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/products': {
      id: '/_authenticated/_tenant/subsidiary/products'
      path: '/products'
      fullPath: '/subsidiary/products'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryProductsRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/data-sharing': {
      id: '/_authenticated/_tenant/subsidiary/data-sharing'
      path: '/data-sharing'
      fullPath: '/subsidiary/data-sharing'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryDataSharingRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/asset-access': {
      id: '/_authenticated/_tenant/subsidiary/asset-access'
      path: '/asset-access'
      fullPath: '/subsidiary/asset-access'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryAssetAccessRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/access-policy': {
      id: '/_authenticated/_tenant/subsidiary/access-policy'
      path: '/access-policy'
      fullPath: '/subsidiary/access-policy'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryAccessPolicyRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary/access-control': {
      id: '/_authenticated/_tenant/subsidiary/access-control'
      path: '/access-control'
      fullPath: '/subsidiary/access-control'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryAccessControlRouteImport
      parentRoute: typeof AuthenticatedTenantSubsidiaryRouteRoute
    }
    '/_authenticated/_tenant/subsidiary-preferences/constraints': {
      id: '/_authenticated/_tenant/subsidiary-preferences/constraints'
      path: '/subsidiary-preferences/constraints'
      fullPath: '/subsidiary-preferences/constraints'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryPreferencesConstraintsRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/subsidiary-preferences/brand-preferences': {
      id: '/_authenticated/_tenant/subsidiary-preferences/brand-preferences'
      path: '/subsidiary-preferences/brand-preferences'
      fullPath: '/subsidiary-preferences/brand-preferences'
      preLoaderRoute: typeof AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/settings_/notification': {
      id: '/_authenticated/_tenant/settings_/notification'
      path: '/settings/notification'
      fullPath: '/settings/notification'
      preLoaderRoute: typeof AuthenticatedTenantSettingsNotificationRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/platform/users': {
      id: '/_authenticated/_tenant/platform/users'
      path: '/users'
      fullPath: '/platform/users'
      preLoaderRoute: typeof AuthenticatedTenantPlatformUsersRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/subsidiaries': {
      id: '/_authenticated/_tenant/platform/subsidiaries'
      path: '/subsidiaries'
      fullPath: '/platform/subsidiaries'
      preLoaderRoute: typeof AuthenticatedTenantPlatformSubsidiariesRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/screens': {
      id: '/_authenticated/_tenant/platform/screens'
      path: '/screens'
      fullPath: '/platform/screens'
      preLoaderRoute: typeof AuthenticatedTenantPlatformScreensRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/schedules': {
      id: '/_authenticated/_tenant/platform/schedules'
      path: '/schedules'
      fullPath: '/platform/schedules'
      preLoaderRoute: typeof AuthenticatedTenantPlatformSchedulesRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/resources': {
      id: '/_authenticated/_tenant/platform/resources'
      path: '/resources'
      fullPath: '/platform/resources'
      preLoaderRoute: typeof AuthenticatedTenantPlatformResourcesRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/products': {
      id: '/_authenticated/_tenant/platform/products'
      path: '/products'
      fullPath: '/platform/products'
      preLoaderRoute: typeof AuthenticatedTenantPlatformProductsRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/permissions': {
      id: '/_authenticated/_tenant/platform/permissions'
      path: '/permissions'
      fullPath: '/platform/permissions'
      preLoaderRoute: typeof AuthenticatedTenantPlatformPermissionsRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/feature-flags': {
      id: '/_authenticated/_tenant/platform/feature-flags'
      path: '/feature-flags'
      fullPath: '/platform/feature-flags'
      preLoaderRoute: typeof AuthenticatedTenantPlatformFeatureFlagsRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/enrichment-limit': {
      id: '/_authenticated/_tenant/platform/enrichment-limit'
      path: '/enrichment-limit'
      fullPath: '/platform/enrichment-limit'
      preLoaderRoute: typeof AuthenticatedTenantPlatformEnrichmentLimitRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/data-management': {
      id: '/_authenticated/_tenant/platform/data-management'
      path: '/data-management'
      fullPath: '/platform/data-management'
      preLoaderRoute: typeof AuthenticatedTenantPlatformDataManagementRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/coverage': {
      id: '/_authenticated/_tenant/platform/coverage'
      path: '/coverage'
      fullPath: '/platform/coverage'
      preLoaderRoute: typeof AuthenticatedTenantPlatformCoverageRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/cost-approval': {
      id: '/_authenticated/_tenant/platform/cost-approval'
      path: '/cost-approval'
      fullPath: '/platform/cost-approval'
      preLoaderRoute: typeof AuthenticatedTenantPlatformCostApprovalRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/connectors': {
      id: '/_authenticated/_tenant/platform/connectors'
      path: '/connectors'
      fullPath: '/platform/connectors'
      preLoaderRoute: typeof AuthenticatedTenantPlatformConnectorsRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/batch-review': {
      id: '/_authenticated/_tenant/platform/batch-review'
      path: '/batch-review'
      fullPath: '/platform/batch-review'
      preLoaderRoute: typeof AuthenticatedTenantPlatformBatchReviewRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/audit-logs': {
      id: '/_authenticated/_tenant/platform/audit-logs'
      path: '/audit-logs'
      fullPath: '/platform/audit-logs'
      preLoaderRoute: typeof AuthenticatedTenantPlatformAuditLogsRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/pipelines/$pipelineId': {
      id: '/_authenticated/_tenant/pipelines/$pipelineId'
      path: '/pipelines/$pipelineId'
      fullPath: '/pipelines/$pipelineId'
      preLoaderRoute: typeof AuthenticatedTenantPipelinesPipelineIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/pipeline-runs/$runId': {
      id: '/_authenticated/_tenant/pipeline-runs/$runId'
      path: '/pipeline-runs/$runId'
      fullPath: '/pipeline-runs/$runId'
      preLoaderRoute: typeof AuthenticatedTenantPipelineRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/onboarding/product-overview': {
      id: '/_authenticated/_tenant/onboarding/product-overview'
      path: '/product-overview'
      fullPath: '/onboarding/product-overview'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingProductOverviewRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingRoute
    }
    '/_authenticated/_tenant/onboarding/paid-ads': {
      id: '/_authenticated/_tenant/onboarding/paid-ads'
      path: '/paid-ads'
      fullPath: '/onboarding/paid-ads'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingPaidAdsRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingRoute
    }
    '/_authenticated/_tenant/onboarding/onsite': {
      id: '/_authenticated/_tenant/onboarding/onsite'
      path: '/onsite'
      fullPath: '/onboarding/onsite'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingOnsiteRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingRoute
    }
    '/_authenticated/_tenant/onboarding/complete-import': {
      id: '/_authenticated/_tenant/onboarding/complete-import'
      path: '/complete-import'
      fullPath: '/onboarding/complete-import'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingCompleteImportRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingRoute
    }
    '/_authenticated/_tenant/item-setup/verify': {
      id: '/_authenticated/_tenant/item-setup/verify'
      path: '/verify'
      fullPath: '/item-setup/verify'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupVerifyRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/taxonomy-review': {
      id: '/_authenticated/_tenant/item-setup/taxonomy-review'
      path: '/taxonomy-review'
      fullPath: '/item-setup/taxonomy-review'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupTaxonomyReviewRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/taxonomy': {
      id: '/_authenticated/_tenant/item-setup/taxonomy'
      path: '/taxonomy'
      fullPath: '/item-setup/taxonomy'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupTaxonomyRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/source-priority': {
      id: '/_authenticated/_tenant/item-setup/source-priority'
      path: '/source-priority'
      fullPath: '/item-setup/source-priority'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupSourcePriorityRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/shopify-confirm': {
      id: '/_authenticated/_tenant/item-setup/shopify-confirm'
      path: '/shopify-confirm'
      fullPath: '/item-setup/shopify-confirm'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupShopifyConfirmRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/shopify': {
      id: '/_authenticated/_tenant/item-setup/shopify'
      path: '/shopify'
      fullPath: '/item-setup/shopify'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupShopifyRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/sftp': {
      id: '/_authenticated/_tenant/item-setup/sftp'
      path: '/sftp'
      fullPath: '/item-setup/sftp'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupSftpRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/quality-report': {
      id: '/_authenticated/_tenant/item-setup/quality-report'
      path: '/quality-report'
      fullPath: '/item-setup/quality-report'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupQualityReportRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/pattern-inspector': {
      id: '/_authenticated/_tenant/item-setup/pattern-inspector'
      path: '/pattern-inspector'
      fullPath: '/item-setup/pattern-inspector'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupPatternInspectorRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/output-format': {
      id: '/_authenticated/_tenant/item-setup/output-format'
      path: '/output-format'
      fullPath: '/item-setup/output-format'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupOutputFormatRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/full-catalog-generation': {
      id: '/_authenticated/_tenant/item-setup/full-catalog-generation'
      path: '/full-catalog-generation'
      fullPath: '/item-setup/full-catalog-generation'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupFullCatalogGenerationRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/file-preview': {
      id: '/_authenticated/_tenant/item-setup/file-preview'
      path: '/file-preview'
      fullPath: '/item-setup/file-preview'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupFilePreviewRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/enrichment-overview': {
      id: '/_authenticated/_tenant/item-setup/enrichment-overview'
      path: '/enrichment-overview'
      fullPath: '/item-setup/enrichment-overview'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupEnrichmentOverviewRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/content-generation': {
      id: '/_authenticated/_tenant/item-setup/content-generation'
      path: '/content-generation'
      fullPath: '/item-setup/content-generation'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupContentGenerationRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/client-verification': {
      id: '/_authenticated/_tenant/item-setup/client-verification'
      path: '/client-verification'
      fullPath: '/item-setup/client-verification'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupClientVerificationRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/catalog-review': {
      id: '/_authenticated/_tenant/item-setup/catalog-review'
      path: '/catalog-review'
      fullPath: '/item-setup/catalog-review'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupCatalogReviewRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/item-setup/calibration-scope': {
      id: '/_authenticated/_tenant/item-setup/calibration-scope'
      path: '/calibration-scope'
      fullPath: '/item-setup/calibration-scope'
      preLoaderRoute: typeof AuthenticatedTenantItemSetupCalibrationScopeRouteImport
      parentRoute: typeof AuthenticatedTenantItemSetupRoute
    }
    '/_authenticated/_tenant/integrations_/sharing': {
      id: '/_authenticated/_tenant/integrations_/sharing'
      path: '/integrations/sharing'
      fullPath: '/integrations/sharing'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsSharingRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/integrations/schedules': {
      id: '/_authenticated/_tenant/integrations/schedules'
      path: '/schedules'
      fullPath: '/integrations/schedules'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsSchedulesRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/products': {
      id: '/_authenticated/_tenant/integrations/products'
      path: '/products'
      fullPath: '/integrations/products'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsProductsRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/keyword-planner': {
      id: '/_authenticated/_tenant/integrations/keyword-planner'
      path: '/keyword-planner'
      fullPath: '/integrations/keyword-planner'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsKeywordPlannerRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/health': {
      id: '/_authenticated/_tenant/integrations/health'
      path: '/health'
      fullPath: '/integrations/health'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsHealthRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/datalake': {
      id: '/_authenticated/_tenant/integrations/datalake'
      path: '/datalake'
      fullPath: '/integrations/datalake'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsDatalakeRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/coverage': {
      id: '/_authenticated/_tenant/integrations/coverage'
      path: '/coverage'
      fullPath: '/integrations/coverage'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsCoverageRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/connectors': {
      id: '/_authenticated/_tenant/integrations/connectors'
      path: '/connectors'
      fullPath: '/integrations/connectors'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsConnectorsRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/clickhouse': {
      id: '/_authenticated/_tenant/integrations/clickhouse'
      path: '/clickhouse'
      fullPath: '/integrations/clickhouse'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsClickhouseRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/catalog-images': {
      id: '/_authenticated/_tenant/integrations/catalog-images'
      path: '/catalog-images'
      fullPath: '/integrations/catalog-images'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsCatalogImagesRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/feed-audit/upload': {
      id: '/_authenticated/_tenant/feed-audit/upload'
      path: '/upload'
      fullPath: '/feed-audit/upload'
      preLoaderRoute: typeof AuthenticatedTenantFeedAuditUploadRouteImport
      parentRoute: typeof AuthenticatedTenantFeedAuditRouteRoute
    }
    '/_authenticated/_tenant/feed-audit/create': {
      id: '/_authenticated/_tenant/feed-audit/create'
      path: '/create'
      fullPath: '/feed-audit/create'
      preLoaderRoute: typeof AuthenticatedTenantFeedAuditCreateRouteImport
      parentRoute: typeof AuthenticatedTenantFeedAuditRouteRoute
    }
    '/_authenticated/_tenant/feed-audit/$id': {
      id: '/_authenticated/_tenant/feed-audit/$id'
      path: '/$id'
      fullPath: '/feed-audit/$id'
      preLoaderRoute: typeof AuthenticatedTenantFeedAuditIdRouteImport
      parentRoute: typeof AuthenticatedTenantFeedAuditRouteRoute
    }
    '/_authenticated/_tenant/exports/$sourceWorkflowId': {
      id: '/_authenticated/_tenant/exports/$sourceWorkflowId'
      path: '/exports/$sourceWorkflowId'
      fullPath: '/exports/$sourceWorkflowId'
      preLoaderRoute: typeof AuthenticatedTenantExportsSourceWorkflowIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/explorer/products': {
      id: '/_authenticated/_tenant/explorer/products'
      path: '/products'
      fullPath: '/explorer/products'
      preLoaderRoute: typeof AuthenticatedTenantExplorerProductsRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/explorer/keyword-planner': {
      id: '/_authenticated/_tenant/explorer/keyword-planner'
      path: '/keyword-planner'
      fullPath: '/explorer/keyword-planner'
      preLoaderRoute: typeof AuthenticatedTenantExplorerKeywordPlannerRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/explorer/datalake': {
      id: '/_authenticated/_tenant/explorer/datalake'
      path: '/datalake'
      fullPath: '/explorer/datalake'
      preLoaderRoute: typeof AuthenticatedTenantExplorerDatalakeRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/explorer/coverage': {
      id: '/_authenticated/_tenant/explorer/coverage'
      path: '/coverage'
      fullPath: '/explorer/coverage'
      preLoaderRoute: typeof AuthenticatedTenantExplorerCoverageRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/explorer/clickhouse': {
      id: '/_authenticated/_tenant/explorer/clickhouse'
      path: '/clickhouse'
      fullPath: '/explorer/clickhouse'
      preLoaderRoute: typeof AuthenticatedTenantExplorerClickhouseRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/explorer/catalog-images': {
      id: '/_authenticated/_tenant/explorer/catalog-images'
      path: '/catalog-images'
      fullPath: '/explorer/catalog-images'
      preLoaderRoute: typeof AuthenticatedTenantExplorerCatalogImagesRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/experiments_/create': {
      id: '/_authenticated/_tenant/experiments_/create'
      path: '/experiments/create'
      fullPath: '/experiments/create'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsCreateRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/experiments/$id': {
      id: '/_authenticated/_tenant/experiments/$id'
      path: '/experiments/$id'
      fullPath: '/experiments/$id'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/enrichments/meta': {
      id: '/_authenticated/_tenant/enrichments/meta'
      path: '/enrichments/meta'
      fullPath: '/enrichments/meta'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsMetaRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/enrichments/google': {
      id: '/_authenticated/_tenant/enrichments/google'
      path: '/enrichments/google'
      fullPath: '/enrichments/google'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsGoogleRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/deliveries/new': {
      id: '/_authenticated/_tenant/deliveries/new'
      path: '/new'
      fullPath: '/deliveries/new'
      preLoaderRoute: typeof AuthenticatedTenantDeliveriesNewRouteImport
      parentRoute: typeof AuthenticatedTenantDeliveriesRouteRoute
    }
    '/_authenticated/_tenant/deliveries/$runId': {
      id: '/_authenticated/_tenant/deliveries/$runId'
      path: '/$runId'
      fullPath: '/deliveries/$runId'
      preLoaderRoute: typeof AuthenticatedTenantDeliveriesRunIdRouteImport
      parentRoute: typeof AuthenticatedTenantDeliveriesRouteRoute
    }
    '/_authenticated/_tenant/cost-approvals_/$workflowId': {
      id: '/_authenticated/_tenant/cost-approvals_/$workflowId'
      path: '/cost-approvals/$workflowId'
      fullPath: '/cost-approvals/$workflowId'
      preLoaderRoute: typeof AuthenticatedTenantCostApprovalsWorkflowIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/content/review': {
      id: '/_authenticated/_tenant/content/review'
      path: '/review'
      fullPath: '/content/review'
      preLoaderRoute: typeof AuthenticatedTenantContentReviewRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/prompts': {
      id: '/_authenticated/_tenant/content/prompts'
      path: '/prompts'
      fullPath: '/content/prompts'
      preLoaderRoute: typeof AuthenticatedTenantContentPromptsRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/overview': {
      id: '/_authenticated/_tenant/content/overview'
      path: '/overview'
      fullPath: '/content/overview'
      preLoaderRoute: typeof AuthenticatedTenantContentOverviewRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/model-configuration': {
      id: '/_authenticated/_tenant/content/model-configuration'
      path: '/model-configuration'
      fullPath: '/content/model-configuration'
      preLoaderRoute: typeof AuthenticatedTenantContentModelConfigurationRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/jobs': {
      id: '/_authenticated/_tenant/content/jobs'
      path: '/jobs'
      fullPath: '/content/jobs'
      preLoaderRoute: typeof AuthenticatedTenantContentJobsRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/attribution': {
      id: '/_authenticated/_tenant/content/attribution'
      path: '/attribution'
      fullPath: '/content/attribution'
      preLoaderRoute: typeof AuthenticatedTenantContentAttributionRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/configuration/treatment': {
      id: '/_authenticated/_tenant/configuration/treatment'
      path: '/treatment'
      fullPath: '/configuration/treatment'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationTreatmentRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationRouteRoute
    }
    '/_authenticated/_tenant/configuration/prompts': {
      id: '/_authenticated/_tenant/configuration/prompts'
      path: '/prompts'
      fullPath: '/configuration/prompts'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationPromptsRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationRouteRoute
    }
    '/_authenticated/_tenant/configuration/manager': {
      id: '/_authenticated/_tenant/configuration/manager'
      path: '/manager'
      fullPath: '/configuration/manager'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationManagerRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationRouteRoute
    }
    '/_authenticated/_tenant/configuration/lily-taxonomy': {
      id: '/_authenticated/_tenant/configuration/lily-taxonomy'
      path: '/lily-taxonomy'
      fullPath: '/configuration/lily-taxonomy'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationLilyTaxonomyRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationRouteRoute
    }
    '/_authenticated/_tenant/configuration/gpc-categories': {
      id: '/_authenticated/_tenant/configuration/gpc-categories'
      path: '/gpc-categories'
      fullPath: '/configuration/gpc-categories'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationGpcCategoriesRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationRouteRoute
    }
    '/_authenticated/_tenant/configuration/fpc-categories': {
      id: '/_authenticated/_tenant/configuration/fpc-categories'
      path: '/fpc-categories'
      fullPath: '/configuration/fpc-categories'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationFpcCategoriesRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationRouteRoute
    }
    '/_authenticated/_tenant/configuration/dashboard': {
      id: '/_authenticated/_tenant/configuration/dashboard'
      path: '/dashboard'
      fullPath: '/configuration/dashboard'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationDashboardRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/schedules': {
      id: '/_authenticated/_tenant/catalog-v2/schedules'
      path: '/schedules'
      fullPath: '/catalog-v2/schedules'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2SchedulesRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/needs-attention': {
      id: '/_authenticated/_tenant/catalog-v2/needs-attention'
      path: '/needs-attention'
      fullPath: '/catalog-v2/needs-attention'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2NeedsAttentionRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/cost-approvals': {
      id: '/_authenticated/_tenant/catalog-v2/cost-approvals'
      path: '/cost-approvals'
      fullPath: '/catalog-v2/cost-approvals'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2CostApprovalsRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-operations/products-need-attention': {
      id: '/_authenticated/_tenant/catalog-operations/products-need-attention'
      path: '/catalog-operations/products-need-attention'
      fullPath: '/catalog-operations/products-need-attention'
      preLoaderRoute: typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-operations/$batchId': {
      id: '/_authenticated/_tenant/catalog-operations/$batchId'
      path: '/catalog-operations/$batchId'
      fullPath: '/catalog-operations/$batchId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/needs-attention': {
      id: '/_authenticated/_tenant/catalog-enrichment/needs-attention'
      path: '/needs-attention'
      fullPath: '/catalog-enrichment/needs-attention'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentNeedsAttentionRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/cost-approvals': {
      id: '/_authenticated/_tenant/catalog-enrichment/cost-approvals'
      path: '/cost-approvals'
      fullPath: '/catalog-enrichment/cost-approvals'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentCostApprovalsRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/ai-performance/$workflowId': {
      id: '/_authenticated/_tenant/ai-performance/$workflowId'
      path: '/$workflowId'
      fullPath: '/ai-performance/$workflowId'
      preLoaderRoute: typeof AuthenticatedTenantAiPerformanceWorkflowIdRouteImport
      parentRoute: typeof AuthenticatedTenantAiPerformanceRouteRoute
    }
    '/_authenticated/_tenant/platform/service-auth': {
      id: '/_authenticated/_tenant/platform/service-auth'
      path: '/service-auth'
      fullPath: '/platform/service-auth'
      preLoaderRoute: typeof AuthenticatedTenantPlatformServiceAuthRouteRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/transformers/': {
      id: '/_authenticated/_tenant/platform/transformers/'
      path: '/transformers'
      fullPath: '/platform/transformers/'
      preLoaderRoute: typeof AuthenticatedTenantPlatformTransformersIndexRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/subsidiaries/': {
      id: '/_authenticated/_tenant/platform/subsidiaries/'
      path: '/'
      fullPath: '/platform/subsidiaries/'
      preLoaderRoute: typeof AuthenticatedTenantPlatformSubsidiariesIndexRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformSubsidiariesRoute
    }
    '/_authenticated/_tenant/platform/service-auth/': {
      id: '/_authenticated/_tenant/platform/service-auth/'
      path: '/'
      fullPath: '/platform/service-auth/'
      preLoaderRoute: typeof AuthenticatedTenantPlatformServiceAuthIndexRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformServiceAuthRouteRoute
    }
    '/_authenticated/_tenant/integrations/upload-delivery/': {
      id: '/_authenticated/_tenant/integrations/upload-delivery/'
      path: '/upload-delivery'
      fullPath: '/integrations/upload-delivery/'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsUploadDeliveryIndexRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/pipelines/': {
      id: '/_authenticated/_tenant/integrations/pipelines/'
      path: '/pipelines'
      fullPath: '/integrations/pipelines/'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsPipelinesIndexRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/data-quality/': {
      id: '/_authenticated/_tenant/integrations/data-quality/'
      path: '/data-quality'
      fullPath: '/integrations/data-quality/'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsDataQualityIndexRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/connections/': {
      id: '/_authenticated/_tenant/integrations/connections/'
      path: '/connections'
      fullPath: '/integrations/connections/'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsConnectionsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/exports/catalog/': {
      id: '/_authenticated/_tenant/exports/catalog/'
      path: '/exports/catalog'
      fullPath: '/exports/catalog/'
      preLoaderRoute: typeof AuthenticatedTenantExportsCatalogIndexRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/explorer/data-quality/': {
      id: '/_authenticated/_tenant/explorer/data-quality/'
      path: '/data-quality'
      fullPath: '/explorer/data-quality/'
      preLoaderRoute: typeof AuthenticatedTenantExplorerDataQualityIndexRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/experiments_/create/': {
      id: '/_authenticated/_tenant/experiments_/create/'
      path: '/'
      fullPath: '/experiments/create/'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedTenantExperimentsCreateRoute
    }
    '/_authenticated/_tenant/content/runs/': {
      id: '/_authenticated/_tenant/content/runs/'
      path: '/runs'
      fullPath: '/content/runs/'
      preLoaderRoute: typeof AuthenticatedTenantContentRunsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/qc/': {
      id: '/_authenticated/_tenant/content/qc/'
      path: '/qc'
      fullPath: '/content/qc/'
      preLoaderRoute: typeof AuthenticatedTenantContentQcIndexRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/configuration/manager/': {
      id: '/_authenticated/_tenant/configuration/manager/'
      path: '/'
      fullPath: '/configuration/manager/'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationManagerIndexRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationManagerRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/': {
      id: '/_authenticated/_tenant/catalog-v2/runs/'
      path: '/runs'
      fullPath: '/catalog-v2/runs/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/products/': {
      id: '/_authenticated/_tenant/catalog-v2/products/'
      path: '/products'
      fullPath: '/catalog-v2/products/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2ProductsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/feed-audit/': {
      id: '/_authenticated/_tenant/catalog-v2/feed-audit/'
      path: '/feed-audit'
      fullPath: '/catalog-v2/feed-audit/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2FeedAuditIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/experiments/': {
      id: '/_authenticated/_tenant/catalog-v2/experiments/'
      path: '/experiments'
      fullPath: '/catalog-v2/experiments/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2ExperimentsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/schedules/': {
      id: '/_authenticated/_tenant/catalog-enrichment/schedules/'
      path: '/schedules'
      fullPath: '/catalog-enrichment/schedules/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentSchedulesIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/'
      path: '/runs'
      fullPath: '/catalog-enrichment/runs/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/products/': {
      id: '/_authenticated/_tenant/catalog-enrichment/products/'
      path: '/products'
      fullPath: '/catalog-enrichment/products/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentProductsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/feed-audit/': {
      id: '/_authenticated/_tenant/catalog-enrichment/feed-audit/'
      path: '/feed-audit'
      fullPath: '/catalog-enrichment/feed-audit/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/experiments/': {
      id: '/_authenticated/_tenant/catalog-enrichment/experiments/'
      path: '/experiments'
      fullPath: '/catalog-enrichment/experiments/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentExperimentsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/trial/$platform/enrichment': {
      id: '/_authenticated/_tenant/trial/$platform/enrichment'
      path: '/enrichment'
      fullPath: '/trial/$platform/enrichment'
      preLoaderRoute: typeof AuthenticatedTenantTrialPlatformEnrichmentRouteImport
      parentRoute: typeof AuthenticatedTenantTrialPlatformRoute
    }
    '/_authenticated/_tenant/trial/$platform/create': {
      id: '/_authenticated/_tenant/trial/$platform/create'
      path: '/create'
      fullPath: '/trial/$platform/create'
      preLoaderRoute: typeof AuthenticatedTenantTrialPlatformCreateRouteImport
      parentRoute: typeof AuthenticatedTenantTrialPlatformRoute
    }
    '/_authenticated/_tenant/platform/transformers/$transformerId': {
      id: '/_authenticated/_tenant/platform/transformers/$transformerId'
      path: '/transformers/$transformerId'
      fullPath: '/platform/transformers/$transformerId'
      preLoaderRoute: typeof AuthenticatedTenantPlatformTransformersTransformerIdRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformRouteRoute
    }
    '/_authenticated/_tenant/platform/subsidiaries/onboarding': {
      id: '/_authenticated/_tenant/platform/subsidiaries/onboarding'
      path: '/onboarding'
      fullPath: '/platform/subsidiaries/onboarding'
      preLoaderRoute: typeof AuthenticatedTenantPlatformSubsidiariesOnboardingRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformSubsidiariesRoute
    }
    '/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId': {
      id: '/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId'
      path: '/$subsidiaryId'
      fullPath: '/platform/subsidiaries/$subsidiaryId'
      preLoaderRoute: typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformSubsidiariesRoute
    }
    '/_authenticated/_tenant/platform/service-auth/discovery': {
      id: '/_authenticated/_tenant/platform/service-auth/discovery'
      path: '/discovery'
      fullPath: '/platform/service-auth/discovery'
      preLoaderRoute: typeof AuthenticatedTenantPlatformServiceAuthDiscoveryRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformServiceAuthRouteRoute
    }
    '/_authenticated/_tenant/platform/service-auth/audit': {
      id: '/_authenticated/_tenant/platform/service-auth/audit'
      path: '/audit'
      fullPath: '/platform/service-auth/audit'
      preLoaderRoute: typeof AuthenticatedTenantPlatformServiceAuthAuditRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformServiceAuthRouteRoute
    }
    '/_authenticated/_tenant/onboarding/integration/meta': {
      id: '/_authenticated/_tenant/onboarding/integration/meta'
      path: '/integration/meta'
      fullPath: '/onboarding/integration/meta'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google': {
      id: '/_authenticated/_tenant/onboarding/integration/google'
      path: '/integration/google'
      fullPath: '/onboarding/integration/google'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingRoute
    }
    '/_authenticated/_tenant/oauth/google-ads/callback': {
      id: '/_authenticated/_tenant/oauth/google-ads/callback'
      path: '/oauth/google-ads/callback'
      fullPath: '/oauth/google-ads/callback'
      preLoaderRoute: typeof AuthenticatedTenantOauthGoogleAdsCallbackRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/integrations/datalake_/upload': {
      id: '/_authenticated/_tenant/integrations/datalake_/upload'
      path: '/datalake/upload'
      fullPath: '/integrations/datalake/upload'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsDatalakeUploadRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/data-quality/compare': {
      id: '/_authenticated/_tenant/integrations/data-quality/compare'
      path: '/data-quality/compare'
      fullPath: '/integrations/data-quality/compare'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsDataQualityCompareRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/integrations/connections/new': {
      id: '/_authenticated/_tenant/integrations/connections/new'
      path: '/connections/new'
      fullPath: '/integrations/connections/new'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsConnectionsNewRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/exports/catalog/new': {
      id: '/_authenticated/_tenant/exports/catalog/new'
      path: '/exports/catalog/new'
      fullPath: '/exports/catalog/new'
      preLoaderRoute: typeof AuthenticatedTenantExportsCatalogNewRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/explorer/datalake_/upload': {
      id: '/_authenticated/_tenant/explorer/datalake_/upload'
      path: '/datalake/upload'
      fullPath: '/explorer/datalake/upload'
      preLoaderRoute: typeof AuthenticatedTenantExplorerDatalakeUploadRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/explorer/data-quality/compare': {
      id: '/_authenticated/_tenant/explorer/data-quality/compare'
      path: '/data-quality/compare'
      fullPath: '/explorer/data-quality/compare'
      preLoaderRoute: typeof AuthenticatedTenantExplorerDataQualityCompareRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/experiments_/create/info': {
      id: '/_authenticated/_tenant/experiments_/create/info'
      path: '/info'
      fullPath: '/experiments/create/info'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsCreateInfoRouteImport
      parentRoute: typeof AuthenticatedTenantExperimentsCreateRoute
    }
    '/_authenticated/_tenant/experiments_/create/configure': {
      id: '/_authenticated/_tenant/experiments_/create/configure'
      path: '/configure'
      fullPath: '/experiments/create/configure'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsCreateConfigureRouteImport
      parentRoute: typeof AuthenticatedTenantExperimentsCreateRoute
    }
    '/_authenticated/_tenant/experiments_/$expId/content-enrichment': {
      id: '/_authenticated/_tenant/experiments_/$expId/content-enrichment'
      path: '/experiments/$expId/content-enrichment'
      fullPath: '/experiments/$expId/content-enrichment'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/enrichments/meta/product-selection': {
      id: '/_authenticated/_tenant/enrichments/meta/product-selection'
      path: '/product-selection'
      fullPath: '/enrichments/meta/product-selection'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsMetaProductSelectionRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsMetaRoute
    }
    '/_authenticated/_tenant/enrichments/google/product-selection': {
      id: '/_authenticated/_tenant/enrichments/google/product-selection'
      path: '/product-selection'
      fullPath: '/enrichments/google/product-selection'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsGoogleProductSelectionRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsGoogleRoute
    }
    '/_authenticated/_tenant/deliveries/connections/$connectionId': {
      id: '/_authenticated/_tenant/deliveries/connections/$connectionId'
      path: '/connections/$connectionId'
      fullPath: '/deliveries/connections/$connectionId'
      preLoaderRoute: typeof AuthenticatedTenantDeliveriesConnectionsConnectionIdRouteImport
      parentRoute: typeof AuthenticatedTenantDeliveriesRouteRoute
    }
    '/_authenticated/_tenant/content_/qc/new': {
      id: '/_authenticated/_tenant/content_/qc/new'
      path: '/content/qc/new'
      fullPath: '/content/qc/new'
      preLoaderRoute: typeof AuthenticatedTenantContentQcNewRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/content_/qc/$runId': {
      id: '/_authenticated/_tenant/content_/qc/$runId'
      path: '/content/qc/$runId'
      fullPath: '/content/qc/$runId'
      preLoaderRoute: typeof AuthenticatedTenantContentQcRunIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/content_/catalog/new': {
      id: '/_authenticated/_tenant/content_/catalog/new'
      path: '/content/catalog/new'
      fullPath: '/content/catalog/new'
      preLoaderRoute: typeof AuthenticatedTenantContentCatalogNewRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/content_/catalog/$jobId': {
      id: '/_authenticated/_tenant/content_/catalog/$jobId'
      path: '/content/catalog/$jobId'
      fullPath: '/content/catalog/$jobId'
      preLoaderRoute: typeof AuthenticatedTenantContentCatalogJobIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/content/settings/vocabulary': {
      id: '/_authenticated/_tenant/content/settings/vocabulary'
      path: '/settings/vocabulary'
      fullPath: '/content/settings/vocabulary'
      preLoaderRoute: typeof AuthenticatedTenantContentSettingsVocabularyRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/settings/models': {
      id: '/_authenticated/_tenant/content/settings/models'
      path: '/settings/models'
      fullPath: '/content/settings/models'
      preLoaderRoute: typeof AuthenticatedTenantContentSettingsModelsRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/settings/instructions': {
      id: '/_authenticated/_tenant/content/settings/instructions'
      path: '/settings/instructions'
      fullPath: '/content/settings/instructions'
      preLoaderRoute: typeof AuthenticatedTenantContentSettingsInstructionsRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/runs/how-it-works': {
      id: '/_authenticated/_tenant/content/runs/how-it-works'
      path: '/runs/how-it-works'
      fullPath: '/content/runs/how-it-works'
      preLoaderRoute: typeof AuthenticatedTenantContentRunsHowItWorksRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/runs/$runId': {
      id: '/_authenticated/_tenant/content/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/content/runs/$runId'
      preLoaderRoute: typeof AuthenticatedTenantContentRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/content/jobs_/how-it-works': {
      id: '/_authenticated/_tenant/content/jobs_/how-it-works'
      path: '/jobs/how-it-works'
      fullPath: '/content/jobs/how-it-works'
      preLoaderRoute: typeof AuthenticatedTenantContentJobsHowItWorksRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/configuration/manager/parameters': {
      id: '/_authenticated/_tenant/configuration/manager/parameters'
      path: '/parameters'
      fullPath: '/configuration/manager/parameters'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationManagerParametersRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationManagerRoute
    }
    '/_authenticated/_tenant/configuration/manager/audit-trail': {
      id: '/_authenticated/_tenant/configuration/manager/audit-trail'
      path: '/audit-trail'
      fullPath: '/configuration/manager/audit-trail'
      preLoaderRoute: typeof AuthenticatedTenantConfigurationManagerAuditTrailRouteImport
      parentRoute: typeof AuthenticatedTenantConfigurationManagerRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/new': {
      id: '/_authenticated/_tenant/catalog-v2/runs/new'
      path: '/runs/new'
      fullPath: '/catalog-v2/runs/new'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsNewRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/products/$productId': {
      id: '/_authenticated/_tenant/catalog-v2/products/$productId'
      path: '/products/$productId'
      fullPath: '/catalog-v2/products/$productId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2ProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/feed-products/$feedProductId': {
      id: '/_authenticated/_tenant/catalog-v2/feed-products/$feedProductId'
      path: '/feed-products/$feedProductId'
      fullPath: '/catalog-v2/feed-products/$feedProductId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/feed-audit/new': {
      id: '/_authenticated/_tenant/catalog-v2/feed-audit/new'
      path: '/feed-audit/new'
      fullPath: '/catalog-v2/feed-audit/new'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2FeedAuditNewRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/experiments/new': {
      id: '/_authenticated/_tenant/catalog-v2/experiments/new'
      path: '/experiments/new'
      fullPath: '/catalog-v2/experiments/new'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2ExperimentsNewRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/experiments/$experimentId': {
      id: '/_authenticated/_tenant/catalog-v2/experiments/$experimentId'
      path: '/experiments/$experimentId'
      fullPath: '/catalog-v2/experiments/$experimentId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2ExperimentsExperimentIdRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-operations/products-need-attention_/$productId': {
      id: '/_authenticated/_tenant/catalog-operations/products-need-attention_/$productId'
      path: '/catalog-operations/products-need-attention/$productId'
      fullPath: '/catalog-operations/products-need-attention/$productId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-operations/$batchId_/products': {
      id: '/_authenticated/_tenant/catalog-operations/$batchId_/products'
      path: '/catalog-operations/$batchId/products'
      fullPath: '/catalog-operations/$batchId/products'
      preLoaderRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdProductsRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-operations/$batchId_/deliver': {
      id: '/_authenticated/_tenant/catalog-operations/$batchId_/deliver'
      path: '/catalog-operations/$batchId/deliver'
      fullPath: '/catalog-operations/$batchId/deliver'
      preLoaderRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdDeliverRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-operations/$batchId_/compare-delivery': {
      id: '/_authenticated/_tenant/catalog-operations/$batchId_/compare-delivery'
      path: '/catalog-operations/$batchId/compare-delivery'
      fullPath: '/catalog-operations/$batchId/compare-delivery'
      preLoaderRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/schedules/$scheduleId': {
      id: '/_authenticated/_tenant/catalog-enrichment/schedules/$scheduleId'
      path: '/schedules/$scheduleId'
      fullPath: '/catalog-enrichment/schedules/$scheduleId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/new': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/new'
      path: '/runs/new'
      fullPath: '/catalog-enrichment/runs/new'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsNewRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/products/$productId': {
      id: '/_authenticated/_tenant/catalog-enrichment/products/$productId'
      path: '/products/$productId'
      fullPath: '/catalog-enrichment/products/$productId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/feed-products/$feedProductId': {
      id: '/_authenticated/_tenant/catalog-enrichment/feed-products/$feedProductId'
      path: '/feed-products/$feedProductId'
      fullPath: '/catalog-enrichment/feed-products/$feedProductId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/feed-audit/new': {
      id: '/_authenticated/_tenant/catalog-enrichment/feed-audit/new'
      path: '/feed-audit/new'
      fullPath: '/catalog-enrichment/feed-audit/new'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentFeedAuditNewRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/experiments/new': {
      id: '/_authenticated/_tenant/catalog-enrichment/experiments/new'
      path: '/experiments/new'
      fullPath: '/catalog-enrichment/experiments/new'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentExperimentsNewRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/experiments/$experimentId': {
      id: '/_authenticated/_tenant/catalog-enrichment/experiments/$experimentId'
      path: '/experiments/$experimentId'
      fullPath: '/catalog-enrichment/experiments/$experimentId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/catalog-v2/runs/$runId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/catalog-enrichment/runs/$runId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRoute
    }
    '/_authenticated/_tenant/trial/$platform/enrichment/': {
      id: '/_authenticated/_tenant/trial/$platform/enrichment/'
      path: '/'
      fullPath: '/trial/$platform/enrichment/'
      preLoaderRoute: typeof AuthenticatedTenantTrialPlatformEnrichmentIndexRouteImport
      parentRoute: typeof AuthenticatedTenantTrialPlatformEnrichmentRoute
    }
    '/_authenticated/_tenant/platform/service-auth/users/': {
      id: '/_authenticated/_tenant/platform/service-auth/users/'
      path: '/users'
      fullPath: '/platform/service-auth/users/'
      preLoaderRoute: typeof AuthenticatedTenantPlatformServiceAuthUsersIndexRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformServiceAuthRouteRoute
    }
    '/_authenticated/_tenant/onboarding/integration/meta/': {
      id: '/_authenticated/_tenant/onboarding/integration/meta/'
      path: '/'
      fullPath: '/onboarding/integration/meta/'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaIndexRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/': {
      id: '/_authenticated/_tenant/onboarding/integration/google/'
      path: '/'
      fullPath: '/onboarding/integration/google/'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleIndexRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRoute
    }
    '/_authenticated/_tenant/experiments_/$expId/content-enrichment/': {
      id: '/_authenticated/_tenant/experiments_/$expId/content-enrichment/'
      path: '/'
      fullPath: '/experiments/$expId/content-enrichment/'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRouteImport
      parentRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/'
      path: '/'
      fullPath: '/catalog-v2/runs/$runId/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/'
      path: '/'
      fullPath: '/catalog-enrichment/runs/$runId/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/trial/$platform/enrichment/$id': {
      id: '/_authenticated/_tenant/trial/$platform/enrichment/$id'
      path: '/$id'
      fullPath: '/trial/$platform/enrichment/$id'
      preLoaderRoute: typeof AuthenticatedTenantTrialPlatformEnrichmentIdRouteImport
      parentRoute: typeof AuthenticatedTenantTrialPlatformEnrichmentRoute
    }
    '/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId/products': {
      id: '/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId/products'
      path: '/products'
      fullPath: '/platform/subsidiaries/$subsidiaryId/products'
      preLoaderRoute: typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRoute
    }
    '/_authenticated/_tenant/platform/service-auth/users/$id': {
      id: '/_authenticated/_tenant/platform/service-auth/users/$id'
      path: '/users/$id'
      fullPath: '/platform/service-auth/users/$id'
      preLoaderRoute: typeof AuthenticatedTenantPlatformServiceAuthUsersIdRouteImport
      parentRoute: typeof AuthenticatedTenantPlatformServiceAuthRouteRoute
    }
    '/_authenticated/_tenant/onboarding/integration/meta/sftp': {
      id: '/_authenticated/_tenant/onboarding/integration/meta/sftp'
      path: '/sftp'
      fullPath: '/onboarding/integration/meta/sftp'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaSftpRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaRoute
    }
    '/_authenticated/_tenant/onboarding/integration/meta/product-overview': {
      id: '/_authenticated/_tenant/onboarding/integration/meta/product-overview'
      path: '/product-overview'
      fullPath: '/onboarding/integration/meta/product-overview'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaRoute
    }
    '/_authenticated/_tenant/onboarding/integration/meta/meta-commerce-manager': {
      id: '/_authenticated/_tenant/onboarding/integration/meta/meta-commerce-manager'
      path: '/meta-commerce-manager'
      fullPath: '/onboarding/integration/meta/meta-commerce-manager'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaRoute
    }
    '/_authenticated/_tenant/onboarding/integration/meta/import-catalog': {
      id: '/_authenticated/_tenant/onboarding/integration/meta/import-catalog'
      path: '/import-catalog'
      fullPath: '/onboarding/integration/meta/import-catalog'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaRoute
    }
    '/_authenticated/_tenant/onboarding/integration/meta/complete-import': {
      id: '/_authenticated/_tenant/onboarding/integration/meta/complete-import'
      path: '/complete-import'
      fullPath: '/onboarding/integration/meta/complete-import'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/shopify': {
      id: '/_authenticated/_tenant/onboarding/integration/google/shopify'
      path: '/shopify'
      fullPath: '/onboarding/integration/google/shopify'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleShopifyRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/sftp': {
      id: '/_authenticated/_tenant/onboarding/integration/google/sftp'
      path: '/sftp'
      fullPath: '/onboarding/integration/google/sftp'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleSftpRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/import-catalog': {
      id: '/_authenticated/_tenant/onboarding/integration/google/import-catalog'
      path: '/import-catalog'
      fullPath: '/onboarding/integration/google/import-catalog'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/google-merchant-center': {
      id: '/_authenticated/_tenant/onboarding/integration/google/google-merchant-center'
      path: '/google-merchant-center'
      fullPath: '/onboarding/integration/google/google-merchant-center'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/google-analytics': {
      id: '/_authenticated/_tenant/onboarding/integration/google/google-analytics'
      path: '/google-analytics'
      fullPath: '/onboarding/integration/google/google-analytics'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/google-ads': {
      id: '/_authenticated/_tenant/onboarding/integration/google/google-ads'
      path: '/google-ads'
      fullPath: '/onboarding/integration/google/google-ads'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRoute
    }
    '/_authenticated/_tenant/integrations/connections/connect/$connectorCode': {
      id: '/_authenticated/_tenant/integrations/connections/connect/$connectorCode'
      path: '/connections/connect/$connectorCode'
      fullPath: '/integrations/connections/connect/$connectorCode'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/exports/catalog/runs/$runId': {
      id: '/_authenticated/_tenant/exports/catalog/runs/$runId'
      path: '/exports/catalog/runs/$runId'
      fullPath: '/exports/catalog/runs/$runId'
      preLoaderRoute: typeof AuthenticatedTenantExportsCatalogRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/exports/catalog/profiles/$profileId': {
      id: '/_authenticated/_tenant/exports/catalog/profiles/$profileId'
      path: '/exports/catalog/profiles/$profileId'
      fullPath: '/exports/catalog/profiles/$profileId'
      preLoaderRoute: typeof AuthenticatedTenantExportsCatalogProfilesProfileIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/exports/catalog/exports/$exportId': {
      id: '/_authenticated/_tenant/exports/catalog/exports/$exportId'
      path: '/exports/catalog/exports/$exportId'
      fullPath: '/exports/catalog/exports/$exportId'
      preLoaderRoute: typeof AuthenticatedTenantExportsCatalogExportsExportIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/experiments_/$expId/content-enrichment/review': {
      id: '/_authenticated/_tenant/experiments_/$expId/content-enrichment/review'
      path: '/review'
      fullPath: '/experiments/$expId/content-enrichment/review'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRouteImport
      parentRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute
    }
    '/_authenticated/_tenant/experiments_/$expId/content-enrichment/overview': {
      id: '/_authenticated/_tenant/experiments_/$expId/content-enrichment/overview'
      path: '/overview'
      fullPath: '/experiments/$expId/content-enrichment/overview'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRouteImport
      parentRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute
    }
    '/_authenticated/_tenant/experiments_/$expId/content-enrichment/groups': {
      id: '/_authenticated/_tenant/experiments_/$expId/content-enrichment/groups'
      path: '/groups'
      fullPath: '/experiments/$expId/content-enrichment/groups'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRouteImport
      parentRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute
    }
    '/_authenticated/_tenant/experiments_/$expId/content-enrichment/full': {
      id: '/_authenticated/_tenant/experiments_/$expId/content-enrichment/full'
      path: '/full'
      fullPath: '/experiments/$expId/content-enrichment/full'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRouteImport
      parentRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute
    }
    '/_authenticated/_tenant/experiments_/$expId/content-enrichment/delivery': {
      id: '/_authenticated/_tenant/experiments_/$expId/content-enrichment/delivery'
      path: '/delivery'
      fullPath: '/experiments/$expId/content-enrichment/delivery'
      preLoaderRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRouteImport
      parentRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute
    }
    '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId': {
      id: '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId'
      path: '/content-enrichment/$batchId'
      fullPath: '/enrichments/meta/content-enrichment/$batchId'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsMetaRoute
    }
    '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId': {
      id: '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId'
      path: '/content-enrichment/$batchId'
      fullPath: '/enrichments/google/content-enrichment/$batchId'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsGoogleRoute
    }
    '/_authenticated/_tenant/content/runs/$runId_/review': {
      id: '/_authenticated/_tenant/content/runs/$runId_/review'
      path: '/runs/$runId/review'
      fullPath: '/content/runs/$runId/review'
      preLoaderRoute: typeof AuthenticatedTenantContentRunsRunIdReviewRouteImport
      parentRoute: typeof AuthenticatedTenantContentRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/recovery': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/recovery'
      path: '/recovery'
      fullPath: '/catalog-v2/runs/$runId/recovery'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRecoveryRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/quality-checks': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/quality-checks'
      path: '/quality-checks'
      fullPath: '/catalog-v2/runs/$runId/quality-checks'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/lineage': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/lineage'
      path: '/lineage'
      fullPath: '/catalog-v2/runs/$runId/lineage'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdLineageRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/issues': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/issues'
      path: '/issues'
      fullPath: '/catalog-v2/runs/$runId/issues'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdIssuesRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/insights': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/insights'
      path: '/insights'
      fullPath: '/catalog-v2/runs/$runId/insights'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/images': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/images'
      path: '/images'
      fullPath: '/catalog-v2/runs/$runId/images'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdImagesRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/gate': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/gate'
      path: '/gate'
      fullPath: '/catalog-v2/runs/$runId/gate'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdGateRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/content-results': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/content-results'
      path: '/content-results'
      fullPath: '/catalog-v2/runs/$runId/content-results'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdContentResultsRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/compare': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/compare'
      path: '/compare'
      fullPath: '/catalog-v2/runs/$runId/compare'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdCompareRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/approval': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/approval'
      path: '/approval'
      fullPath: '/catalog-v2/runs/$runId/approval'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdApprovalRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-operations/$batchId_/products_/$productId': {
      id: '/_authenticated/_tenant/catalog-operations/$batchId_/products_/$productId'
      path: '/catalog-operations/$batchId/products/$productId'
      fullPath: '/catalog-operations/$batchId/products/$productId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/recovery': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/recovery'
      path: '/recovery'
      fullPath: '/catalog-enrichment/runs/$runId/recovery'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/quality-checks': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/quality-checks'
      path: '/quality-checks'
      fullPath: '/catalog-enrichment/runs/$runId/quality-checks'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/lineage': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/lineage'
      path: '/lineage'
      fullPath: '/catalog-enrichment/runs/$runId/lineage'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/issues': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/issues'
      path: '/issues'
      fullPath: '/catalog-enrichment/runs/$runId/issues'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights'
      path: '/insights'
      fullPath: '/catalog-enrichment/runs/$runId/insights'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/images': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/images'
      path: '/images'
      fullPath: '/catalog-enrichment/runs/$runId/images'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/gate': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/gate'
      path: '/gate'
      fullPath: '/catalog-enrichment/runs/$runId/gate'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/delivery': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/delivery'
      path: '/delivery'
      fullPath: '/catalog-enrichment/runs/$runId/delivery'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/cost': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/cost'
      path: '/cost'
      fullPath: '/catalog-enrichment/runs/$runId/cost'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/content-results': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/content-results'
      path: '/content-results'
      fullPath: '/catalog-enrichment/runs/$runId/content-results'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/compare': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/compare'
      path: '/compare'
      fullPath: '/catalog-enrichment/runs/$runId/compare'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/approval': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/approval'
      path: '/approval'
      fullPath: '/catalog-enrichment/runs/$runId/approval'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/activity': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/activity'
      path: '/activity'
      fullPath: '/catalog-enrichment/runs/$runId/activity'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/google-analytics/': {
      id: '/_authenticated/_tenant/onboarding/integration/google/google-analytics/'
      path: '/'
      fullPath: '/onboarding/integration/google/google-analytics/'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/google-ads/': {
      id: '/_authenticated/_tenant/onboarding/integration/google/google-ads/'
      path: '/'
      fullPath: '/onboarding/integration/google/google-ads/'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/': {
      id: '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/'
      path: '/adobe-analytics'
      fullPath: '/onboarding/integration/google/adobe-analytics/'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRoute
    }
    '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/': {
      id: '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/'
      path: '/'
      fullPath: '/enrichments/meta/content-enrichment/$batchId/'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/': {
      id: '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/'
      path: '/'
      fullPath: '/enrichments/google/content-enrichment/$batchId/'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/products/': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/products/'
      path: '/products'
      fullPath: '/catalog-v2/runs/$runId/products/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/'
      path: '/products'
      fullPath: '/catalog-enrichment/runs/$runId/products/'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/google-analytics/pick-property': {
      id: '/_authenticated/_tenant/onboarding/integration/google/google-analytics/pick-property'
      path: '/pick-property'
      fullPath: '/onboarding/integration/google/google-analytics/pick-property'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/google-analytics/data-preview': {
      id: '/_authenticated/_tenant/onboarding/integration/google/google-analytics/data-preview'
      path: '/data-preview'
      fullPath: '/onboarding/integration/google/google-analytics/data-preview'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/google-ads/select-account': {
      id: '/_authenticated/_tenant/onboarding/integration/google/google-ads/select-account'
      path: '/select-account'
      fullPath: '/onboarding/integration/google/google-ads/select-account'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/google-ads/confirmation': {
      id: '/_authenticated/_tenant/onboarding/integration/google/google-ads/confirmation'
      path: '/confirmation'
      fullPath: '/onboarding/integration/google/google-ads/confirmation'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute
    }
    '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/extraction': {
      id: '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/extraction'
      path: '/adobe-analytics/extraction'
      fullPath: '/onboarding/integration/google/adobe-analytics/extraction'
      preLoaderRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRouteImport
      parentRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRoute
    }
    '/_authenticated/_tenant/integrations/data-quality/product/$connectionId/$externalId': {
      id: '/_authenticated/_tenant/integrations/data-quality/product/$connectionId/$externalId'
      path: '/data-quality/product/$connectionId/$externalId'
      fullPath: '/integrations/data-quality/product/$connectionId/$externalId'
      preLoaderRoute: typeof AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRouteImport
      parentRoute: typeof AuthenticatedTenantIntegrationsRouteRoute
    }
    '/_authenticated/_tenant/explorer/data-quality/product/$connectionId/$externalId': {
      id: '/_authenticated/_tenant/explorer/data-quality/product/$connectionId/$externalId'
      path: '/data-quality/product/$connectionId/$externalId'
      fullPath: '/explorer/data-quality/product/$connectionId/$externalId'
      preLoaderRoute: typeof AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRouteImport
      parentRoute: typeof AuthenticatedTenantExplorerRouteRoute
    }
    '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId_/deliver': {
      id: '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId_/deliver'
      path: '/content-enrichment/$batchId/deliver'
      fullPath: '/enrichments/meta/content-enrichment/$batchId/deliver'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsMetaRoute
    }
    '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/review': {
      id: '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/review'
      path: '/review'
      fullPath: '/enrichments/meta/content-enrichment/$batchId/review'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/overview': {
      id: '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/overview'
      path: '/overview'
      fullPath: '/enrichments/meta/content-enrichment/$batchId/overview'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/full': {
      id: '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/full'
      path: '/full'
      fullPath: '/enrichments/meta/content-enrichment/$batchId/full'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/delivery': {
      id: '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId/delivery'
      path: '/delivery'
      fullPath: '/enrichments/meta/content-enrichment/$batchId/delivery'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId_/deliver': {
      id: '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId_/deliver'
      path: '/content-enrichment/$batchId/deliver'
      fullPath: '/enrichments/google/content-enrichment/$batchId/deliver'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsGoogleRoute
    }
    '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/review': {
      id: '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/review'
      path: '/review'
      fullPath: '/enrichments/google/content-enrichment/$batchId/review'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/overview': {
      id: '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/overview'
      path: '/overview'
      fullPath: '/enrichments/google/content-enrichment/$batchId/overview'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/full': {
      id: '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/full'
      path: '/full'
      fullPath: '/enrichments/google/content-enrichment/$batchId/full'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/delivery': {
      id: '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/delivery'
      path: '/delivery'
      fullPath: '/enrichments/google/content-enrichment/$batchId/delivery'
      preLoaderRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRouteImport
      parentRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute
    }
    '/_authenticated/_tenant/content_/runs/$runId/products/$productId': {
      id: '/_authenticated/_tenant/content_/runs/$runId/products/$productId'
      path: '/content/runs/$runId/products/$productId'
      fullPath: '/content/runs/$runId/products/$productId'
      preLoaderRoute: typeof AuthenticatedTenantContentRunsRunIdProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedTenantRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/products/$productId': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/products/$productId'
      path: '/products/$productId'
      fullPath: '/catalog-v2/runs/$runId/products/$productId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-v2/runs/$runId/insights_/products': {
      id: '/_authenticated/_tenant/catalog-v2/runs/$runId/insights_/products'
      path: '/insights/products'
      fullPath: '/catalog-v2/runs/$runId/insights/products'
      preLoaderRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/$productId': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/$productId'
      path: '/products/$productId'
      fullPath: '/catalog-enrichment/runs/$runId/products/$productId'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
    '/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights_/products': {
      id: '/_authenticated/_tenant/catalog-enrichment/runs/$runId/insights_/products'
      path: '/insights/products'
      fullPath: '/catalog-enrichment/runs/$runId/insights/products'
      preLoaderRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRouteImport
      parentRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute
    }
  }
}

interface AuthenticatedTenantAiPerformanceRouteRouteChildren {
  AuthenticatedTenantAiPerformanceWorkflowIdRoute: typeof AuthenticatedTenantAiPerformanceWorkflowIdRoute
  AuthenticatedTenantAiPerformanceIndexRoute: typeof AuthenticatedTenantAiPerformanceIndexRoute
}

const AuthenticatedTenantAiPerformanceRouteRouteChildren: AuthenticatedTenantAiPerformanceRouteRouteChildren =
  {
    AuthenticatedTenantAiPerformanceWorkflowIdRoute:
      AuthenticatedTenantAiPerformanceWorkflowIdRoute,
    AuthenticatedTenantAiPerformanceIndexRoute:
      AuthenticatedTenantAiPerformanceIndexRoute,
  }

const AuthenticatedTenantAiPerformanceRouteRouteWithChildren =
  AuthenticatedTenantAiPerformanceRouteRoute._addFileChildren(
    AuthenticatedTenantAiPerformanceRouteRouteChildren,
  )

interface AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteChildren {
  AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRoute
}

const AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteChildren: AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteChildren =
  {
    AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdActivityRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdApprovalRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdCompareRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdContentResultsRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdCostRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdDeliveryRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdGateRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdImagesRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdIssuesRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdLineageRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdQualityChecksRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRecoveryRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdIndexRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdInsightsProductsRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsProductIdRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdProductsIndexRoute,
  }

const AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteWithChildren =
  AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute._addFileChildren(
    AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteChildren,
  )

interface AuthenticatedTenantCatalogEnrichmentRouteRouteChildren {
  AuthenticatedTenantCatalogEnrichmentCostApprovalsRoute: typeof AuthenticatedTenantCatalogEnrichmentCostApprovalsRoute
  AuthenticatedTenantCatalogEnrichmentNeedsAttentionRoute: typeof AuthenticatedTenantCatalogEnrichmentNeedsAttentionRoute
  AuthenticatedTenantCatalogEnrichmentIndexRoute: typeof AuthenticatedTenantCatalogEnrichmentIndexRoute
  AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteWithChildren
  AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRoute: typeof AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRoute
  AuthenticatedTenantCatalogEnrichmentExperimentsNewRoute: typeof AuthenticatedTenantCatalogEnrichmentExperimentsNewRoute
  AuthenticatedTenantCatalogEnrichmentFeedAuditNewRoute: typeof AuthenticatedTenantCatalogEnrichmentFeedAuditNewRoute
  AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRoute: typeof AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRoute
  AuthenticatedTenantCatalogEnrichmentProductsProductIdRoute: typeof AuthenticatedTenantCatalogEnrichmentProductsProductIdRoute
  AuthenticatedTenantCatalogEnrichmentRunsNewRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsNewRoute
  AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRoute: typeof AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRoute
  AuthenticatedTenantCatalogEnrichmentExperimentsIndexRoute: typeof AuthenticatedTenantCatalogEnrichmentExperimentsIndexRoute
  AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRoute: typeof AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRoute
  AuthenticatedTenantCatalogEnrichmentProductsIndexRoute: typeof AuthenticatedTenantCatalogEnrichmentProductsIndexRoute
  AuthenticatedTenantCatalogEnrichmentRunsIndexRoute: typeof AuthenticatedTenantCatalogEnrichmentRunsIndexRoute
  AuthenticatedTenantCatalogEnrichmentSchedulesIndexRoute: typeof AuthenticatedTenantCatalogEnrichmentSchedulesIndexRoute
}

const AuthenticatedTenantCatalogEnrichmentRouteRouteChildren: AuthenticatedTenantCatalogEnrichmentRouteRouteChildren =
  {
    AuthenticatedTenantCatalogEnrichmentCostApprovalsRoute:
      AuthenticatedTenantCatalogEnrichmentCostApprovalsRoute,
    AuthenticatedTenantCatalogEnrichmentNeedsAttentionRoute:
      AuthenticatedTenantCatalogEnrichmentNeedsAttentionRoute,
    AuthenticatedTenantCatalogEnrichmentIndexRoute:
      AuthenticatedTenantCatalogEnrichmentIndexRoute,
    AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRoute:
      AuthenticatedTenantCatalogEnrichmentRunsRunIdRouteRouteWithChildren,
    AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRoute:
      AuthenticatedTenantCatalogEnrichmentExperimentsExperimentIdRoute,
    AuthenticatedTenantCatalogEnrichmentExperimentsNewRoute:
      AuthenticatedTenantCatalogEnrichmentExperimentsNewRoute,
    AuthenticatedTenantCatalogEnrichmentFeedAuditNewRoute:
      AuthenticatedTenantCatalogEnrichmentFeedAuditNewRoute,
    AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRoute:
      AuthenticatedTenantCatalogEnrichmentFeedProductsFeedProductIdRoute,
    AuthenticatedTenantCatalogEnrichmentProductsProductIdRoute:
      AuthenticatedTenantCatalogEnrichmentProductsProductIdRoute,
    AuthenticatedTenantCatalogEnrichmentRunsNewRoute:
      AuthenticatedTenantCatalogEnrichmentRunsNewRoute,
    AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRoute:
      AuthenticatedTenantCatalogEnrichmentSchedulesScheduleIdRoute,
    AuthenticatedTenantCatalogEnrichmentExperimentsIndexRoute:
      AuthenticatedTenantCatalogEnrichmentExperimentsIndexRoute,
    AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRoute:
      AuthenticatedTenantCatalogEnrichmentFeedAuditIndexRoute,
    AuthenticatedTenantCatalogEnrichmentProductsIndexRoute:
      AuthenticatedTenantCatalogEnrichmentProductsIndexRoute,
    AuthenticatedTenantCatalogEnrichmentRunsIndexRoute:
      AuthenticatedTenantCatalogEnrichmentRunsIndexRoute,
    AuthenticatedTenantCatalogEnrichmentSchedulesIndexRoute:
      AuthenticatedTenantCatalogEnrichmentSchedulesIndexRoute,
  }

const AuthenticatedTenantCatalogEnrichmentRouteRouteWithChildren =
  AuthenticatedTenantCatalogEnrichmentRouteRoute._addFileChildren(
    AuthenticatedTenantCatalogEnrichmentRouteRouteChildren,
  )

interface AuthenticatedTenantCatalogV2RunsRunIdRouteRouteChildren {
  AuthenticatedTenantCatalogV2RunsRunIdApprovalRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdApprovalRoute
  AuthenticatedTenantCatalogV2RunsRunIdCompareRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdCompareRoute
  AuthenticatedTenantCatalogV2RunsRunIdContentResultsRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdContentResultsRoute
  AuthenticatedTenantCatalogV2RunsRunIdGateRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdGateRoute
  AuthenticatedTenantCatalogV2RunsRunIdImagesRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdImagesRoute
  AuthenticatedTenantCatalogV2RunsRunIdInsightsRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsRoute
  AuthenticatedTenantCatalogV2RunsRunIdIssuesRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdIssuesRoute
  AuthenticatedTenantCatalogV2RunsRunIdLineageRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdLineageRoute
  AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRoute
  AuthenticatedTenantCatalogV2RunsRunIdRecoveryRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRecoveryRoute
  AuthenticatedTenantCatalogV2RunsRunIdIndexRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdIndexRoute
  AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRoute
  AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRoute
  AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRoute
}

const AuthenticatedTenantCatalogV2RunsRunIdRouteRouteChildren: AuthenticatedTenantCatalogV2RunsRunIdRouteRouteChildren =
  {
    AuthenticatedTenantCatalogV2RunsRunIdApprovalRoute:
      AuthenticatedTenantCatalogV2RunsRunIdApprovalRoute,
    AuthenticatedTenantCatalogV2RunsRunIdCompareRoute:
      AuthenticatedTenantCatalogV2RunsRunIdCompareRoute,
    AuthenticatedTenantCatalogV2RunsRunIdContentResultsRoute:
      AuthenticatedTenantCatalogV2RunsRunIdContentResultsRoute,
    AuthenticatedTenantCatalogV2RunsRunIdGateRoute:
      AuthenticatedTenantCatalogV2RunsRunIdGateRoute,
    AuthenticatedTenantCatalogV2RunsRunIdImagesRoute:
      AuthenticatedTenantCatalogV2RunsRunIdImagesRoute,
    AuthenticatedTenantCatalogV2RunsRunIdInsightsRoute:
      AuthenticatedTenantCatalogV2RunsRunIdInsightsRoute,
    AuthenticatedTenantCatalogV2RunsRunIdIssuesRoute:
      AuthenticatedTenantCatalogV2RunsRunIdIssuesRoute,
    AuthenticatedTenantCatalogV2RunsRunIdLineageRoute:
      AuthenticatedTenantCatalogV2RunsRunIdLineageRoute,
    AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRoute:
      AuthenticatedTenantCatalogV2RunsRunIdQualityChecksRoute,
    AuthenticatedTenantCatalogV2RunsRunIdRecoveryRoute:
      AuthenticatedTenantCatalogV2RunsRunIdRecoveryRoute,
    AuthenticatedTenantCatalogV2RunsRunIdIndexRoute:
      AuthenticatedTenantCatalogV2RunsRunIdIndexRoute,
    AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRoute:
      AuthenticatedTenantCatalogV2RunsRunIdInsightsProductsRoute,
    AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRoute:
      AuthenticatedTenantCatalogV2RunsRunIdProductsProductIdRoute,
    AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRoute:
      AuthenticatedTenantCatalogV2RunsRunIdProductsIndexRoute,
  }

const AuthenticatedTenantCatalogV2RunsRunIdRouteRouteWithChildren =
  AuthenticatedTenantCatalogV2RunsRunIdRouteRoute._addFileChildren(
    AuthenticatedTenantCatalogV2RunsRunIdRouteRouteChildren,
  )

interface AuthenticatedTenantCatalogV2RouteRouteChildren {
  AuthenticatedTenantCatalogV2CostApprovalsRoute: typeof AuthenticatedTenantCatalogV2CostApprovalsRoute
  AuthenticatedTenantCatalogV2NeedsAttentionRoute: typeof AuthenticatedTenantCatalogV2NeedsAttentionRoute
  AuthenticatedTenantCatalogV2SchedulesRoute: typeof AuthenticatedTenantCatalogV2SchedulesRoute
  AuthenticatedTenantCatalogV2IndexRoute: typeof AuthenticatedTenantCatalogV2IndexRoute
  AuthenticatedTenantCatalogV2RunsRunIdRouteRoute: typeof AuthenticatedTenantCatalogV2RunsRunIdRouteRouteWithChildren
  AuthenticatedTenantCatalogV2ExperimentsExperimentIdRoute: typeof AuthenticatedTenantCatalogV2ExperimentsExperimentIdRoute
  AuthenticatedTenantCatalogV2ExperimentsNewRoute: typeof AuthenticatedTenantCatalogV2ExperimentsNewRoute
  AuthenticatedTenantCatalogV2FeedAuditNewRoute: typeof AuthenticatedTenantCatalogV2FeedAuditNewRoute
  AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRoute: typeof AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRoute
  AuthenticatedTenantCatalogV2ProductsProductIdRoute: typeof AuthenticatedTenantCatalogV2ProductsProductIdRoute
  AuthenticatedTenantCatalogV2RunsNewRoute: typeof AuthenticatedTenantCatalogV2RunsNewRoute
  AuthenticatedTenantCatalogV2ExperimentsIndexRoute: typeof AuthenticatedTenantCatalogV2ExperimentsIndexRoute
  AuthenticatedTenantCatalogV2FeedAuditIndexRoute: typeof AuthenticatedTenantCatalogV2FeedAuditIndexRoute
  AuthenticatedTenantCatalogV2ProductsIndexRoute: typeof AuthenticatedTenantCatalogV2ProductsIndexRoute
  AuthenticatedTenantCatalogV2RunsIndexRoute: typeof AuthenticatedTenantCatalogV2RunsIndexRoute
}

const AuthenticatedTenantCatalogV2RouteRouteChildren: AuthenticatedTenantCatalogV2RouteRouteChildren =
  {
    AuthenticatedTenantCatalogV2CostApprovalsRoute:
      AuthenticatedTenantCatalogV2CostApprovalsRoute,
    AuthenticatedTenantCatalogV2NeedsAttentionRoute:
      AuthenticatedTenantCatalogV2NeedsAttentionRoute,
    AuthenticatedTenantCatalogV2SchedulesRoute:
      AuthenticatedTenantCatalogV2SchedulesRoute,
    AuthenticatedTenantCatalogV2IndexRoute:
      AuthenticatedTenantCatalogV2IndexRoute,
    AuthenticatedTenantCatalogV2RunsRunIdRouteRoute:
      AuthenticatedTenantCatalogV2RunsRunIdRouteRouteWithChildren,
    AuthenticatedTenantCatalogV2ExperimentsExperimentIdRoute:
      AuthenticatedTenantCatalogV2ExperimentsExperimentIdRoute,
    AuthenticatedTenantCatalogV2ExperimentsNewRoute:
      AuthenticatedTenantCatalogV2ExperimentsNewRoute,
    AuthenticatedTenantCatalogV2FeedAuditNewRoute:
      AuthenticatedTenantCatalogV2FeedAuditNewRoute,
    AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRoute:
      AuthenticatedTenantCatalogV2FeedProductsFeedProductIdRoute,
    AuthenticatedTenantCatalogV2ProductsProductIdRoute:
      AuthenticatedTenantCatalogV2ProductsProductIdRoute,
    AuthenticatedTenantCatalogV2RunsNewRoute:
      AuthenticatedTenantCatalogV2RunsNewRoute,
    AuthenticatedTenantCatalogV2ExperimentsIndexRoute:
      AuthenticatedTenantCatalogV2ExperimentsIndexRoute,
    AuthenticatedTenantCatalogV2FeedAuditIndexRoute:
      AuthenticatedTenantCatalogV2FeedAuditIndexRoute,
    AuthenticatedTenantCatalogV2ProductsIndexRoute:
      AuthenticatedTenantCatalogV2ProductsIndexRoute,
    AuthenticatedTenantCatalogV2RunsIndexRoute:
      AuthenticatedTenantCatalogV2RunsIndexRoute,
  }

const AuthenticatedTenantCatalogV2RouteRouteWithChildren =
  AuthenticatedTenantCatalogV2RouteRoute._addFileChildren(
    AuthenticatedTenantCatalogV2RouteRouteChildren,
  )

interface AuthenticatedTenantConfigurationManagerRouteChildren {
  AuthenticatedTenantConfigurationManagerAuditTrailRoute: typeof AuthenticatedTenantConfigurationManagerAuditTrailRoute
  AuthenticatedTenantConfigurationManagerParametersRoute: typeof AuthenticatedTenantConfigurationManagerParametersRoute
  AuthenticatedTenantConfigurationManagerIndexRoute: typeof AuthenticatedTenantConfigurationManagerIndexRoute
}

const AuthenticatedTenantConfigurationManagerRouteChildren: AuthenticatedTenantConfigurationManagerRouteChildren =
  {
    AuthenticatedTenantConfigurationManagerAuditTrailRoute:
      AuthenticatedTenantConfigurationManagerAuditTrailRoute,
    AuthenticatedTenantConfigurationManagerParametersRoute:
      AuthenticatedTenantConfigurationManagerParametersRoute,
    AuthenticatedTenantConfigurationManagerIndexRoute:
      AuthenticatedTenantConfigurationManagerIndexRoute,
  }

const AuthenticatedTenantConfigurationManagerRouteWithChildren =
  AuthenticatedTenantConfigurationManagerRoute._addFileChildren(
    AuthenticatedTenantConfigurationManagerRouteChildren,
  )

interface AuthenticatedTenantConfigurationRouteRouteChildren {
  AuthenticatedTenantConfigurationDashboardRoute: typeof AuthenticatedTenantConfigurationDashboardRoute
  AuthenticatedTenantConfigurationFpcCategoriesRoute: typeof AuthenticatedTenantConfigurationFpcCategoriesRoute
  AuthenticatedTenantConfigurationGpcCategoriesRoute: typeof AuthenticatedTenantConfigurationGpcCategoriesRoute
  AuthenticatedTenantConfigurationLilyTaxonomyRoute: typeof AuthenticatedTenantConfigurationLilyTaxonomyRoute
  AuthenticatedTenantConfigurationManagerRoute: typeof AuthenticatedTenantConfigurationManagerRouteWithChildren
  AuthenticatedTenantConfigurationPromptsRoute: typeof AuthenticatedTenantConfigurationPromptsRoute
  AuthenticatedTenantConfigurationTreatmentRoute: typeof AuthenticatedTenantConfigurationTreatmentRoute
  AuthenticatedTenantConfigurationIndexRoute: typeof AuthenticatedTenantConfigurationIndexRoute
}

const AuthenticatedTenantConfigurationRouteRouteChildren: AuthenticatedTenantConfigurationRouteRouteChildren =
  {
    AuthenticatedTenantConfigurationDashboardRoute:
      AuthenticatedTenantConfigurationDashboardRoute,
    AuthenticatedTenantConfigurationFpcCategoriesRoute:
      AuthenticatedTenantConfigurationFpcCategoriesRoute,
    AuthenticatedTenantConfigurationGpcCategoriesRoute:
      AuthenticatedTenantConfigurationGpcCategoriesRoute,
    AuthenticatedTenantConfigurationLilyTaxonomyRoute:
      AuthenticatedTenantConfigurationLilyTaxonomyRoute,
    AuthenticatedTenantConfigurationManagerRoute:
      AuthenticatedTenantConfigurationManagerRouteWithChildren,
    AuthenticatedTenantConfigurationPromptsRoute:
      AuthenticatedTenantConfigurationPromptsRoute,
    AuthenticatedTenantConfigurationTreatmentRoute:
      AuthenticatedTenantConfigurationTreatmentRoute,
    AuthenticatedTenantConfigurationIndexRoute:
      AuthenticatedTenantConfigurationIndexRoute,
  }

const AuthenticatedTenantConfigurationRouteRouteWithChildren =
  AuthenticatedTenantConfigurationRouteRoute._addFileChildren(
    AuthenticatedTenantConfigurationRouteRouteChildren,
  )

interface AuthenticatedTenantContentRouteRouteChildren {
  AuthenticatedTenantContentAttributionRoute: typeof AuthenticatedTenantContentAttributionRoute
  AuthenticatedTenantContentJobsRoute: typeof AuthenticatedTenantContentJobsRoute
  AuthenticatedTenantContentModelConfigurationRoute: typeof AuthenticatedTenantContentModelConfigurationRoute
  AuthenticatedTenantContentOverviewRoute: typeof AuthenticatedTenantContentOverviewRoute
  AuthenticatedTenantContentPromptsRoute: typeof AuthenticatedTenantContentPromptsRoute
  AuthenticatedTenantContentReviewRoute: typeof AuthenticatedTenantContentReviewRoute
  AuthenticatedTenantContentIndexRoute: typeof AuthenticatedTenantContentIndexRoute
  AuthenticatedTenantContentJobsHowItWorksRoute: typeof AuthenticatedTenantContentJobsHowItWorksRoute
  AuthenticatedTenantContentRunsRunIdRoute: typeof AuthenticatedTenantContentRunsRunIdRoute
  AuthenticatedTenantContentRunsHowItWorksRoute: typeof AuthenticatedTenantContentRunsHowItWorksRoute
  AuthenticatedTenantContentSettingsInstructionsRoute: typeof AuthenticatedTenantContentSettingsInstructionsRoute
  AuthenticatedTenantContentSettingsModelsRoute: typeof AuthenticatedTenantContentSettingsModelsRoute
  AuthenticatedTenantContentSettingsVocabularyRoute: typeof AuthenticatedTenantContentSettingsVocabularyRoute
  AuthenticatedTenantContentQcIndexRoute: typeof AuthenticatedTenantContentQcIndexRoute
  AuthenticatedTenantContentRunsIndexRoute: typeof AuthenticatedTenantContentRunsIndexRoute
  AuthenticatedTenantContentRunsRunIdReviewRoute: typeof AuthenticatedTenantContentRunsRunIdReviewRoute
}

const AuthenticatedTenantContentRouteRouteChildren: AuthenticatedTenantContentRouteRouteChildren =
  {
    AuthenticatedTenantContentAttributionRoute:
      AuthenticatedTenantContentAttributionRoute,
    AuthenticatedTenantContentJobsRoute: AuthenticatedTenantContentJobsRoute,
    AuthenticatedTenantContentModelConfigurationRoute:
      AuthenticatedTenantContentModelConfigurationRoute,
    AuthenticatedTenantContentOverviewRoute:
      AuthenticatedTenantContentOverviewRoute,
    AuthenticatedTenantContentPromptsRoute:
      AuthenticatedTenantContentPromptsRoute,
    AuthenticatedTenantContentReviewRoute:
      AuthenticatedTenantContentReviewRoute,
    AuthenticatedTenantContentIndexRoute: AuthenticatedTenantContentIndexRoute,
    AuthenticatedTenantContentJobsHowItWorksRoute:
      AuthenticatedTenantContentJobsHowItWorksRoute,
    AuthenticatedTenantContentRunsRunIdRoute:
      AuthenticatedTenantContentRunsRunIdRoute,
    AuthenticatedTenantContentRunsHowItWorksRoute:
      AuthenticatedTenantContentRunsHowItWorksRoute,
    AuthenticatedTenantContentSettingsInstructionsRoute:
      AuthenticatedTenantContentSettingsInstructionsRoute,
    AuthenticatedTenantContentSettingsModelsRoute:
      AuthenticatedTenantContentSettingsModelsRoute,
    AuthenticatedTenantContentSettingsVocabularyRoute:
      AuthenticatedTenantContentSettingsVocabularyRoute,
    AuthenticatedTenantContentQcIndexRoute:
      AuthenticatedTenantContentQcIndexRoute,
    AuthenticatedTenantContentRunsIndexRoute:
      AuthenticatedTenantContentRunsIndexRoute,
    AuthenticatedTenantContentRunsRunIdReviewRoute:
      AuthenticatedTenantContentRunsRunIdReviewRoute,
  }

const AuthenticatedTenantContentRouteRouteWithChildren =
  AuthenticatedTenantContentRouteRoute._addFileChildren(
    AuthenticatedTenantContentRouteRouteChildren,
  )

interface AuthenticatedTenantDeliveriesRouteRouteChildren {
  AuthenticatedTenantDeliveriesRunIdRoute: typeof AuthenticatedTenantDeliveriesRunIdRoute
  AuthenticatedTenantDeliveriesNewRoute: typeof AuthenticatedTenantDeliveriesNewRoute
  AuthenticatedTenantDeliveriesIndexRoute: typeof AuthenticatedTenantDeliveriesIndexRoute
  AuthenticatedTenantDeliveriesConnectionsConnectionIdRoute: typeof AuthenticatedTenantDeliveriesConnectionsConnectionIdRoute
}

const AuthenticatedTenantDeliveriesRouteRouteChildren: AuthenticatedTenantDeliveriesRouteRouteChildren =
  {
    AuthenticatedTenantDeliveriesRunIdRoute:
      AuthenticatedTenantDeliveriesRunIdRoute,
    AuthenticatedTenantDeliveriesNewRoute:
      AuthenticatedTenantDeliveriesNewRoute,
    AuthenticatedTenantDeliveriesIndexRoute:
      AuthenticatedTenantDeliveriesIndexRoute,
    AuthenticatedTenantDeliveriesConnectionsConnectionIdRoute:
      AuthenticatedTenantDeliveriesConnectionsConnectionIdRoute,
  }

const AuthenticatedTenantDeliveriesRouteRouteWithChildren =
  AuthenticatedTenantDeliveriesRouteRoute._addFileChildren(
    AuthenticatedTenantDeliveriesRouteRouteChildren,
  )

interface AuthenticatedTenantExplorerRouteRouteChildren {
  AuthenticatedTenantExplorerCatalogImagesRoute: typeof AuthenticatedTenantExplorerCatalogImagesRoute
  AuthenticatedTenantExplorerClickhouseRoute: typeof AuthenticatedTenantExplorerClickhouseRoute
  AuthenticatedTenantExplorerCoverageRoute: typeof AuthenticatedTenantExplorerCoverageRoute
  AuthenticatedTenantExplorerDatalakeRoute: typeof AuthenticatedTenantExplorerDatalakeRoute
  AuthenticatedTenantExplorerKeywordPlannerRoute: typeof AuthenticatedTenantExplorerKeywordPlannerRoute
  AuthenticatedTenantExplorerProductsRoute: typeof AuthenticatedTenantExplorerProductsRoute
  AuthenticatedTenantExplorerIndexRoute: typeof AuthenticatedTenantExplorerIndexRoute
  AuthenticatedTenantExplorerDataQualityCompareRoute: typeof AuthenticatedTenantExplorerDataQualityCompareRoute
  AuthenticatedTenantExplorerDatalakeUploadRoute: typeof AuthenticatedTenantExplorerDatalakeUploadRoute
  AuthenticatedTenantExplorerDataQualityIndexRoute: typeof AuthenticatedTenantExplorerDataQualityIndexRoute
  AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRoute: typeof AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRoute
}

const AuthenticatedTenantExplorerRouteRouteChildren: AuthenticatedTenantExplorerRouteRouteChildren =
  {
    AuthenticatedTenantExplorerCatalogImagesRoute:
      AuthenticatedTenantExplorerCatalogImagesRoute,
    AuthenticatedTenantExplorerClickhouseRoute:
      AuthenticatedTenantExplorerClickhouseRoute,
    AuthenticatedTenantExplorerCoverageRoute:
      AuthenticatedTenantExplorerCoverageRoute,
    AuthenticatedTenantExplorerDatalakeRoute:
      AuthenticatedTenantExplorerDatalakeRoute,
    AuthenticatedTenantExplorerKeywordPlannerRoute:
      AuthenticatedTenantExplorerKeywordPlannerRoute,
    AuthenticatedTenantExplorerProductsRoute:
      AuthenticatedTenantExplorerProductsRoute,
    AuthenticatedTenantExplorerIndexRoute:
      AuthenticatedTenantExplorerIndexRoute,
    AuthenticatedTenantExplorerDataQualityCompareRoute:
      AuthenticatedTenantExplorerDataQualityCompareRoute,
    AuthenticatedTenantExplorerDatalakeUploadRoute:
      AuthenticatedTenantExplorerDatalakeUploadRoute,
    AuthenticatedTenantExplorerDataQualityIndexRoute:
      AuthenticatedTenantExplorerDataQualityIndexRoute,
    AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRoute:
      AuthenticatedTenantExplorerDataQualityProductConnectionIdExternalIdRoute,
  }

const AuthenticatedTenantExplorerRouteRouteWithChildren =
  AuthenticatedTenantExplorerRouteRoute._addFileChildren(
    AuthenticatedTenantExplorerRouteRouteChildren,
  )

interface AuthenticatedTenantFeedAuditRouteRouteChildren {
  AuthenticatedTenantFeedAuditIdRoute: typeof AuthenticatedTenantFeedAuditIdRoute
  AuthenticatedTenantFeedAuditCreateRoute: typeof AuthenticatedTenantFeedAuditCreateRoute
  AuthenticatedTenantFeedAuditUploadRoute: typeof AuthenticatedTenantFeedAuditUploadRoute
  AuthenticatedTenantFeedAuditIndexRoute: typeof AuthenticatedTenantFeedAuditIndexRoute
}

const AuthenticatedTenantFeedAuditRouteRouteChildren: AuthenticatedTenantFeedAuditRouteRouteChildren =
  {
    AuthenticatedTenantFeedAuditIdRoute: AuthenticatedTenantFeedAuditIdRoute,
    AuthenticatedTenantFeedAuditCreateRoute:
      AuthenticatedTenantFeedAuditCreateRoute,
    AuthenticatedTenantFeedAuditUploadRoute:
      AuthenticatedTenantFeedAuditUploadRoute,
    AuthenticatedTenantFeedAuditIndexRoute:
      AuthenticatedTenantFeedAuditIndexRoute,
  }

const AuthenticatedTenantFeedAuditRouteRouteWithChildren =
  AuthenticatedTenantFeedAuditRouteRoute._addFileChildren(
    AuthenticatedTenantFeedAuditRouteRouteChildren,
  )

interface AuthenticatedTenantIntegrationsRouteRouteChildren {
  AuthenticatedTenantIntegrationsCatalogImagesRoute: typeof AuthenticatedTenantIntegrationsCatalogImagesRoute
  AuthenticatedTenantIntegrationsClickhouseRoute: typeof AuthenticatedTenantIntegrationsClickhouseRoute
  AuthenticatedTenantIntegrationsConnectorsRoute: typeof AuthenticatedTenantIntegrationsConnectorsRoute
  AuthenticatedTenantIntegrationsCoverageRoute: typeof AuthenticatedTenantIntegrationsCoverageRoute
  AuthenticatedTenantIntegrationsDatalakeRoute: typeof AuthenticatedTenantIntegrationsDatalakeRoute
  AuthenticatedTenantIntegrationsHealthRoute: typeof AuthenticatedTenantIntegrationsHealthRoute
  AuthenticatedTenantIntegrationsKeywordPlannerRoute: typeof AuthenticatedTenantIntegrationsKeywordPlannerRoute
  AuthenticatedTenantIntegrationsProductsRoute: typeof AuthenticatedTenantIntegrationsProductsRoute
  AuthenticatedTenantIntegrationsSchedulesRoute: typeof AuthenticatedTenantIntegrationsSchedulesRoute
  AuthenticatedTenantIntegrationsIndexRoute: typeof AuthenticatedTenantIntegrationsIndexRoute
  AuthenticatedTenantIntegrationsConnectionsNewRoute: typeof AuthenticatedTenantIntegrationsConnectionsNewRoute
  AuthenticatedTenantIntegrationsDataQualityCompareRoute: typeof AuthenticatedTenantIntegrationsDataQualityCompareRoute
  AuthenticatedTenantIntegrationsDatalakeUploadRoute: typeof AuthenticatedTenantIntegrationsDatalakeUploadRoute
  AuthenticatedTenantIntegrationsConnectionsIndexRoute: typeof AuthenticatedTenantIntegrationsConnectionsIndexRoute
  AuthenticatedTenantIntegrationsDataQualityIndexRoute: typeof AuthenticatedTenantIntegrationsDataQualityIndexRoute
  AuthenticatedTenantIntegrationsPipelinesIndexRoute: typeof AuthenticatedTenantIntegrationsPipelinesIndexRoute
  AuthenticatedTenantIntegrationsUploadDeliveryIndexRoute: typeof AuthenticatedTenantIntegrationsUploadDeliveryIndexRoute
  AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRoute: typeof AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRoute
  AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRoute: typeof AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRoute
}

const AuthenticatedTenantIntegrationsRouteRouteChildren: AuthenticatedTenantIntegrationsRouteRouteChildren =
  {
    AuthenticatedTenantIntegrationsCatalogImagesRoute:
      AuthenticatedTenantIntegrationsCatalogImagesRoute,
    AuthenticatedTenantIntegrationsClickhouseRoute:
      AuthenticatedTenantIntegrationsClickhouseRoute,
    AuthenticatedTenantIntegrationsConnectorsRoute:
      AuthenticatedTenantIntegrationsConnectorsRoute,
    AuthenticatedTenantIntegrationsCoverageRoute:
      AuthenticatedTenantIntegrationsCoverageRoute,
    AuthenticatedTenantIntegrationsDatalakeRoute:
      AuthenticatedTenantIntegrationsDatalakeRoute,
    AuthenticatedTenantIntegrationsHealthRoute:
      AuthenticatedTenantIntegrationsHealthRoute,
    AuthenticatedTenantIntegrationsKeywordPlannerRoute:
      AuthenticatedTenantIntegrationsKeywordPlannerRoute,
    AuthenticatedTenantIntegrationsProductsRoute:
      AuthenticatedTenantIntegrationsProductsRoute,
    AuthenticatedTenantIntegrationsSchedulesRoute:
      AuthenticatedTenantIntegrationsSchedulesRoute,
    AuthenticatedTenantIntegrationsIndexRoute:
      AuthenticatedTenantIntegrationsIndexRoute,
    AuthenticatedTenantIntegrationsConnectionsNewRoute:
      AuthenticatedTenantIntegrationsConnectionsNewRoute,
    AuthenticatedTenantIntegrationsDataQualityCompareRoute:
      AuthenticatedTenantIntegrationsDataQualityCompareRoute,
    AuthenticatedTenantIntegrationsDatalakeUploadRoute:
      AuthenticatedTenantIntegrationsDatalakeUploadRoute,
    AuthenticatedTenantIntegrationsConnectionsIndexRoute:
      AuthenticatedTenantIntegrationsConnectionsIndexRoute,
    AuthenticatedTenantIntegrationsDataQualityIndexRoute:
      AuthenticatedTenantIntegrationsDataQualityIndexRoute,
    AuthenticatedTenantIntegrationsPipelinesIndexRoute:
      AuthenticatedTenantIntegrationsPipelinesIndexRoute,
    AuthenticatedTenantIntegrationsUploadDeliveryIndexRoute:
      AuthenticatedTenantIntegrationsUploadDeliveryIndexRoute,
    AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRoute:
      AuthenticatedTenantIntegrationsConnectionsConnectConnectorCodeRoute,
    AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRoute:
      AuthenticatedTenantIntegrationsDataQualityProductConnectionIdExternalIdRoute,
  }

const AuthenticatedTenantIntegrationsRouteRouteWithChildren =
  AuthenticatedTenantIntegrationsRouteRoute._addFileChildren(
    AuthenticatedTenantIntegrationsRouteRouteChildren,
  )

interface AuthenticatedTenantPlatformServiceAuthRouteRouteChildren {
  AuthenticatedTenantPlatformServiceAuthAuditRoute: typeof AuthenticatedTenantPlatformServiceAuthAuditRoute
  AuthenticatedTenantPlatformServiceAuthDiscoveryRoute: typeof AuthenticatedTenantPlatformServiceAuthDiscoveryRoute
  AuthenticatedTenantPlatformServiceAuthIndexRoute: typeof AuthenticatedTenantPlatformServiceAuthIndexRoute
  AuthenticatedTenantPlatformServiceAuthUsersIdRoute: typeof AuthenticatedTenantPlatformServiceAuthUsersIdRoute
  AuthenticatedTenantPlatformServiceAuthUsersIndexRoute: typeof AuthenticatedTenantPlatformServiceAuthUsersIndexRoute
}

const AuthenticatedTenantPlatformServiceAuthRouteRouteChildren: AuthenticatedTenantPlatformServiceAuthRouteRouteChildren =
  {
    AuthenticatedTenantPlatformServiceAuthAuditRoute:
      AuthenticatedTenantPlatformServiceAuthAuditRoute,
    AuthenticatedTenantPlatformServiceAuthDiscoveryRoute:
      AuthenticatedTenantPlatformServiceAuthDiscoveryRoute,
    AuthenticatedTenantPlatformServiceAuthIndexRoute:
      AuthenticatedTenantPlatformServiceAuthIndexRoute,
    AuthenticatedTenantPlatformServiceAuthUsersIdRoute:
      AuthenticatedTenantPlatformServiceAuthUsersIdRoute,
    AuthenticatedTenantPlatformServiceAuthUsersIndexRoute:
      AuthenticatedTenantPlatformServiceAuthUsersIndexRoute,
  }

const AuthenticatedTenantPlatformServiceAuthRouteRouteWithChildren =
  AuthenticatedTenantPlatformServiceAuthRouteRoute._addFileChildren(
    AuthenticatedTenantPlatformServiceAuthRouteRouteChildren,
  )

interface AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteChildren {
  AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRoute: typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRoute
}

const AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteChildren: AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteChildren =
  {
    AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRoute:
      AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdProductsRoute,
  }

const AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteWithChildren =
  AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRoute._addFileChildren(
    AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteChildren,
  )

interface AuthenticatedTenantPlatformSubsidiariesRouteChildren {
  AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRoute: typeof AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteWithChildren
  AuthenticatedTenantPlatformSubsidiariesOnboardingRoute: typeof AuthenticatedTenantPlatformSubsidiariesOnboardingRoute
  AuthenticatedTenantPlatformSubsidiariesIndexRoute: typeof AuthenticatedTenantPlatformSubsidiariesIndexRoute
}

const AuthenticatedTenantPlatformSubsidiariesRouteChildren: AuthenticatedTenantPlatformSubsidiariesRouteChildren =
  {
    AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRoute:
      AuthenticatedTenantPlatformSubsidiariesSubsidiaryIdRouteWithChildren,
    AuthenticatedTenantPlatformSubsidiariesOnboardingRoute:
      AuthenticatedTenantPlatformSubsidiariesOnboardingRoute,
    AuthenticatedTenantPlatformSubsidiariesIndexRoute:
      AuthenticatedTenantPlatformSubsidiariesIndexRoute,
  }

const AuthenticatedTenantPlatformSubsidiariesRouteWithChildren =
  AuthenticatedTenantPlatformSubsidiariesRoute._addFileChildren(
    AuthenticatedTenantPlatformSubsidiariesRouteChildren,
  )

interface AuthenticatedTenantPlatformRouteRouteChildren {
  AuthenticatedTenantPlatformServiceAuthRouteRoute: typeof AuthenticatedTenantPlatformServiceAuthRouteRouteWithChildren
  AuthenticatedTenantPlatformAuditLogsRoute: typeof AuthenticatedTenantPlatformAuditLogsRoute
  AuthenticatedTenantPlatformBatchReviewRoute: typeof AuthenticatedTenantPlatformBatchReviewRoute
  AuthenticatedTenantPlatformConnectorsRoute: typeof AuthenticatedTenantPlatformConnectorsRoute
  AuthenticatedTenantPlatformCostApprovalRoute: typeof AuthenticatedTenantPlatformCostApprovalRoute
  AuthenticatedTenantPlatformCoverageRoute: typeof AuthenticatedTenantPlatformCoverageRoute
  AuthenticatedTenantPlatformDataManagementRoute: typeof AuthenticatedTenantPlatformDataManagementRoute
  AuthenticatedTenantPlatformEnrichmentLimitRoute: typeof AuthenticatedTenantPlatformEnrichmentLimitRoute
  AuthenticatedTenantPlatformFeatureFlagsRoute: typeof AuthenticatedTenantPlatformFeatureFlagsRoute
  AuthenticatedTenantPlatformPermissionsRoute: typeof AuthenticatedTenantPlatformPermissionsRoute
  AuthenticatedTenantPlatformProductsRoute: typeof AuthenticatedTenantPlatformProductsRoute
  AuthenticatedTenantPlatformResourcesRoute: typeof AuthenticatedTenantPlatformResourcesRoute
  AuthenticatedTenantPlatformSchedulesRoute: typeof AuthenticatedTenantPlatformSchedulesRoute
  AuthenticatedTenantPlatformScreensRoute: typeof AuthenticatedTenantPlatformScreensRoute
  AuthenticatedTenantPlatformSubsidiariesRoute: typeof AuthenticatedTenantPlatformSubsidiariesRouteWithChildren
  AuthenticatedTenantPlatformUsersRoute: typeof AuthenticatedTenantPlatformUsersRoute
  AuthenticatedTenantPlatformIndexRoute: typeof AuthenticatedTenantPlatformIndexRoute
  AuthenticatedTenantPlatformTransformersTransformerIdRoute: typeof AuthenticatedTenantPlatformTransformersTransformerIdRoute
  AuthenticatedTenantPlatformTransformersIndexRoute: typeof AuthenticatedTenantPlatformTransformersIndexRoute
}

const AuthenticatedTenantPlatformRouteRouteChildren: AuthenticatedTenantPlatformRouteRouteChildren =
  {
    AuthenticatedTenantPlatformServiceAuthRouteRoute:
      AuthenticatedTenantPlatformServiceAuthRouteRouteWithChildren,
    AuthenticatedTenantPlatformAuditLogsRoute:
      AuthenticatedTenantPlatformAuditLogsRoute,
    AuthenticatedTenantPlatformBatchReviewRoute:
      AuthenticatedTenantPlatformBatchReviewRoute,
    AuthenticatedTenantPlatformConnectorsRoute:
      AuthenticatedTenantPlatformConnectorsRoute,
    AuthenticatedTenantPlatformCostApprovalRoute:
      AuthenticatedTenantPlatformCostApprovalRoute,
    AuthenticatedTenantPlatformCoverageRoute:
      AuthenticatedTenantPlatformCoverageRoute,
    AuthenticatedTenantPlatformDataManagementRoute:
      AuthenticatedTenantPlatformDataManagementRoute,
    AuthenticatedTenantPlatformEnrichmentLimitRoute:
      AuthenticatedTenantPlatformEnrichmentLimitRoute,
    AuthenticatedTenantPlatformFeatureFlagsRoute:
      AuthenticatedTenantPlatformFeatureFlagsRoute,
    AuthenticatedTenantPlatformPermissionsRoute:
      AuthenticatedTenantPlatformPermissionsRoute,
    AuthenticatedTenantPlatformProductsRoute:
      AuthenticatedTenantPlatformProductsRoute,
    AuthenticatedTenantPlatformResourcesRoute:
      AuthenticatedTenantPlatformResourcesRoute,
    AuthenticatedTenantPlatformSchedulesRoute:
      AuthenticatedTenantPlatformSchedulesRoute,
    AuthenticatedTenantPlatformScreensRoute:
      AuthenticatedTenantPlatformScreensRoute,
    AuthenticatedTenantPlatformSubsidiariesRoute:
      AuthenticatedTenantPlatformSubsidiariesRouteWithChildren,
    AuthenticatedTenantPlatformUsersRoute:
      AuthenticatedTenantPlatformUsersRoute,
    AuthenticatedTenantPlatformIndexRoute:
      AuthenticatedTenantPlatformIndexRoute,
    AuthenticatedTenantPlatformTransformersTransformerIdRoute:
      AuthenticatedTenantPlatformTransformersTransformerIdRoute,
    AuthenticatedTenantPlatformTransformersIndexRoute:
      AuthenticatedTenantPlatformTransformersIndexRoute,
  }

const AuthenticatedTenantPlatformRouteRouteWithChildren =
  AuthenticatedTenantPlatformRouteRoute._addFileChildren(
    AuthenticatedTenantPlatformRouteRouteChildren,
  )

interface AuthenticatedTenantSubsidiaryRouteRouteChildren {
  AuthenticatedTenantSubsidiaryAccessControlRoute: typeof AuthenticatedTenantSubsidiaryAccessControlRoute
  AuthenticatedTenantSubsidiaryAccessPolicyRoute: typeof AuthenticatedTenantSubsidiaryAccessPolicyRoute
  AuthenticatedTenantSubsidiaryAssetAccessRoute: typeof AuthenticatedTenantSubsidiaryAssetAccessRoute
  AuthenticatedTenantSubsidiaryDataSharingRoute: typeof AuthenticatedTenantSubsidiaryDataSharingRoute
  AuthenticatedTenantSubsidiaryProductsRoute: typeof AuthenticatedTenantSubsidiaryProductsRoute
  AuthenticatedTenantSubsidiaryRolesRoute: typeof AuthenticatedTenantSubsidiaryRolesRoute
  AuthenticatedTenantSubsidiaryScreenAccessRoute: typeof AuthenticatedTenantSubsidiaryScreenAccessRoute
  AuthenticatedTenantSubsidiarySsoRoute: typeof AuthenticatedTenantSubsidiarySsoRoute
  AuthenticatedTenantSubsidiarySubsidiariesRoute: typeof AuthenticatedTenantSubsidiarySubsidiariesRoute
  AuthenticatedTenantSubsidiarySyncScheduleRoute: typeof AuthenticatedTenantSubsidiarySyncScheduleRoute
  AuthenticatedTenantSubsidiaryUsersRoute: typeof AuthenticatedTenantSubsidiaryUsersRoute
  AuthenticatedTenantSubsidiaryIndexRoute: typeof AuthenticatedTenantSubsidiaryIndexRoute
}

const AuthenticatedTenantSubsidiaryRouteRouteChildren: AuthenticatedTenantSubsidiaryRouteRouteChildren =
  {
    AuthenticatedTenantSubsidiaryAccessControlRoute:
      AuthenticatedTenantSubsidiaryAccessControlRoute,
    AuthenticatedTenantSubsidiaryAccessPolicyRoute:
      AuthenticatedTenantSubsidiaryAccessPolicyRoute,
    AuthenticatedTenantSubsidiaryAssetAccessRoute:
      AuthenticatedTenantSubsidiaryAssetAccessRoute,
    AuthenticatedTenantSubsidiaryDataSharingRoute:
      AuthenticatedTenantSubsidiaryDataSharingRoute,
    AuthenticatedTenantSubsidiaryProductsRoute:
      AuthenticatedTenantSubsidiaryProductsRoute,
    AuthenticatedTenantSubsidiaryRolesRoute:
      AuthenticatedTenantSubsidiaryRolesRoute,
    AuthenticatedTenantSubsidiaryScreenAccessRoute:
      AuthenticatedTenantSubsidiaryScreenAccessRoute,
    AuthenticatedTenantSubsidiarySsoRoute:
      AuthenticatedTenantSubsidiarySsoRoute,
    AuthenticatedTenantSubsidiarySubsidiariesRoute:
      AuthenticatedTenantSubsidiarySubsidiariesRoute,
    AuthenticatedTenantSubsidiarySyncScheduleRoute:
      AuthenticatedTenantSubsidiarySyncScheduleRoute,
    AuthenticatedTenantSubsidiaryUsersRoute:
      AuthenticatedTenantSubsidiaryUsersRoute,
    AuthenticatedTenantSubsidiaryIndexRoute:
      AuthenticatedTenantSubsidiaryIndexRoute,
  }

const AuthenticatedTenantSubsidiaryRouteRouteWithChildren =
  AuthenticatedTenantSubsidiaryRouteRoute._addFileChildren(
    AuthenticatedTenantSubsidiaryRouteRouteChildren,
  )

interface AuthenticatedTenantTaxonomyRouteRouteChildren {
  AuthenticatedTenantTaxonomyAttributesRoute: typeof AuthenticatedTenantTaxonomyAttributesRoute
  AuthenticatedTenantTaxonomyProductsRoute: typeof AuthenticatedTenantTaxonomyProductsRoute
  AuthenticatedTenantTaxonomyUploadsRoute: typeof AuthenticatedTenantTaxonomyUploadsRoute
  AuthenticatedTenantTaxonomyVersionsRoute: typeof AuthenticatedTenantTaxonomyVersionsRoute
  AuthenticatedTenantTaxonomyIndexRoute: typeof AuthenticatedTenantTaxonomyIndexRoute
}

const AuthenticatedTenantTaxonomyRouteRouteChildren: AuthenticatedTenantTaxonomyRouteRouteChildren =
  {
    AuthenticatedTenantTaxonomyAttributesRoute:
      AuthenticatedTenantTaxonomyAttributesRoute,
    AuthenticatedTenantTaxonomyProductsRoute:
      AuthenticatedTenantTaxonomyProductsRoute,
    AuthenticatedTenantTaxonomyUploadsRoute:
      AuthenticatedTenantTaxonomyUploadsRoute,
    AuthenticatedTenantTaxonomyVersionsRoute:
      AuthenticatedTenantTaxonomyVersionsRoute,
    AuthenticatedTenantTaxonomyIndexRoute:
      AuthenticatedTenantTaxonomyIndexRoute,
  }

const AuthenticatedTenantTaxonomyRouteRouteWithChildren =
  AuthenticatedTenantTaxonomyRouteRoute._addFileChildren(
    AuthenticatedTenantTaxonomyRouteRouteChildren,
  )

interface AuthenticatedTenantUploadDeliveryRouteRouteChildren {
  AuthenticatedTenantUploadDeliverySingleRoute: typeof AuthenticatedTenantUploadDeliverySingleRoute
}

const AuthenticatedTenantUploadDeliveryRouteRouteChildren: AuthenticatedTenantUploadDeliveryRouteRouteChildren =
  {
    AuthenticatedTenantUploadDeliverySingleRoute:
      AuthenticatedTenantUploadDeliverySingleRoute,
  }

const AuthenticatedTenantUploadDeliveryRouteRouteWithChildren =
  AuthenticatedTenantUploadDeliveryRouteRoute._addFileChildren(
    AuthenticatedTenantUploadDeliveryRouteRouteChildren,
  )

interface AuthenticatedTenantWorkflowRunsRouteRouteChildren {
  AuthenticatedTenantWorkflowRunsRunIdRoute: typeof AuthenticatedTenantWorkflowRunsRunIdRoute
  AuthenticatedTenantWorkflowRunsIndexRoute: typeof AuthenticatedTenantWorkflowRunsIndexRoute
}

const AuthenticatedTenantWorkflowRunsRouteRouteChildren: AuthenticatedTenantWorkflowRunsRouteRouteChildren =
  {
    AuthenticatedTenantWorkflowRunsRunIdRoute:
      AuthenticatedTenantWorkflowRunsRunIdRoute,
    AuthenticatedTenantWorkflowRunsIndexRoute:
      AuthenticatedTenantWorkflowRunsIndexRoute,
  }

const AuthenticatedTenantWorkflowRunsRouteRouteWithChildren =
  AuthenticatedTenantWorkflowRunsRouteRoute._addFileChildren(
    AuthenticatedTenantWorkflowRunsRouteRouteChildren,
  )

interface AuthenticatedTenantItemSetupRouteChildren {
  AuthenticatedTenantItemSetupCalibrationScopeRoute: typeof AuthenticatedTenantItemSetupCalibrationScopeRoute
  AuthenticatedTenantItemSetupCatalogReviewRoute: typeof AuthenticatedTenantItemSetupCatalogReviewRoute
  AuthenticatedTenantItemSetupClientVerificationRoute: typeof AuthenticatedTenantItemSetupClientVerificationRoute
  AuthenticatedTenantItemSetupContentGenerationRoute: typeof AuthenticatedTenantItemSetupContentGenerationRoute
  AuthenticatedTenantItemSetupEnrichmentOverviewRoute: typeof AuthenticatedTenantItemSetupEnrichmentOverviewRoute
  AuthenticatedTenantItemSetupFilePreviewRoute: typeof AuthenticatedTenantItemSetupFilePreviewRoute
  AuthenticatedTenantItemSetupFullCatalogGenerationRoute: typeof AuthenticatedTenantItemSetupFullCatalogGenerationRoute
  AuthenticatedTenantItemSetupOutputFormatRoute: typeof AuthenticatedTenantItemSetupOutputFormatRoute
  AuthenticatedTenantItemSetupPatternInspectorRoute: typeof AuthenticatedTenantItemSetupPatternInspectorRoute
  AuthenticatedTenantItemSetupQualityReportRoute: typeof AuthenticatedTenantItemSetupQualityReportRoute
  AuthenticatedTenantItemSetupSftpRoute: typeof AuthenticatedTenantItemSetupSftpRoute
  AuthenticatedTenantItemSetupShopifyRoute: typeof AuthenticatedTenantItemSetupShopifyRoute
  AuthenticatedTenantItemSetupShopifyConfirmRoute: typeof AuthenticatedTenantItemSetupShopifyConfirmRoute
  AuthenticatedTenantItemSetupSourcePriorityRoute: typeof AuthenticatedTenantItemSetupSourcePriorityRoute
  AuthenticatedTenantItemSetupTaxonomyRoute: typeof AuthenticatedTenantItemSetupTaxonomyRoute
  AuthenticatedTenantItemSetupTaxonomyReviewRoute: typeof AuthenticatedTenantItemSetupTaxonomyReviewRoute
  AuthenticatedTenantItemSetupVerifyRoute: typeof AuthenticatedTenantItemSetupVerifyRoute
  AuthenticatedTenantItemSetupIndexRoute: typeof AuthenticatedTenantItemSetupIndexRoute
}

const AuthenticatedTenantItemSetupRouteChildren: AuthenticatedTenantItemSetupRouteChildren =
  {
    AuthenticatedTenantItemSetupCalibrationScopeRoute:
      AuthenticatedTenantItemSetupCalibrationScopeRoute,
    AuthenticatedTenantItemSetupCatalogReviewRoute:
      AuthenticatedTenantItemSetupCatalogReviewRoute,
    AuthenticatedTenantItemSetupClientVerificationRoute:
      AuthenticatedTenantItemSetupClientVerificationRoute,
    AuthenticatedTenantItemSetupContentGenerationRoute:
      AuthenticatedTenantItemSetupContentGenerationRoute,
    AuthenticatedTenantItemSetupEnrichmentOverviewRoute:
      AuthenticatedTenantItemSetupEnrichmentOverviewRoute,
    AuthenticatedTenantItemSetupFilePreviewRoute:
      AuthenticatedTenantItemSetupFilePreviewRoute,
    AuthenticatedTenantItemSetupFullCatalogGenerationRoute:
      AuthenticatedTenantItemSetupFullCatalogGenerationRoute,
    AuthenticatedTenantItemSetupOutputFormatRoute:
      AuthenticatedTenantItemSetupOutputFormatRoute,
    AuthenticatedTenantItemSetupPatternInspectorRoute:
      AuthenticatedTenantItemSetupPatternInspectorRoute,
    AuthenticatedTenantItemSetupQualityReportRoute:
      AuthenticatedTenantItemSetupQualityReportRoute,
    AuthenticatedTenantItemSetupSftpRoute:
      AuthenticatedTenantItemSetupSftpRoute,
    AuthenticatedTenantItemSetupShopifyRoute:
      AuthenticatedTenantItemSetupShopifyRoute,
    AuthenticatedTenantItemSetupShopifyConfirmRoute:
      AuthenticatedTenantItemSetupShopifyConfirmRoute,
    AuthenticatedTenantItemSetupSourcePriorityRoute:
      AuthenticatedTenantItemSetupSourcePriorityRoute,
    AuthenticatedTenantItemSetupTaxonomyRoute:
      AuthenticatedTenantItemSetupTaxonomyRoute,
    AuthenticatedTenantItemSetupTaxonomyReviewRoute:
      AuthenticatedTenantItemSetupTaxonomyReviewRoute,
    AuthenticatedTenantItemSetupVerifyRoute:
      AuthenticatedTenantItemSetupVerifyRoute,
    AuthenticatedTenantItemSetupIndexRoute:
      AuthenticatedTenantItemSetupIndexRoute,
  }

const AuthenticatedTenantItemSetupRouteWithChildren =
  AuthenticatedTenantItemSetupRoute._addFileChildren(
    AuthenticatedTenantItemSetupRouteChildren,
  )

interface AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteChildren {
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRoute
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRoute
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRoute
}

const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteChildren: AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteChildren =
  {
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsConfirmationRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsSelectAccountRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsIndexRoute,
  }

const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteWithChildren =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute._addFileChildren(
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteChildren,
  )

interface AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteChildren {
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRoute
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRoute
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRoute
}

const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteChildren: AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteChildren =
  {
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsDataPreviewRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsPickPropertyRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsIndexRoute,
  }

const AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteWithChildren =
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute._addFileChildren(
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteChildren,
  )

interface AuthenticatedTenantOnboardingIntegrationGoogleRouteChildren {
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteWithChildren
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteWithChildren
  AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRoute
  AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRoute
  AuthenticatedTenantOnboardingIntegrationGoogleSftpRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleSftpRoute
  AuthenticatedTenantOnboardingIntegrationGoogleShopifyRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleShopifyRoute
  AuthenticatedTenantOnboardingIntegrationGoogleIndexRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleIndexRoute
  AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRoute
  AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRoute
}

const AuthenticatedTenantOnboardingIntegrationGoogleRouteChildren: AuthenticatedTenantOnboardingIntegrationGoogleRouteChildren =
  {
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleGoogleAdsRouteWithChildren,
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleGoogleAnalyticsRouteWithChildren,
    AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleGoogleMerchantCenterRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleImportCatalogRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleSftpRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleSftpRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleShopifyRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleShopifyRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleIndexRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleIndexRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsExtractionRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleAdobeAnalyticsIndexRoute,
  }

const AuthenticatedTenantOnboardingIntegrationGoogleRouteWithChildren =
  AuthenticatedTenantOnboardingIntegrationGoogleRoute._addFileChildren(
    AuthenticatedTenantOnboardingIntegrationGoogleRouteChildren,
  )

interface AuthenticatedTenantOnboardingIntegrationMetaRouteChildren {
  AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRoute
  AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRoute
  AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRoute
  AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRoute
  AuthenticatedTenantOnboardingIntegrationMetaSftpRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaSftpRoute
  AuthenticatedTenantOnboardingIntegrationMetaIndexRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaIndexRoute
}

const AuthenticatedTenantOnboardingIntegrationMetaRouteChildren: AuthenticatedTenantOnboardingIntegrationMetaRouteChildren =
  {
    AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRoute:
      AuthenticatedTenantOnboardingIntegrationMetaCompleteImportRoute,
    AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRoute:
      AuthenticatedTenantOnboardingIntegrationMetaImportCatalogRoute,
    AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRoute:
      AuthenticatedTenantOnboardingIntegrationMetaMetaCommerceManagerRoute,
    AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRoute:
      AuthenticatedTenantOnboardingIntegrationMetaProductOverviewRoute,
    AuthenticatedTenantOnboardingIntegrationMetaSftpRoute:
      AuthenticatedTenantOnboardingIntegrationMetaSftpRoute,
    AuthenticatedTenantOnboardingIntegrationMetaIndexRoute:
      AuthenticatedTenantOnboardingIntegrationMetaIndexRoute,
  }

const AuthenticatedTenantOnboardingIntegrationMetaRouteWithChildren =
  AuthenticatedTenantOnboardingIntegrationMetaRoute._addFileChildren(
    AuthenticatedTenantOnboardingIntegrationMetaRouteChildren,
  )

interface AuthenticatedTenantOnboardingRouteChildren {
  AuthenticatedTenantOnboardingCompleteImportRoute: typeof AuthenticatedTenantOnboardingCompleteImportRoute
  AuthenticatedTenantOnboardingOnsiteRoute: typeof AuthenticatedTenantOnboardingOnsiteRoute
  AuthenticatedTenantOnboardingPaidAdsRoute: typeof AuthenticatedTenantOnboardingPaidAdsRoute
  AuthenticatedTenantOnboardingProductOverviewRoute: typeof AuthenticatedTenantOnboardingProductOverviewRoute
  AuthenticatedTenantOnboardingIndexRoute: typeof AuthenticatedTenantOnboardingIndexRoute
  AuthenticatedTenantOnboardingIntegrationGoogleRoute: typeof AuthenticatedTenantOnboardingIntegrationGoogleRouteWithChildren
  AuthenticatedTenantOnboardingIntegrationMetaRoute: typeof AuthenticatedTenantOnboardingIntegrationMetaRouteWithChildren
}

const AuthenticatedTenantOnboardingRouteChildren: AuthenticatedTenantOnboardingRouteChildren =
  {
    AuthenticatedTenantOnboardingCompleteImportRoute:
      AuthenticatedTenantOnboardingCompleteImportRoute,
    AuthenticatedTenantOnboardingOnsiteRoute:
      AuthenticatedTenantOnboardingOnsiteRoute,
    AuthenticatedTenantOnboardingPaidAdsRoute:
      AuthenticatedTenantOnboardingPaidAdsRoute,
    AuthenticatedTenantOnboardingProductOverviewRoute:
      AuthenticatedTenantOnboardingProductOverviewRoute,
    AuthenticatedTenantOnboardingIndexRoute:
      AuthenticatedTenantOnboardingIndexRoute,
    AuthenticatedTenantOnboardingIntegrationGoogleRoute:
      AuthenticatedTenantOnboardingIntegrationGoogleRouteWithChildren,
    AuthenticatedTenantOnboardingIntegrationMetaRoute:
      AuthenticatedTenantOnboardingIntegrationMetaRouteWithChildren,
  }

const AuthenticatedTenantOnboardingRouteWithChildren =
  AuthenticatedTenantOnboardingRoute._addFileChildren(
    AuthenticatedTenantOnboardingRouteChildren,
  )

interface AuthenticatedTenantTrialPlatformEnrichmentRouteChildren {
  AuthenticatedTenantTrialPlatformEnrichmentIdRoute: typeof AuthenticatedTenantTrialPlatformEnrichmentIdRoute
  AuthenticatedTenantTrialPlatformEnrichmentIndexRoute: typeof AuthenticatedTenantTrialPlatformEnrichmentIndexRoute
}

const AuthenticatedTenantTrialPlatformEnrichmentRouteChildren: AuthenticatedTenantTrialPlatformEnrichmentRouteChildren =
  {
    AuthenticatedTenantTrialPlatformEnrichmentIdRoute:
      AuthenticatedTenantTrialPlatformEnrichmentIdRoute,
    AuthenticatedTenantTrialPlatformEnrichmentIndexRoute:
      AuthenticatedTenantTrialPlatformEnrichmentIndexRoute,
  }

const AuthenticatedTenantTrialPlatformEnrichmentRouteWithChildren =
  AuthenticatedTenantTrialPlatformEnrichmentRoute._addFileChildren(
    AuthenticatedTenantTrialPlatformEnrichmentRouteChildren,
  )

interface AuthenticatedTenantTrialPlatformRouteChildren {
  AuthenticatedTenantTrialPlatformCreateRoute: typeof AuthenticatedTenantTrialPlatformCreateRoute
  AuthenticatedTenantTrialPlatformEnrichmentRoute: typeof AuthenticatedTenantTrialPlatformEnrichmentRouteWithChildren
}

const AuthenticatedTenantTrialPlatformRouteChildren: AuthenticatedTenantTrialPlatformRouteChildren =
  {
    AuthenticatedTenantTrialPlatformCreateRoute:
      AuthenticatedTenantTrialPlatformCreateRoute,
    AuthenticatedTenantTrialPlatformEnrichmentRoute:
      AuthenticatedTenantTrialPlatformEnrichmentRouteWithChildren,
  }

const AuthenticatedTenantTrialPlatformRouteWithChildren =
  AuthenticatedTenantTrialPlatformRoute._addFileChildren(
    AuthenticatedTenantTrialPlatformRouteChildren,
  )

interface AuthenticatedTenantTrialRouteChildren {
  AuthenticatedTenantTrialPlatformRoute: typeof AuthenticatedTenantTrialPlatformRouteWithChildren
}

const AuthenticatedTenantTrialRouteChildren: AuthenticatedTenantTrialRouteChildren =
  {
    AuthenticatedTenantTrialPlatformRoute:
      AuthenticatedTenantTrialPlatformRouteWithChildren,
  }

const AuthenticatedTenantTrialRouteWithChildren =
  AuthenticatedTenantTrialRoute._addFileChildren(
    AuthenticatedTenantTrialRouteChildren,
  )

interface AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteChildren {
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRoute
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRoute
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRoute
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRoute
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRoute
}

const AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteChildren: AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteChildren =
  {
    AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRoute:
      AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliveryRoute,
    AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRoute:
      AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdFullRoute,
    AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRoute:
      AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdOverviewRoute,
    AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRoute:
      AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdReviewRoute,
    AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRoute:
      AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdIndexRoute,
  }

const AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteWithChildren =
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute._addFileChildren(
    AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteChildren,
  )

interface AuthenticatedTenantEnrichmentsGoogleRouteChildren {
  AuthenticatedTenantEnrichmentsGoogleProductSelectionRoute: typeof AuthenticatedTenantEnrichmentsGoogleProductSelectionRoute
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteWithChildren
  AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRoute: typeof AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRoute
}

const AuthenticatedTenantEnrichmentsGoogleRouteChildren: AuthenticatedTenantEnrichmentsGoogleRouteChildren =
  {
    AuthenticatedTenantEnrichmentsGoogleProductSelectionRoute:
      AuthenticatedTenantEnrichmentsGoogleProductSelectionRoute,
    AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRoute:
      AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdRouteWithChildren,
    AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRoute:
      AuthenticatedTenantEnrichmentsGoogleContentEnrichmentBatchIdDeliverRoute,
  }

const AuthenticatedTenantEnrichmentsGoogleRouteWithChildren =
  AuthenticatedTenantEnrichmentsGoogleRoute._addFileChildren(
    AuthenticatedTenantEnrichmentsGoogleRouteChildren,
  )

interface AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteChildren {
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRoute
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRoute
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRoute
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRoute
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRoute
}

const AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteChildren: AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteChildren =
  {
    AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRoute:
      AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliveryRoute,
    AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRoute:
      AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdFullRoute,
    AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRoute:
      AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdOverviewRoute,
    AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRoute:
      AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdReviewRoute,
    AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRoute:
      AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdIndexRoute,
  }

const AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteWithChildren =
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute._addFileChildren(
    AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteChildren,
  )

interface AuthenticatedTenantEnrichmentsMetaRouteChildren {
  AuthenticatedTenantEnrichmentsMetaProductSelectionRoute: typeof AuthenticatedTenantEnrichmentsMetaProductSelectionRoute
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteWithChildren
  AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRoute: typeof AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRoute
}

const AuthenticatedTenantEnrichmentsMetaRouteChildren: AuthenticatedTenantEnrichmentsMetaRouteChildren =
  {
    AuthenticatedTenantEnrichmentsMetaProductSelectionRoute:
      AuthenticatedTenantEnrichmentsMetaProductSelectionRoute,
    AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRoute:
      AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdRouteWithChildren,
    AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRoute:
      AuthenticatedTenantEnrichmentsMetaContentEnrichmentBatchIdDeliverRoute,
  }

const AuthenticatedTenantEnrichmentsMetaRouteWithChildren =
  AuthenticatedTenantEnrichmentsMetaRoute._addFileChildren(
    AuthenticatedTenantEnrichmentsMetaRouteChildren,
  )

interface AuthenticatedTenantExperimentsCreateRouteChildren {
  AuthenticatedTenantExperimentsCreateConfigureRoute: typeof AuthenticatedTenantExperimentsCreateConfigureRoute
  AuthenticatedTenantExperimentsCreateInfoRoute: typeof AuthenticatedTenantExperimentsCreateInfoRoute
  AuthenticatedTenantExperimentsCreateIndexRoute: typeof AuthenticatedTenantExperimentsCreateIndexRoute
}

const AuthenticatedTenantExperimentsCreateRouteChildren: AuthenticatedTenantExperimentsCreateRouteChildren =
  {
    AuthenticatedTenantExperimentsCreateConfigureRoute:
      AuthenticatedTenantExperimentsCreateConfigureRoute,
    AuthenticatedTenantExperimentsCreateInfoRoute:
      AuthenticatedTenantExperimentsCreateInfoRoute,
    AuthenticatedTenantExperimentsCreateIndexRoute:
      AuthenticatedTenantExperimentsCreateIndexRoute,
  }

const AuthenticatedTenantExperimentsCreateRouteWithChildren =
  AuthenticatedTenantExperimentsCreateRoute._addFileChildren(
    AuthenticatedTenantExperimentsCreateRouteChildren,
  )

interface AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteChildren {
  AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRoute
  AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRoute
  AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRoute
  AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRoute
  AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRoute
  AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRoute
}

const AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteChildren: AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteChildren =
  {
    AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRoute:
      AuthenticatedTenantExperimentsExpIdContentEnrichmentDeliveryRoute,
    AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRoute:
      AuthenticatedTenantExperimentsExpIdContentEnrichmentFullRoute,
    AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRoute:
      AuthenticatedTenantExperimentsExpIdContentEnrichmentGroupsRoute,
    AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRoute:
      AuthenticatedTenantExperimentsExpIdContentEnrichmentOverviewRoute,
    AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRoute:
      AuthenticatedTenantExperimentsExpIdContentEnrichmentReviewRoute,
    AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRoute:
      AuthenticatedTenantExperimentsExpIdContentEnrichmentIndexRoute,
  }

const AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteWithChildren =
  AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute._addFileChildren(
    AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteChildren,
  )

interface AuthenticatedTenantRouteChildren {
  AuthenticatedTenantAiPerformanceRouteRoute: typeof AuthenticatedTenantAiPerformanceRouteRouteWithChildren
  AuthenticatedTenantCatalogEnrichmentRouteRoute: typeof AuthenticatedTenantCatalogEnrichmentRouteRouteWithChildren
  AuthenticatedTenantCatalogV2RouteRoute: typeof AuthenticatedTenantCatalogV2RouteRouteWithChildren
  AuthenticatedTenantConfigurationRouteRoute: typeof AuthenticatedTenantConfigurationRouteRouteWithChildren
  AuthenticatedTenantContentRouteRoute: typeof AuthenticatedTenantContentRouteRouteWithChildren
  AuthenticatedTenantDeliveriesRouteRoute: typeof AuthenticatedTenantDeliveriesRouteRouteWithChildren
  AuthenticatedTenantExplorerRouteRoute: typeof AuthenticatedTenantExplorerRouteRouteWithChildren
  AuthenticatedTenantFeedAuditRouteRoute: typeof AuthenticatedTenantFeedAuditRouteRouteWithChildren
  AuthenticatedTenantIntegrationsRouteRoute: typeof AuthenticatedTenantIntegrationsRouteRouteWithChildren
  AuthenticatedTenantPlatformRouteRoute: typeof AuthenticatedTenantPlatformRouteRouteWithChildren
  AuthenticatedTenantSubsidiaryRouteRoute: typeof AuthenticatedTenantSubsidiaryRouteRouteWithChildren
  AuthenticatedTenantTaxonomyRouteRoute: typeof AuthenticatedTenantTaxonomyRouteRouteWithChildren
  AuthenticatedTenantUploadDeliveryRouteRoute: typeof AuthenticatedTenantUploadDeliveryRouteRouteWithChildren
  AuthenticatedTenantWorkflowRunsRouteRoute: typeof AuthenticatedTenantWorkflowRunsRouteRouteWithChildren
  AuthenticatedTenantAccessDeniedRoute: typeof AuthenticatedTenantAccessDeniedRoute
  AuthenticatedTenantCatalogManagerRoute: typeof AuthenticatedTenantCatalogManagerRoute
  AuthenticatedTenantCostApprovalsRoute: typeof AuthenticatedTenantCostApprovalsRoute
  AuthenticatedTenantCoverageRoute: typeof AuthenticatedTenantCoverageRoute
  AuthenticatedTenantDashboardRoute: typeof AuthenticatedTenantDashboardRoute
  AuthenticatedTenantHistoryRoute: typeof AuthenticatedTenantHistoryRoute
  AuthenticatedTenantHomeRoute: typeof AuthenticatedTenantHomeRoute
  AuthenticatedTenantItemSetupRoute: typeof AuthenticatedTenantItemSetupRouteWithChildren
  AuthenticatedTenantLilyAgentRoute: typeof AuthenticatedTenantLilyAgentRoute
  AuthenticatedTenantNotificationRoute: typeof AuthenticatedTenantNotificationRoute
  AuthenticatedTenantOnboardingRoute: typeof AuthenticatedTenantOnboardingRouteWithChildren
  AuthenticatedTenantProductNotEnrolledRoute: typeof AuthenticatedTenantProductNotEnrolledRoute
  AuthenticatedTenantSchedulesRoute: typeof AuthenticatedTenantSchedulesRoute
  AuthenticatedTenantSettingsRoute: typeof AuthenticatedTenantSettingsRoute
  AuthenticatedTenantTrialRoute: typeof AuthenticatedTenantTrialRouteWithChildren
  AuthenticatedTenantCatalogOperationsBatchIdRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdRoute
  AuthenticatedTenantCatalogOperationsProductsNeedAttentionRoute: typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionRoute
  AuthenticatedTenantCostApprovalsWorkflowIdRoute: typeof AuthenticatedTenantCostApprovalsWorkflowIdRoute
  AuthenticatedTenantEnrichmentsGoogleRoute: typeof AuthenticatedTenantEnrichmentsGoogleRouteWithChildren
  AuthenticatedTenantEnrichmentsMetaRoute: typeof AuthenticatedTenantEnrichmentsMetaRouteWithChildren
  AuthenticatedTenantExperimentsIdRoute: typeof AuthenticatedTenantExperimentsIdRoute
  AuthenticatedTenantExperimentsCreateRoute: typeof AuthenticatedTenantExperimentsCreateRouteWithChildren
  AuthenticatedTenantExportsSourceWorkflowIdRoute: typeof AuthenticatedTenantExportsSourceWorkflowIdRoute
  AuthenticatedTenantIntegrationsSharingRoute: typeof AuthenticatedTenantIntegrationsSharingRoute
  AuthenticatedTenantPipelineRunsRunIdRoute: typeof AuthenticatedTenantPipelineRunsRunIdRoute
  AuthenticatedTenantPipelinesPipelineIdRoute: typeof AuthenticatedTenantPipelinesPipelineIdRoute
  AuthenticatedTenantSettingsNotificationRoute: typeof AuthenticatedTenantSettingsNotificationRoute
  AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRoute: typeof AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRoute
  AuthenticatedTenantSubsidiaryPreferencesConstraintsRoute: typeof AuthenticatedTenantSubsidiaryPreferencesConstraintsRoute
  AuthenticatedTenantCatalogOperationsIndexRoute: typeof AuthenticatedTenantCatalogOperationsIndexRoute
  AuthenticatedTenantExperimentsIndexRoute: typeof AuthenticatedTenantExperimentsIndexRoute
  AuthenticatedTenantProductCatalogIndexRoute: typeof AuthenticatedTenantProductCatalogIndexRoute
  AuthenticatedTenantSubsidiaryPreferencesIndexRoute: typeof AuthenticatedTenantSubsidiaryPreferencesIndexRoute
  AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRoute
  AuthenticatedTenantCatalogOperationsBatchIdDeliverRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdDeliverRoute
  AuthenticatedTenantCatalogOperationsBatchIdProductsRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdProductsRoute
  AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRoute: typeof AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRoute
  AuthenticatedTenantContentCatalogJobIdRoute: typeof AuthenticatedTenantContentCatalogJobIdRoute
  AuthenticatedTenantContentCatalogNewRoute: typeof AuthenticatedTenantContentCatalogNewRoute
  AuthenticatedTenantContentQcRunIdRoute: typeof AuthenticatedTenantContentQcRunIdRoute
  AuthenticatedTenantContentQcNewRoute: typeof AuthenticatedTenantContentQcNewRoute
  AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute: typeof AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteWithChildren
  AuthenticatedTenantExportsCatalogNewRoute: typeof AuthenticatedTenantExportsCatalogNewRoute
  AuthenticatedTenantOauthGoogleAdsCallbackRoute: typeof AuthenticatedTenantOauthGoogleAdsCallbackRoute
  AuthenticatedTenantExportsCatalogIndexRoute: typeof AuthenticatedTenantExportsCatalogIndexRoute
  AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRoute: typeof AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRoute
  AuthenticatedTenantExportsCatalogExportsExportIdRoute: typeof AuthenticatedTenantExportsCatalogExportsExportIdRoute
  AuthenticatedTenantExportsCatalogProfilesProfileIdRoute: typeof AuthenticatedTenantExportsCatalogProfilesProfileIdRoute
  AuthenticatedTenantExportsCatalogRunsRunIdRoute: typeof AuthenticatedTenantExportsCatalogRunsRunIdRoute
  AuthenticatedTenantContentRunsRunIdProductsProductIdRoute: typeof AuthenticatedTenantContentRunsRunIdProductsProductIdRoute
}

const AuthenticatedTenantRouteChildren: AuthenticatedTenantRouteChildren = {
  AuthenticatedTenantAiPerformanceRouteRoute:
    AuthenticatedTenantAiPerformanceRouteRouteWithChildren,
  AuthenticatedTenantCatalogEnrichmentRouteRoute:
    AuthenticatedTenantCatalogEnrichmentRouteRouteWithChildren,
  AuthenticatedTenantCatalogV2RouteRoute:
    AuthenticatedTenantCatalogV2RouteRouteWithChildren,
  AuthenticatedTenantConfigurationRouteRoute:
    AuthenticatedTenantConfigurationRouteRouteWithChildren,
  AuthenticatedTenantContentRouteRoute:
    AuthenticatedTenantContentRouteRouteWithChildren,
  AuthenticatedTenantDeliveriesRouteRoute:
    AuthenticatedTenantDeliveriesRouteRouteWithChildren,
  AuthenticatedTenantExplorerRouteRoute:
    AuthenticatedTenantExplorerRouteRouteWithChildren,
  AuthenticatedTenantFeedAuditRouteRoute:
    AuthenticatedTenantFeedAuditRouteRouteWithChildren,
  AuthenticatedTenantIntegrationsRouteRoute:
    AuthenticatedTenantIntegrationsRouteRouteWithChildren,
  AuthenticatedTenantPlatformRouteRoute:
    AuthenticatedTenantPlatformRouteRouteWithChildren,
  AuthenticatedTenantSubsidiaryRouteRoute:
    AuthenticatedTenantSubsidiaryRouteRouteWithChildren,
  AuthenticatedTenantTaxonomyRouteRoute:
    AuthenticatedTenantTaxonomyRouteRouteWithChildren,
  AuthenticatedTenantUploadDeliveryRouteRoute:
    AuthenticatedTenantUploadDeliveryRouteRouteWithChildren,
  AuthenticatedTenantWorkflowRunsRouteRoute:
    AuthenticatedTenantWorkflowRunsRouteRouteWithChildren,
  AuthenticatedTenantAccessDeniedRoute: AuthenticatedTenantAccessDeniedRoute,
  AuthenticatedTenantCatalogManagerRoute:
    AuthenticatedTenantCatalogManagerRoute,
  AuthenticatedTenantCostApprovalsRoute: AuthenticatedTenantCostApprovalsRoute,
  AuthenticatedTenantCoverageRoute: AuthenticatedTenantCoverageRoute,
  AuthenticatedTenantDashboardRoute: AuthenticatedTenantDashboardRoute,
  AuthenticatedTenantHistoryRoute: AuthenticatedTenantHistoryRoute,
  AuthenticatedTenantHomeRoute: AuthenticatedTenantHomeRoute,
  AuthenticatedTenantItemSetupRoute:
    AuthenticatedTenantItemSetupRouteWithChildren,
  AuthenticatedTenantLilyAgentRoute: AuthenticatedTenantLilyAgentRoute,
  AuthenticatedTenantNotificationRoute: AuthenticatedTenantNotificationRoute,
  AuthenticatedTenantOnboardingRoute:
    AuthenticatedTenantOnboardingRouteWithChildren,
  AuthenticatedTenantProductNotEnrolledRoute:
    AuthenticatedTenantProductNotEnrolledRoute,
  AuthenticatedTenantSchedulesRoute: AuthenticatedTenantSchedulesRoute,
  AuthenticatedTenantSettingsRoute: AuthenticatedTenantSettingsRoute,
  AuthenticatedTenantTrialRoute: AuthenticatedTenantTrialRouteWithChildren,
  AuthenticatedTenantCatalogOperationsBatchIdRoute:
    AuthenticatedTenantCatalogOperationsBatchIdRoute,
  AuthenticatedTenantCatalogOperationsProductsNeedAttentionRoute:
    AuthenticatedTenantCatalogOperationsProductsNeedAttentionRoute,
  AuthenticatedTenantCostApprovalsWorkflowIdRoute:
    AuthenticatedTenantCostApprovalsWorkflowIdRoute,
  AuthenticatedTenantEnrichmentsGoogleRoute:
    AuthenticatedTenantEnrichmentsGoogleRouteWithChildren,
  AuthenticatedTenantEnrichmentsMetaRoute:
    AuthenticatedTenantEnrichmentsMetaRouteWithChildren,
  AuthenticatedTenantExperimentsIdRoute: AuthenticatedTenantExperimentsIdRoute,
  AuthenticatedTenantExperimentsCreateRoute:
    AuthenticatedTenantExperimentsCreateRouteWithChildren,
  AuthenticatedTenantExportsSourceWorkflowIdRoute:
    AuthenticatedTenantExportsSourceWorkflowIdRoute,
  AuthenticatedTenantIntegrationsSharingRoute:
    AuthenticatedTenantIntegrationsSharingRoute,
  AuthenticatedTenantPipelineRunsRunIdRoute:
    AuthenticatedTenantPipelineRunsRunIdRoute,
  AuthenticatedTenantPipelinesPipelineIdRoute:
    AuthenticatedTenantPipelinesPipelineIdRoute,
  AuthenticatedTenantSettingsNotificationRoute:
    AuthenticatedTenantSettingsNotificationRoute,
  AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRoute:
    AuthenticatedTenantSubsidiaryPreferencesBrandPreferencesRoute,
  AuthenticatedTenantSubsidiaryPreferencesConstraintsRoute:
    AuthenticatedTenantSubsidiaryPreferencesConstraintsRoute,
  AuthenticatedTenantCatalogOperationsIndexRoute:
    AuthenticatedTenantCatalogOperationsIndexRoute,
  AuthenticatedTenantExperimentsIndexRoute:
    AuthenticatedTenantExperimentsIndexRoute,
  AuthenticatedTenantProductCatalogIndexRoute:
    AuthenticatedTenantProductCatalogIndexRoute,
  AuthenticatedTenantSubsidiaryPreferencesIndexRoute:
    AuthenticatedTenantSubsidiaryPreferencesIndexRoute,
  AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRoute:
    AuthenticatedTenantCatalogOperationsBatchIdCompareDeliveryRoute,
  AuthenticatedTenantCatalogOperationsBatchIdDeliverRoute:
    AuthenticatedTenantCatalogOperationsBatchIdDeliverRoute,
  AuthenticatedTenantCatalogOperationsBatchIdProductsRoute:
    AuthenticatedTenantCatalogOperationsBatchIdProductsRoute,
  AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRoute:
    AuthenticatedTenantCatalogOperationsProductsNeedAttentionProductIdRoute,
  AuthenticatedTenantContentCatalogJobIdRoute:
    AuthenticatedTenantContentCatalogJobIdRoute,
  AuthenticatedTenantContentCatalogNewRoute:
    AuthenticatedTenantContentCatalogNewRoute,
  AuthenticatedTenantContentQcRunIdRoute:
    AuthenticatedTenantContentQcRunIdRoute,
  AuthenticatedTenantContentQcNewRoute: AuthenticatedTenantContentQcNewRoute,
  AuthenticatedTenantExperimentsExpIdContentEnrichmentRoute:
    AuthenticatedTenantExperimentsExpIdContentEnrichmentRouteWithChildren,
  AuthenticatedTenantExportsCatalogNewRoute:
    AuthenticatedTenantExportsCatalogNewRoute,
  AuthenticatedTenantOauthGoogleAdsCallbackRoute:
    AuthenticatedTenantOauthGoogleAdsCallbackRoute,
  AuthenticatedTenantExportsCatalogIndexRoute:
    AuthenticatedTenantExportsCatalogIndexRoute,
  AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRoute:
    AuthenticatedTenantCatalogOperationsBatchIdProductsProductIdRoute,
  AuthenticatedTenantExportsCatalogExportsExportIdRoute:
    AuthenticatedTenantExportsCatalogExportsExportIdRoute,
  AuthenticatedTenantExportsCatalogProfilesProfileIdRoute:
    AuthenticatedTenantExportsCatalogProfilesProfileIdRoute,
  AuthenticatedTenantExportsCatalogRunsRunIdRoute:
    AuthenticatedTenantExportsCatalogRunsRunIdRoute,
  AuthenticatedTenantContentRunsRunIdProductsProductIdRoute:
    AuthenticatedTenantContentRunsRunIdProductsProductIdRoute,
}

const AuthenticatedTenantRouteWithChildren =
  AuthenticatedTenantRoute._addFileChildren(AuthenticatedTenantRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedTenantRoute: typeof AuthenticatedTenantRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedTenantRoute: AuthenticatedTenantRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthProviderCallbackRoute: AuthProviderCallbackRoute,
  ConnectorTokenDoneRoute: ConnectorTokenDoneRoute,
  ConnectorTokenSelectRoute: ConnectorTokenSelectRoute,
  ConnectorTokenIndexRoute: ConnectorTokenIndexRoute,
  PublicOauthGoogleAdsCallbackRoute: PublicOauthGoogleAdsCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
